import { RISK_TRANSACTIONS } from 'components/GenerateReportModal/constants';
import { OCC_ANALYTICS, OFFERS_ANALYTICS } from 'constants/common';
import { PATH_DROPDOWN_OPTIONS } from 'containers/RateLimitsV2/constants';
import moment from 'moment';

import xsLogoSmall from 'images/xs_logo_small.svg';

export const RESTART_ON_REMOUNT = '@@saga-injector/restart-on-remount';
export const DAEMON = '@@saga-injector/daemon';
export const ONCE_TILL_UNMOUNT = '@@saga-injector/once-till-unmount';

export const TEST = 'test';

export const PROD = 'prod';

export const PROD_TEST = 'prod-test';

const envObj = process.env;

export const isNotProd = envObj.NODE_ENV !== PROD;

export const ENV_CONFIG = {
  [TEST]: { displayText: 'Test', key: TEST },
  [PROD]: { displayText: 'Prod', key: PROD },
};

export const SEARCH_BULK_UPLOAD_URL = {
  url: '/common/dashboard/bulk-upload/search',
  method: 'GET',
};

export const DOWNLOAD_BATCH_FILE_URL = {
  url: '/common/dashboard/bulk-upload/file/$id$',
  method: 'GET',
};

export const VALIDATE_BATCH_FILE_URL = {
  url: '/common/dashboard/bulk-upload/validate',
  method: 'POST',
};

export const PROCESS_BATCH_FILE_URL = {
  url: '/common/dashboard/bulk-upload/process',
  method: 'POST',
};

export const TEST_WEBHOOK_URL = {
  url: '/pg/notification/webhook/test',
  method: 'POST',
};

export const CHANGE_PG_DASHBOARD_CONFIG_URL = {
  url: '/common/config/pg',
  method: 'POST',
};

export const GET_PAGE_PREFERENCE_URL = {
  url: '/pg/page-preference',
  method: 'GET',
};

export const UPDATE_MODES_LIMIT_URL = {
  url: '/epos/merchant/role',
  method: 'PATCH',
};

export const GET_SETTLEMENT_HOLIDAYS_URL = {
  url: '/pg/settlements/next-date',
  method: 'GET',
};

export const GET_MERCHANT_LOGO_URL = {
  url: '/pg/merchant-logo',
  method: 'GET',
};

export const GET_UNSETTLED_AMOUNT_URL = {
  url: '/pg/settlements/unsettled-amount',
  method: 'GET',
};

export const GET_IMPORT_UNSETTLED_AMOUNT_URL = {
  url: '/imports/settlement-details/unsettled-amount',
  method: 'GET',
};

export const GET_NOTIFICATION_CHANNEL_DETAILS_URL = {
  url: '/pg/notification-details',
  method: 'GET',
};

export const ADD_NOTIFICATION_CHANNEL_DETAILS_URL = {
  url: '/pg/notification-details',
  method: 'POST',
};

export const UPDATE_NOTIFICATION_CHANNEL_DETAILS_URL = {
  url: '/pg/notification-details',
  method: 'PUT',
};

export const GET_MERCHANT_CONFIG_URL = {
  url: '/pg/pggrowth/config',
  method: 'GET',
};

export const UPDATE_MERCHANT_CONFIG_URL = {
  url: '/pg/pggrowth/config',
  method: 'PUT',
};

export const FETCH_API_KEYS_URL = {
  url: '/pg/merchantkey',
  method: 'GET',
};

export const GET_UNIFICATION_ONBOARDING_URL = {
  url: '/pg/unification-onboarding',
  method: 'GET',
};

export const VALIDATE_TOKEN = {
  url: '/common/validate/token',
  method: 'GET',
};

export const GET_MERCHANT_OWNER_DETAILS = {
  url: '/common/user-details/get',
  method: 'GET',
};

export const GET_MERCHANT_ALIAS_DETAILS = {
  url: '/common/alias/aliasId',
  method: 'GET',
};

export const GET_ECOM360_PRODUCT_STATUS_URL = {
  url: '/pg/product/onboard/status',
  method: 'PUT',
};

export const PRODUCT = {
  PAYMENT_GATEWAY: 'PG',
  PAYMENT_LINK: 'Payment Links',
  PAYMENT_FORM: 'Payment Forms',
  SUBSCRIPTION: 'Subscription',
  PAYOUT: 'Payouts',
  CASHGRAM: 'Cashgram',
  GLOBAL_COLLECTION: 'Global Collections',
  BANKING_AS_SERVICE: 'Banking as a Service',
  CROSS_BORDER: 'Cross Border',
  LENDING_AS_SERVICE: 'Lending as a Service',
  VERIFICATION_SUITES: 'Verification Suites',
  PAYMENT_BUTTON: 'Payment Button',
  CUSTOMERS: 'Customers',
  BILLER: 'Biller',
  BBPS_COU: 'BBPS COU',
  SOFT_POS: 'softPOS',
  ROUTER: 'Router',
  IPG: 'International Payment Gateway',
  PG_RISKSHIELD: 'PG Risk Shield',
  PO_RISKSHIELD: 'PO Risk Shield',
  ECOM360: 'Ecom360',
  // Below product cards not available on landing page
  EASY_SPLIT: 'Easy Split',
  RISKSHIELD: 'Riskshield',
  WORKFLOW_BUILDER: 'Relay',
};

export const FREE_TRIAL_PRODUCTS = [
  PRODUCT.VERIFICATION_SUITES,
  PRODUCT.PG_RISKSHIELD,
  PRODUCT.PO_RISKSHIELD,
];

export const TRANSACTIONS_URL = '/common/get/transactions';

export const PRODUCT_STATUS_URL = '/common/product/status';

export const QUICK_LINKS_URL = '/common/quick-links';

export const TEST_PRODUCT_STATUS_URL = '/common/test/product/status';

export const TEST_TOKEN_FROM_PROD_URL = '/common/test/token';

export const VALIDATE_TOKEN_URL = '/common/validate/token';

export const COHORT_LIST_URL = '/common/cohort-list';

export const RESEND_EMAIL_VERIFICATION_URL =
  '/common/email/resend/verification';

export const PRODUCT_ACTIVATION_URL = '/common/product/request/activate';

export const PAYOUTS_ACCOUNT_LIST_URL = '/common/payout-ids';

export const UPDATE_TOKEN_WITH_ACCOUNT_ID_URL = '/common/updatetoken';

export const ENABLE_AOV_MX = 'ENABLE_AOV_MX';

export const PAYMENT_LINK_REMINDER_URL = {
  url: '/pg/pggrowth/links/$shortUrl$/trigger-reminder',
  method: 'POST',
};

export const CHECK_MERCHANT_CONFIG_URL = '/common/config/check';

export const FETCH_PAYOUTS_DASHBOARD_CONFIG_URL =
  '/common/config/check?configName=csp_dashboard_new';

export const REDEEM_VOUCHER_URL = {
  url: '/common/voucher/redeem',
  method: 'POST',
};

export const UPDATE_TNC_URL = {
  url: '/common/merchant/terms-and-conditions',
  method: 'POST',
};

export const HC_FORM = {
  url: '/dashboard/v2/dynamic-forms',
  method: 'POST',
  productType: 'OPEX_FORM',
  templateIdGamma: 1198,
  templateIdProd: 614,
  formType: 'ONE_TIME_FORM',
};

export const FETCH_EASY_SPLIT_CONFIG_URL = '/pg/settlements/split/config';

export const GET_RECHARGE_BALANCE_URL = '/pg/recharge-balance';

export const GET_RECHARGE_BANK_DETAILS_URL = '/pg/recharge-bank-details';

export const GET_SUBSCRIPTION_STATUS_URL = '/pg/subscription/status';

export const SLACK_INSTALL_URL =
  'https://receiver.cashfree.com/pgnextgenconsumer/slack/external/install';

export const SHOPIFY_URL =
  'https://www.shopify.com/admin/settings/payments/alternative-providers/1058691';

export const SHOPIFY_CARD_URL =
  'https://www.shopify.com/admin/settings/payments/third-party-providers/33390593';

export const MOBILE_COUNTRY_CODE_OPTIONS = [
  { key: '+91', text: '🇮🇳 IND (+91)', value: '+91' },
  { key: 'USA+1', text: '🇺🇸 USA (+1)', value: 'USA+1' },
  { key: 'CAN+1', text: '🇨🇦 CAN (+1)', value: 'CAN+1' },
  { key: '+44', text: '🇬🇧 GBR (+44)', value: '+44' },
  { key: '+27', text: '🇿🇦 ZAF (+27)', value: '+27' },
  { key: '+65', text: '🇸🇬 SGP (+65)', value: '+65' },
  { key: '+966', text: '🇸🇦 SAU (+966)', value: '+966' },
  { key: '+49', text: '🇩🇪 DEU (+49)', value: '+49' },
  { key: '+33', text: '🇫🇷 FRA (+33)', value: '+33' },
  // { key: '+86', text: 'CHN (+86)', value: '+86' },
  // { key: '+971', text: 'ARE (+971)', value: '+971' },
  // { key: '+61', text: 'AUS (+61)', value: '+61' },
  // { key: '+994', text: 'AZE (+994)', value: '+994' },
  // { key: '+973', text: 'BHR (+973)', value: '+973' },
  // { key: '+41', text: 'CHE (+41)', value: '+41' },
  // { key: '+45', text: 'DNK (+45)', value: '+45' },
  // { key: '+852', text: 'HKG (+852)', value: '+852' },
  // { key: '+972', text: 'ISR (+972)', value: '+972' },
  // { key: '+962', text: 'JOR (+962)', value: '+962' },
  // { key: '+81', text: 'JPN (+81)', value: '+81' },
  // { key: '+82', text: 'KOR (+82)', value: '+82' },
  // { key: '+60', text: 'MYS (+60)', value: '+60' },
  // { key: '+47', text: 'NOR (+47)', value: '+47' },
  // { key: '+64', text: 'NZL (+64)', value: '+64' },
  // { key: 'RUS+7', text: 'RUS (+7)', value: '+7' },
  // { key: '+46', text: 'SWE (+46)', value: '+46' },
  // { key: '+66', text: 'THA (+66)', value: '+66' },
  // { key: '+51', text: 'PER (+51)', value: '+51' },
  // { key: '+372', text: 'EE (+372)', value: '+372' },
];

export const IMPORT_MOBILE_COUNTRY_CODE_OPTIONS = [
  { key: 'ITA (+39)', text: 'ITA (+39)', value: '+39' },
  { key: 'KAZ (+7)', text: 'KAZ (+7)', value: '+7' },
  { key: '+93', text: 'AFG (+93)', value: '+93' },
  { key: '+355', text: 'ALB (+355)', value: '+355' },
  { key: '+376', text: 'AND (+376)', value: '+376' },
  { key: '+1-268', text: 'ATG (+1-268)', value: '+1-268' },
  { key: '+54', text: 'ARG (+54)', value: '+54' },
  { key: '+374', text: 'ARM (+374)', value: '+374' },
  { key: '+61', text: 'AUS (+61)', value: '+61' },
  { key: '+43', text: 'AUT (+43)', value: '+43' },
  { key: '+994', text: 'AZE (+994)', value: '+994' },
  { key: '+1-242', text: 'BHS (+1-242)', value: '+1-242' },
  { key: '+973', text: 'BHR (+973)', value: '+973' },
  { key: '+880', text: 'BGD (+880)', value: '+880' },
  { key: '+1-246', text: 'BRB (+1-246)', value: '+1-246' },
  { key: '+375', text: 'BLR (+375)', value: '+375' },
  { key: '+32', text: 'BEL (+32)', value: '+32' },
  { key: '+501', text: 'BLZ (+501)', value: '+501' },
  { key: '+229', text: 'BEN (+229)', value: '+229' },
  { key: '+975', text: 'BTN (+975)', value: '+975' },
  { key: '+591', text: 'BOL (+591)', value: '+591' },
  { key: '+387', text: 'BIH (+387)', value: '+387' },
  { key: '+267', text: 'BWA (+267)', value: '+267' },
  { key: '+55', text: 'BRA (+55)', value: '+55' },
  { key: '+673', text: 'BRN (+673)', value: '+673' },
  { key: '+257', text: 'BDI (+257)', value: '+257' },
  { key: '+238', text: 'CPV (+238)', value: '+238' },
  { key: '+855', text: 'KHM (+855)', value: '+855' },
  { key: 'CAN (+1)', text: 'CAN (+1)', value: 'CAN+1' },
  { key: '+236', text: 'CAF (+236)', value: '+236' },
  { key: '+235', text: 'TCD (+235)', value: '+235' },
  { key: '+56', text: 'CHL (+56)', value: '+56' },
  { key: '+86', text: 'CHN (+86)', value: '+86' },
  { key: '+57', text: 'COL (+57)', value: '+57' },
  { key: '+269', text: 'COM (+269)', value: '+269' },
  { key: '+242', text: 'COG (+242)', value: '+242' },
  { key: '+506', text: 'CRI (+506)', value: '+506' },
  { key: '+53', text: 'CUB (+53)', value: '+53' },
  { key: '+357', text: 'CYP (+357)', value: '+357' },
  { key: '+420', text: 'CZE (+420)', value: '+420' },
  { key: '+45', text: 'DNK (+45)', value: '+45' },
  { key: '+253', text: 'DJI (+253)', value: '+253' },
  { key: '+1-767', text: 'DMA (+1-767)', value: '+1-767' },
  { key: '+1-809', text: 'DOM (+1-809)', value: '+1-809' },
  { key: '+593', text: 'ECU (+593)', value: '+593' },
  { key: '+20', text: 'EGY (+20)', value: '+20' },
  { key: '+503', text: 'SLV (+503)', value: '+503' },
  { key: '+240', text: 'GNQ (+240)', value: '+240' },
  { key: '+291', text: 'ERI (+291)', value: '+291' },
  { key: '+372', text: 'EST (+372)', value: '+372' },
  { key: '+268', text: 'SWZ (+268)', value: '+268' },
  { key: '+251', text: 'ETH (+251)', value: '+251' },
  { key: '+679', text: 'FJI (+679)', value: '+679' },
  { key: '+358', text: 'FIN (+358)', value: '+358' },
  { key: '+33', text: 'FRA (+33)', value: '+33' },
  { key: '+241', text: 'GAB (+241)', value: '+241' },
  { key: '+220', text: 'GMB (+220)', value: '+220' },
  { key: '+995', text: 'GEO (+995)', value: '+995' },
  { key: '+49', text: 'DEU (+49)', value: '+49' },
  { key: '+233', text: 'GHA (+233)', value: '+233' },
  { key: '+30', text: 'GRC (+30)', value: '+30' },
  { key: '+1-473', text: 'GRD (+1-473)', value: '+1-473' },
  { key: '+502', text: 'GTM (+502)', value: '+502' },
  { key: '+224', text: 'GIN (+224)', value: '+224' },
  { key: '+245', text: 'GNB (+245)', value: '+245' },
  { key: '+592', text: 'GUY (+592)', value: '+592' },
  { key: '+504', text: 'HND (+504)', value: '+504' },
  { key: '+36', text: 'HUN (+36)', value: '+36' },
  { key: '+354', text: 'ISL (+354)', value: '+354' },
  { key: '+91', text: 'IND (+91)', value: '+91' },
  { key: '+62', text: 'IDN (+62)', value: '+62' },
  { key: '+964', text: 'IRQ (+964)', value: '+964' },
  { key: '+353', text: 'IRL (+353)', value: '+353' },
  { key: '+972', text: 'ISR (+972)', value: '+972' },
  { key: '+1-876', text: 'JAM (+1-876)', value: '+1-876' },
  { key: '+81', text: 'JPN (+81)', value: '+81' },
  { key: '+962', text: 'JOR (+962)', value: '+962' },
  { key: '+686', text: 'KIR (+686)', value: '+686' },
  { key: '+965', text: 'KWT (+965)', value: '+965' },
  { key: '+996', text: 'KGZ (+996)', value: '+996' },
  { key: '+371', text: 'LVA (+371)', value: '+371' },
  { key: '+266', text: 'LSO (+266)', value: '+266' },
  { key: '+231', text: 'LBR (+231)', value: '+231' },
  { key: '+218', text: 'LBY (+218)', value: '+218' },
  { key: '+423', text: 'LIE (+423)', value: '+423' },
  { key: '+370', text: 'LTU (+370)', value: '+370' },
  { key: '+352', text: 'LUX (+352)', value: '+352' },
  { key: '+261', text: 'MDG (+261)', value: '+261' },
  { key: '+265', text: 'MWI (+265)', value: '+265' },
  { key: '+60', text: 'MYS (+60)', value: '+60' },
  { key: '+960', text: 'MDV (+960)', value: '+960' },
  { key: '+356', text: 'MLT (+356)', value: '+356' },
  { key: '+692', text: 'MHL (+692)', value: '+692' },
  { key: '+222', text: 'MRT (+222)', value: '+222' },
  { key: '+230', text: 'MUS (+230)', value: '+230' },
  { key: '+52', text: 'MEX (+52)', value: '+52' },
  { key: '+691', text: 'FSM (+691)', value: '+691' },
  { key: '+373', text: 'MDA (+373)', value: '+373' },
  { key: '+976', text: 'MNG (+976)', value: '+976' },
  { key: '+382', text: 'MNE (+382)', value: '+382' },
  { key: '+212', text: 'MAR (+212)', value: '+212' },
  { key: '+674', text: 'NRU (+674)', value: '+674' },
  { key: '+31', text: 'NLD (+31)', value: '+31' },
  { key: '+64', text: 'NZL (+64)', value: '+64' },
  { key: '+505', text: 'NIC (+505)', value: '+505' },
  { key: '+227', text: 'NER (+227)', value: '+227' },
  { key: '+389', text: 'MKD (+389)', value: '+389' },
  { key: '+47', text: 'NOR (+47)', value: '+47' },
  { key: '+968', text: 'OMN (+968)', value: '+968' },
  { key: '+92', text: 'PAK (+92)', value: '+92' },
  { key: '+680', text: 'PLW (+680)', value: '+680' },
  { key: '+970', text: 'PSE (+970)', value: '+970' },
  { key: '+507', text: 'PAN (+507)', value: '+507' },
  { key: '+675', text: 'PNG (+675)', value: '+675' },
  { key: '+595', text: 'PRY (+595)', value: '+595' },
  { key: '+51', text: 'PER (+51)', value: '+51' },
  { key: '+63', text: 'PHL (+63)', value: '+63' },
  { key: '+48', text: 'POL (+48)', value: '+48' },
  { key: '+351', text: 'PRT (+351)', value: '+351' },
  { key: '+974', text: 'QAT (+974)', value: '+974' },
  { key: '+40', text: 'ROU (+40)', value: '+40' },
  { key: 'RUS (+7)', text: 'RUS (+7)', value: '+7' },
  { key: '+250', text: 'RWA (+250)', value: '+250' },
  { key: '+1-869', text: 'KNA (+1-869)', value: '+1-869' },
  { key: '+1-758', text: 'LCA (+1-758)', value: '+1-758' },
  { key: '+1-784', text: 'VCT (+1-784)', value: '+1-784' },
  { key: '+685', text: 'WSM (+685)', value: '+685' },
  { key: '+378', text: 'SMR (+378)', value: '+378' },
  { key: '+239', text: 'STP (+239)', value: '+239' },
  { key: '+966', text: 'SAU (+966)', value: '+966' },
  { key: '+221', text: 'SEN (+221)', value: '+221' },
  { key: '+381', text: 'SRB (+381)', value: '+381' },
  { key: '+248', text: 'SYC (+248)', value: '+248' },
  { key: '+232', text: 'SLE (+232)', value: '+232' },
  { key: '+65', text: 'SGP (+65)', value: '+65' },
  { key: '+421', text: 'SVK (+421)', value: '+421' },
  { key: '+386', text: 'SVN (+386)', value: '+386' },
  { key: '+677', text: 'SLB (+677)', value: '+677' },
  { key: '+252', text: 'SOM (+252)', value: '+252' },
  { key: '+82', text: 'KOR (+82)', value: '+82' },
  { key: '+34', text: 'ESP (+34)', value: '+34' },
  { key: '+94', text: 'LKA (+94)', value: '+94' },
  { key: '+249', text: 'SDN (+249)', value: '+249' },
  { key: '+597', text: 'SUR (+597)', value: '+597' },
  { key: '+46', text: 'SWE (+46)', value: '+46' },
  { key: '+41', text: 'CHE (+41)', value: '+41' },
  { key: '+992', text: 'TJK (+992)', value: '+992' },
  { key: '+66', text: 'THA (+66)', value: '+66' },
  { key: '+670', text: 'TLS (+670)', value: '+670' },
  { key: '+228', text: 'TGO (+228)', value: '+228' },
  { key: '+676', text: 'TON (+676)', value: '+676' },
  { key: '+1-868', text: 'TTO (+1-868)', value: '+1-868' },
  { key: '+216', text: 'TUN (+216)', value: '+216' },
  { key: '+90', text: 'TUR (+90)', value: '+90' },
  { key: '+993', text: 'TKM (+993)', value: '+993' },
  { key: '+688', text: 'TUV (+688)', value: '+688' },
  { key: '+256', text: 'UGA (+256)', value: '+256' },
  { key: '+380', text: 'UKR (+380)', value: '+380' },
  { key: '+971', text: 'ARE (+971)', value: '+971' },
  { key: '+44', text: 'GBR (+44)', value: '+44' },
  { key: 'USA (+1)', text: 'USA (+1)', value: 'USA+1' },
  { key: '+598', text: 'URY (+598)', value: '+598' },
  { key: '+998', text: 'UZB (+998)', value: '+998' },
  { key: '+678', text: 'VUT (+678)', value: '+678' },
  { key: 'VAT (+39)', text: 'VAT (+39)', value: '+39' },
  { key: '+260', text: 'ZMB (+260)', value: '+260' },
  { key: '+263', text: 'ZWE (+263)', value: '+263' },
];

export const COUNTRY_CODE_OPTIONS = [
  { key: '+91', text: '+91', value: '+91' },
  { key: '+86', text: '+86', value: '+86' },
  { key: '+1', text: '+1', value: '+1' },
  { key: '+44', text: '+44', value: '+44' },
  { key: '+971', text: '+971', value: '+971' },
  { key: '+61', text: '+61', value: '+61' },
  { key: '+994', text: '+994', value: '+994' },
  { key: '+973', text: '+973', value: '+973' },
  { key: '+41', text: '+41', value: '+41' },
  { key: '+45', text: '+45', value: '+45' },
  { key: '+20', text: '+20', value: '+20' },
  { key: '+49', text: '+49', value: '+49' },
  { key: '+852', text: '+852', value: '+852' },
  { key: '+972', text: '+972', value: '+972' },
  { key: '+962', text: '+962', value: '+962' },
  { key: '+81', text: '+81', value: '+81' },
  { key: '+82', text: '+82', value: '+82' },
  { key: '+60', text: '+60', value: '+60' },
  { key: '+47', text: '+47', value: '+47' },
  { key: '+64', text: '+64', value: '+64' },
  { key: 'RUS+7', text: '+7', value: '+7' },
  { key: '+46', text: '+46', value: '+46' },
  { key: '+65', text: '+65', value: '+65' },
  { key: '+66', text: '+66', value: '+66' },
  { key: '+27', text: '+27', value: '+27' },
];

export const IMAGE_SIGNATURES = {
  jpg: 'FFD8FF', // image/jpg (FF D8 FF E3)
  jpeg: 'FFD8FF', // image/jpeg (FF D8 FF E8)
  png: '89504E47', // image/png
};

export const ACCEPTED_SIGNATURE = {
  ...IMAGE_SIGNATURES,
  pdf: '25504446', // application/pdf
};

export const XLS_SIGNATURE = { xls: 'D0CF11' }; // application xls

export const SPREADSHEET_SIGNATURES = {
  csv: '4F726465', // application/csv
  xlsx: '504B34', // application xlsx
};

export const EASY_SPLIT_SIGNATURES = {
  csv: '76656E64',
};

export const REFUND_TIMELINE_LABELS = ['PARTIAL_REFUND_OF', 'FULL_REFUND_OF'];

export const AUTO_REFUND_TIMELINE_LABELS = [
  'PARTIAL_AUTO_REFUND_OF',
  'FULL_AUTO_REFUND_OF',
];

export const PAYMENTS_FIELD_MAPPER = {
  UPI: {
    bankName: 'UPI Method',
    cardNumber: 'User VPA',
    currency: 'Currency',
  },
  NET_BANKING: {
    bankName: 'Bank',
    currency: 'Currency',
  },
  NON_CARD_BASED_PAYMENTS: {
    currency: 'Currency',
  },
  DEFAULT: {
    bankName: 'Bank',
    cardNumber: 'Card Number',
    cardType: 'Card Type',
    cardCountry: 'Card Country',
    currency: 'Currency',
  },
};

export const META_DATA_MAPPER = {
  PAYMENT_CREATED: {
    transactionId: 'Transaction ID',
    paymentMode: 'Payment Mode',
  },
  PAYMENT_SUCCESS: {
    txStatus: 'Transaction Status',
    txMessage: 'Transaction Message',
    rrn: 'Bank Reference No',
    serviceCharge: 'Service Charge',
    serviceTax: 'Service Tax',
  },
  PAYMENT_SETTLED: {
    settlementId: 'Settlement ID',
    settlementUTR: 'UTR No.',
  },
  PAYMENT_NOT_SETTLED: {
    settlementAmount: 'Settlement Amount',
    settlementUTR: 'Settlement UTR No.',
    serviceCharge: 'Serivce Charge',
    serviceTax: 'Service Tax',
  },
  DISPUTE_OPENED: {
    caseId: 'Case ID',
    disputeAmout: 'Dispute Amt',
    targetDate: 'Target Date',
    latestActivity: 'Latest Activity',
  },
  DISPUTE_RAISED: {
    caseId: 'Case ID',
    disputeAmount: 'Dispute Amt',
    targetDate: 'Target Date',
    latestActivity: 'Latest Activity',
  },
  PARTIAL_DISPUTE_RAISED_OF: {
    caseId: 'Case ID',
    disputeAmount: 'Dispute Amt',
    targetDate: 'Target Date',
    latestActivity: 'Latest Activity',
  },
  RISK_CASE_UNDER_REVIEW: {
    riskAmount: 'Risk Amt',
    targetDate: 'Target Date',
  },
  RISK_CASE_CLOSED: {},
  DISPUTE_CLOSED: {},
  REFUND: {
    refundNote: 'Remark',
    refundStatus: 'Refund Status',
    refundId: 'Refund ID',
    cfRefundId: 'CF Refund ID',
    refundARN: 'Refund ARN',
  },
  FULL_AUTO_REFUND_OF: {
    userVisibleStatus: 'Refund Status',
    reversalId: 'CF Refund ID',
    arn: 'Refund ARN',
  },
  PAYMENT_LINK_CREATED: {
    id: 'Tnx Id',
  },
  PAYMENT_ATTEMPTED: {
    id: 'Tnx Id',
    txStatus: 'Tnx Status',
  },
  ORDER_PAID: {
    id: 'Tnx Id',
    txStatus: 'Tnx Status',
  },
  ORDER_CREATED: {
    id: 'Tnx Id',
  },
  PAYMENT_AWAITING: {
    id: 'Tnx Id',
    txStatus: 'Tnx Status',
  },
  PAYMENT_FAILED: {
    rrn: 'Bank Reference No',
    txMessage: 'Transaction Message',
    txStatus: 'Transaction Status',
  },
  PAYMENT_USER_DROPPED: {
    id: 'Tnx Id',
    rrn: 'Bank Reference No',
    txMessage: 'Transaction Message',
    txStatus: 'Transaction Status',
  },
  PAYMENT_VOID: {
    id: 'Tnx Id',
    txStatus: 'Tnx Status',
  },
  PAYMENT_CAPTURE: {
    captureStatus: 'Status',
  },
  OFFER_APPLIED: {
    type: 'Type',
    title: 'Title',
    description: 'Description',
    code: 'Code',
    offerId: 'Offer Id',
  },
  PAYMENT_VERIFICATION_INITIATED: {
    txnVerificationStatus: 'Verification Status',
    fundStatus: 'Fund Status',
    remarks: 'Remarks',
  },
  PAYMENT_VERIFICATION_SUBMITTED: {
    txnVerificationStatus: 'Verification Status',
    fundStatus: 'Fund Status',
    remarks: 'Remarks',
  },
  PAYMENT_VERIFICATION_COMPLETED: {
    txnVerificationStatus: 'Verification Status',
    fundStatus: 'Fund Status',
    remarks: 'Remarks',
  },
  PAYMENT_VERIFICATION_REJECTED: {
    txnVerificationStatus: 'Verification Status',
    fundStatus: 'Fund Status',
    remarks: 'Remarks',
  },
  PAYMENT_VERIFICATION_EXPIRED: {
    txnVerificationStatus: 'Verification Status',
    fundStatus: 'Fund Status',
    remarks: 'Remarks',
  },
  PAYMENT_SETTLED_IMPORT: {
    settlementId: 'Settlement ID',
    settledOn: 'Settled On',
    settlementUtr: 'Settlement UTR',
  },
};

export const AMOUNT_TYPE_TIMELINE_FIELDS = [
  'settlementAmount',
  'serviceCharge',
  'serviceTax',
  'disputeAmout',
  'disputeAmount',
  'riskAmount',
];

// total status mappers as per labels

export const STATUS_MAPPER = {
  DISPUTES: {
    'UNDER REVIEW': 'PENDING',
  },
};

export const TX_STATUS_CLASSNAME = {
  SUCCESS: 'success',
  FAILED: 'failed',
  REFUNDED: 'success',
  PENDING: 'pending',
  USER_DROPPED: 'user-dropped',
  OPENED: 'user-dropped',
  IN_PROGRESS: 'user-dropped',
  'UNDER REVIEW': 'pending',
  INCOMPLETE: 'pending',
  CLOSED: 'closed',
  PAID: 'success',
  AWAITING: 'pending',
  EXPIRED: 'failed',
  PROCESSED: 'success',
  ACTIVE: 'success',
  DEACTIVATED: 'failed',
  ERROR: 'failed',
  PROCESSING: 'pending',
  DELETED: 'failed',
  BLOCKED: 'failed',
  CREATED: 'pending',
  SETTLED: 'success',
  'NOT SETTLED': 'pending',
  'USER DROPPED': 'user-dropped',
  INACTIVE: 'failed',
  CANCELLED: 'failed',
  PARTIALLY_PAID: 'partially-paid',
  PARTIAL: 'partially-paid',
  QUEUED: 'pending',
  REVERSED: 'failed',
  IN_KYC_REVIEW: 'partially-paid',
  ON_HOLD: 'pending',
  AGENT_REVIEW: 'pending',
  UPLOAD_EVIDENCE: 'pending',
  IN_REVIEW: 'pending',
  ACTION_REQUIRED: 'failed',
};

export const VERIFICATION_STATUS_MAPPING = {
  'ACTION REQUIRED': 'Action Required',
  'IN REVIEW': 'In Review',
  FAILED: 'Failed',
  EXPIRED: 'Expired',
};

export const DEFAULT_LIMIT = 10;
export const DEFAULT_CURRENT_PAGE = 1;

export const SUBSCRIPTIONS = 'SUBSCRIPTIONS';

export const SUBSCRIPTIONS_DETAILS = 'SUBSCRIPTIONS_DETAILS';
export const SUBSCRIPTION_PAYMENTS = 'SUBSCRIPTION_PAYMENTS';

export const OFFERS = 'OFFERS';

export const OFFERSV2 = 'OFFERSV2';

export const RECOVERY_CAMPAIGN = 'RECOVERY_CAMPAIGN';

export const QR_CODE = 'QR_CODE';

export const RISKSHIELD = 'RISKSHIELD';

export const WORKFLOWS = 'WORKFLOWS';

export const VBA_CONFIGURATION = 'VBA_CONFIGURATION';

export const ECOM_360 = 'ECOM_360';

export const ECOM_360_V2 = 'ECOM_360_V2';

export const ECOM_360_ACTIVATED = 'ECOM_360_ACTIVATED';
export const ECOM_360_ACTIVATED_OFFERS = 'ECOM_360_ACTIVATED_OFFERS';
export const ECOM_360_ACTIVATED_ANALYTICS = 'ECOM_360_ACTIVATED_ANALYTICS';
export const ECOM_360_ACTIVATED_CANVAS = 'ECOM_360_ACTIVATED_CANVAS';

export const BBPS_COU = 'BBPS_COU';

export const PG_DASHBOARD_SUMMARY_PATH = 'pg/summary/overview';
export const PG_DASHBOARD_SUBSCRIPTION_PATH =
  'pg/subscriptions/all-subscriptions';

export const PG_DASHBOARD_MENU_URL_MAPPING = {
  SUMMARY: {
    name: 'summary',
    children: {
      SUMMARY: 'overview',
      ANALYTICS_V2: 'analytics',
      SR_DASHBOARD: 'sr-dashboard',
    },
  },
  TRANSACTIONS: {
    name: 'transactions',
    children: {
      ORDERS: 'orders',
      REFUNDS: 'refunds',
      DISPUTES: 'disputes',
      SUSPICIOUS: 'suspicious',
    },
  },
  SETTLEMENTS: 'settlements',
  PAYMENT_VERIFICATION: 'payment-verification',
  PAYMENT_LINKS: {
    name: 'payment-links',
    children: {
      PAYMENT_FORM_DESCRIPTION: 'payment-form-description',
    },
  },
  PAYMENT_FORMS: {
    name: 'payment-forms',
    children: {
      PAYMENT_FORM_DESCRIPTION: 'payment-form-description',
    },
  },
  PAYMENT_BUTTONS: {
    name: 'payment-buttons',
    children: {
      PAYMENT_BUTTON_DESCRIPTION: 'payment-button-description',
    },
  },
  CUSTOMERS: 'customers',
  PRODUCT_LINKS: 'product-links',
  EASY_SPLIT: 'easy-split',
  REPORTS: 'reports',
  DEVELOPERS: 'developers',
  WORKFLOWS: 'workflows',
  SETTINGS: 'settings',
  SUBSCRIPTIONS: {
    name: 'subscriptions',
    children: {
      // SUMMARY: 'summary',
      BULK_CREATE_SUBSCRIPTIONS: '#bulk-create-subscriptions',
      BULK_PAYMENTS: '#bulk-payments',
      IMPORT_MANDATES: '#import-mandates',
      ALL_SUBSCRIPTIONS: 'all-subscriptions',
      PLANS: 'plans',
      TRANSACTIONS: 'transactions',
    },
  },
  SOFTPOS: 'softpos',
  ROUTER: 'flowwise',
  GATEWAY_PLUS: 'gateway-plus',
  OFFERS: {
    name: 'offers',
    children: {
      ALL_OFFERS: 'offers/all',
      RECOVERY_CAMPAIGN: 'offers/recovery-campaign',
    },
  },
  APPS: 'apps',
  // ROUTER_ANALYTICS: 'analytics',
  QR_CODE: 'qr-code',
  STATUS_PAGE: 'status-page',
  RISKSHIELD: 'risk-shield',
  VBA_CONFIGURATION: {
    name: 'vba-configuration',
    children: {
      NOTIFICATIONS_GROUPS: 'NotificationGroups',
      VBA_ACCOUNTS: 'accounts',
    },
  },
  ECOM_360: 'one-click-checkout',
  ECOM_360_V2: 'one-click-checkout-pitch',
  ECOM_360_ACTIVATED: {
    name: 'one-click-checkout-activated',
    children: {
      ECOM_360_ACTIVATED_RECOVERY_CAMPAIGN:
        'one-click-checkout-activated/recovery-campaign',
      ECOM_360_ACTIVATED_OFFERS: 'one-click-checkout-activated/offers',
      ECOM_360_ACTIVATED_OFFERSV2: 'one-click-checkout-activated/offersV2',
      ECOM_360_ACTIVATED_CANVAS: 'one-click-checkout-activated/customisation',
      ANALYTICS_V2: 'one-click-checkout-activated/funnel-analytics',
      ECOM_360_ACTIVATED_AOV_BOOSTER:
        'one-click-checkout-activated/aov-booster',
    },
  },
  CHECKOUT_ONE: {
    name: 'customisation',
  },
  EMBEDDABLE_COMPONENTS: 'embeddable-components',
  COD: 'cod',
};

export const GLOBAL_PG_MENU_OPTIONS = [
  'DEVELOPERS',
  'SETTINGS',
  'INCIDENTS',
  'WORKFLOWS',
];

export const BRANDING = 'Branding';

export const APPROVED = 'APPROVED';

export const NEW_COMPLETED = 'NEW_COMPLETED';

export const COMPLETED = 'COMPLETED';

export const IN_PROGRESS = 'IN_PROGRESS';

export const REJECTED = 'REJECTED';

export const FAILED = 'FAILED';

export const NOT_APPLICABLE = 'N/A';

export const DEFAULT_PG_MENU_TAB_STATE = {
  filters: {
    appliedFilters: {
      startDate: moment()
        .startOf('day')
        .format('YYYY-MM-DD 00:00:00'),
      endDate: moment()
        .endOf('day')
        .format('YYYY-MM-DD HH:mm:ss'),
    },
    dateFilters: {
      displayText: 'Today',
      range: [
        moment()
          .startOf('day')
          .toDate(),
        moment()
          .endOf('day')
          .toDate(),
      ],
    },
    pageSize: DEFAULT_LIMIT,
    pageNo: DEFAULT_CURRENT_PAGE,
  },
  data: [],
  totalCount: 0,
  totalPages: 0,
  hasPrev: false,
  hasNext: false,
  currentPageRowData: [],
  filtersForDisplay: [],
};

export const ORDER_AMOUNT_FILTER_OPTIONS = [
  {
    key: 'IS_LESS_THAN_EQUAL_TO',
    value: 'IS_LESS_THAN_EQUAL_TO',
    text: 'is less than equal to',
  },
  { key: 'IS_BETWEEN', value: 'IS_BETWEEN', text: 'is between' },
  { key: 'IS_EQUAL_TO', value: 'IS_EQUAL_TO', text: 'is equal to' },
  {
    key: 'IS_GREATER_THAN_EQUAL_TO',
    value: 'IS_GREATER_THAN_EQUAL_TO',
    text: 'is greater than equal to',
  },
];

export const TRANSACTIONS_SPENDS_FILTER_OPTIONS = [
  {
    key: 'IS_LESS_THAN_EQUAL_TO',
    value: 'IS_LESS_THAN_EQUAL_TO',
    text: 'is less than equal to',
  },
  { key: 'IS_BETWEEN', value: 'IS_BETWEEN', text: 'is between' },
];
export const SETTLEMENT_RECON_SETTLED_AMOUNT_FILTER_OPTIONS = [
  {
    key: 'IS_LESS_THAN_EQUAL_TO',
    value: 'IS_LESS_THAN_EQUAL_TO',
    text: 'is less than equal to',
  },
  { key: 'IS_EQUAL_TO', value: 'IS_EQUAL_TO', text: 'is equal to' },
  {
    key: 'IS_GREATER_THAN_EQUAL_TO',
    value: 'IS_GREATER_THAN_EQUAL_TO',
    text: 'is greater than equal to',
  },
];

export const NET_BANKING_ITEMS = {
  'State Bank Of India': 'State Bank Of India',
  'Kotak Mahindra Bank': 'Kotak Mahindra Bank',
  'ICICI Bank': 'ICICI Bank',
  'HDFC Bank': 'HDFC Bank',
  'Bank of Baroda - Retail Banking': 'Bank of Baroda - Retail Banking',
  'Bank of India': 'Bank of India',
  'Canara Bank': 'Canara Bank',
  'Punjab National Bank - Retail Banking':
    'Punjab National Bank - Retail Banking',
  'Union Bank of India': 'Union Bank of India',
  'Indian Bank': 'Indian Bank',
  'Axis Bank': 'Axis Bank',
  'Federal Bank': 'Federal Bank',
  'Central Bank of India': 'Central Bank of India',
  'Bank of Maharashtra': 'Bank of Maharashtra',
  'Indian Overseas Bank': 'Indian Overseas Bank',
  'Yes Bank Ltd': 'Yes Bank Ltd',
  'IDBI Bank': 'IDBI Bank',
  'City Union Bank': 'City Union Bank',
  'DBS Bank Ltd': 'DBS Bank Ltd',
  'IndusInd Bank': 'IndusInd Bank',
  'Standard Chartered Bank': 'Standard Chartered Bank',
  'South Indian Bank': 'South Indian Bank',
  'UCO Bank': 'UCO Bank',
  'Jammu and Kashmir Bank': 'Jammu and Kashmir Bank',
  'Karnataka Bank Ltd': 'Karnataka Bank Ltd',
  'Bank of Baroda - Corporate': 'Bank of Baroda - Corporate',
  'Karur Vysya Bank': 'Karur Vysya Bank',
  'IDFC FIRST Bank': 'IDFC FIRST Bank',
  'Punjab & Sind Bank': 'Punjab & Sind Bank',
  'Catholic Syrian Bank': 'Catholic Syrian Bank',
  'CSB Bank': 'CSB Bank',
  'RBL Bank': 'RBL Bank',
  'Saraswat Bank': 'Saraswat Bank',
  'DCB Bank - Personal': 'DCB Bank - Personal',
  'Dhanlakshmi Bank': 'Dhanlakshmi Bank',
  'Punjab National Bank   - Corporate': 'Punjab National Bank   - Corporate',
  'Laxmi Vilas Bank - Retail Net Banking':
    'Laxmi Vilas Bank - Retail Net Banking',
  'ICICI Corporate Netbanking': 'ICICI Corporate Netbanking',
  'Tamilnad Mercantile Bank Ltd': 'Tamilnad Mercantile Bank Ltd',
  'Equitas Small Finance Bank': 'Equitas Small Finance Bank',
  'Bandhan Bank - Retail Banking': 'Bandhan Bank - Retail Banking',
  'AU Small Finance Bank': 'AU Small Finance Bank',
  'Axis Bank Corporate': 'Axis Bank Corporate',
  'Tamil Nadu State Co-operative Bank': 'Tamil Nadu State Co-operative Bank',
  'Union Bank of India -  Corporate': 'Union Bank of India -  Corporate',
  'Shamrao Vitthal Co-operative Bank': 'Shamrao Vitthal Co-operative Bank',
  'Deutsche Bank': 'Deutsche Bank',
  'Bandhan Bank- Corporate banking': 'Bandhan Bank- Corporate banking',
  'Shamrao Vithal Bank Corporate': 'Shamrao Vithal Bank Corporate',
  'Indian Overseas Bank Corporate': 'Indian Overseas Bank Corporate',
  'Dhanlaxmi Bank Corporate': 'Dhanlaxmi Bank Corporate',
  'Ratnakar Corporate Banking': 'Ratnakar Corporate Banking',
  'DCB Bank - Corporate': 'DCB Bank - Corporate',
  'Yes Bank Corporate': 'Yes Bank Corporate',
  'HSBC Retail NetBanking': 'HSBC Retail NetBanking',
  'Barclays Corporate- Corporate Banking - Corporate':
    'Barclays Corporate- Corporate Banking - Corporate',
  'Utkarsh Small Finance Bank': 'Utkarsh Small Finance Bank',
  'State Bank of India - Corporate': 'State Bank of India - Corporate',
  'Shivalik Bank': 'Shivalik Bank',
  'Lakshmi Vilas Bank - Corporate': 'Lakshmi Vilas Bank - Corporate',
  'Gujarat State Co-operative Bank Limited':
    'Gujarat State Co-operative Bank Limited',
  'The Surat Peoples Co-operative Bank Limited':
    'The Surat Peoples Co-operative Bank Limited',
  'Bank of India - Corporate': 'Bank of India - Corporate',
  'City Union Bank of Corporate': 'City Union Bank of Corporate',
  'HDFC Corporate': 'HDFC Corporate',
};

export const CREDIT_CARD_ITEMS = {
  RETIAL_CREDIT_CARD: 'Retail Credit Card',
  PREMIUM_CREDIT_CARD: 'Premium Credit Card',
  ELITE_CREDIT_CARD: 'Elite Credit Card',
  CORPORATE_CREDIT_CARD: 'Corporate Credit Card',
};

export const WALLET_ITEMS = {
  PhonePe: 'PhonePe',
  AIRTEL_MONEY: 'Airtel Money',
  PAYTM: 'Paytm',
  FreeCharge: 'FreeCharge',
  MobiKwik: 'MobiKwik',
  JioMoney: 'Jio Money',
  AmazonPay: 'Amazon Pay',
  olaMoney: 'Ola Money',
};

export const DEBIT_CARD_ITEMS = {
  MAESTRO: 'Maestro',
  MASTERCARD: 'MasterCard',
  RUPAY: 'Rupay',
  VISA: 'VISA',
};

export const UPI_ITEMS = {
  BHIM_UPI: 'BHIM UPI',
  GOOGLE_PAY: 'Google Pay',
  PHONEPE: 'PhonePe',
};

export const PAY_LATER_ITEMS = {
  'OlaMoney Post Paid': 'Ola Money Postpaid',
  'Lazy Pay': 'LazyPay',
  'Hdfc Paylater': 'HDFC PayLater',
  'Zestmoney pay later': 'Zestmoney PayLater',
  Simpl: 'Simpl',
  'Freecharge Paylater': 'Freecharge PayLater',
};

export const EMI_ITEMS = {
  DEBIT_CARD_EMI: 'Debit Card EMI',
  CREDIT_CARD_EMI: 'Credit Card EMI',
  CARDLESS_EMI: 'Cardless EMI',
};

export const CHECKBOX = 'checkbox';

export const RULE_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  CREATED: 'In Draft',
};

export const CARD_ITEMS = {
  DEBIT_CARD: 'Debit Card',
  CREDIT_CARD: 'Credit Card',
  PREPAID_CARD: 'Prepaid Card',
  CORPORATE_CREDIT_CARD: 'Corporate Credit Card',
};

// commented for now - will remove once the testing is complete on gamma

// export const PAYMENT_METHODS_ITEMS = {
//   NET_BANKING: 'Net Banking',
//   CREDIT_CARD: 'Credit Card',
//   PREPAID_CARD: 'Prepaid Card',
//   PAYPAL: 'PayPal',
//   WALLET: 'Wallet',
//   DEBIT_CARD: 'Debit Card',
//   UPI: 'UPI',
// };

export const PAYMENT_METHODS_ITEMS = {};

export const EASY_SPLIT_PAYMENTS_METHODS_ITEMS = [
  {
    key: 'UPI',
    value: 'UPI',
    text: 'UPI',
  },
  {
    key: 'PAY_PAL',
    value: 'PAY_PAL',
    text: 'PayPal',
  },
  {
    key: 'CREDIT_CARD',
    value: 'CREDIT_CARD',
    text: 'Credit Card',
  },
  {
    key: 'NET_BANKING',
    value: 'NET_BANKING',
    text: 'Net Banking',
  },
  {
    key: 'WALLET',
    value: 'WALLET',
    text: 'Wallet',
  },
  {
    key: 'PAY_LATER',
    value: 'PAY_LATER',
    text: 'Pay Later',
  },
];

export const CAPTURE_STATUS_ITEMS = {
  NOT_CAPTURED: 'Not Captured',
  CAPTURED: 'Captured',
};

export const PAYMENT_MODE_FILTERS = {
  CARD: 'Cards',
  UPI: 'UPI',
  NET_BANKING: 'Net Banking',
  EMI: 'EMI',
  SUBSCRIPTION: 'Subscription',
  PAY_LATER: 'Pay Later',
  WALLET: 'Wallet',
};

export const FAILURE_SOURCE_FILTERS = {
  customer: 'Customer',
  network: 'Network',
  psp_app: 'PSP App',
  bank: 'Bank',
  acquiring_bank: 'Acquiring Bank',
  issuing_bank: 'Issuing Bank',
  payment_gateway: 'Payment Gateway',
  cashfree: 'Cashfree',
};

export const PAYMENT_METHODS_ITEMS_MAPPING = {
  // CREDIT_CARD: CREDIT_CARD_ITEMS,
  // DEBIT_CARD: DEBIT_CARD_ITEMS,
  // NET_BANKING: NET_BANKING_ITEMS,
  // UPI: UPI_ITEMS,
  // WALLET: WALLET_ITEMS,
};

export const DISPUTES_STATUS_ITEMS = {
  TAKE_ACTION: 'Take action',
  UNDER_REVIEW: 'Under review',
  UPLOAD_EVIDENCE: 'Insufficient evidence',
  WON: 'Won',
  LOST: 'Lost',
  ACCEPTED: 'Accepted',
};

export const SUSPICIOUS_STATUS_ITEMS = {
  UNDER_REVIEW: 'Under Review',
  UPLOAD_EVIDENCE: 'Upload Proof',
  AGENT_REVIEW: 'Agent Review',
  CLOSED: 'Closed',
};

export const SETTLEMENTS_STATUS_ITEMS = [
  {
    key: 'PROCESSED',
    value: 'PROCESSED',
    text: 'Processed',
  },
  {
    key: 'FAILED',
    value: 'FAILED',
    text: 'Failed',
  },
  {
    key: 'PENDING',
    value: 'PENDING',
    text: 'In Progress',
  },
];

export const INSTANT_SETTLEMENTS_STATUS_ITEMS = [
  {
    key: 'PROCESSED',
    value: 'PROCESSED',
    text: 'Processed',
  },
  {
    key: 'FAILED',
    value: 'FAILED',
    text: 'Failed',
  },
  {
    key: 'PENDING',
    value: 'PENDING',
    text: 'Pending',
  },
];

export const SETTLEMENTS_VENDOR_STATUS_ITEMS = [
  {
    key: 'SUCCESS',
    value: 'SUCCESS',
    text: 'Success',
  },
  {
    key: 'FAILED',
    value: 'FAILED',
    text: 'Failed',
  },
  {
    key: 'PENDING',
    value: 'PENDING',
    text: 'Pending',
  },
  {
    key: 'CREATED',
    value: 'CREATED',
    text: 'Created',
  },
  {
    key: 'REVERSED',
    value: 'REVERSED',
    text: 'Reversed',
  },
];

export const PAYMENT_STATUS_ITEMS = {
  SUCCESS: 'Success',
  PENDING: 'Pending',
  FAILED: 'Failed',
  USER_DROPPED: 'User Dropped',
  VOID: 'Void',
  INCOMPLETE: 'Incomplete',
  CANCELLED: 'Cancelled',
};

export const ORDER_STATUS_ITEMS = {
  PAID: 'Paid',
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
};

export const EVENT_TYPE_ITEMS = {
  CREDIT: 'Recharge - Credit',
  DEBIT: 'Refund - Debit',
};

export const FEE_WALLET_EVENT_TYPE_ITEMS = {
  CREDIT: 'Recharge - Credit',
  DEBIT: 'Invoice Payment - Debit',
};

export const SDK_ITEMS = {
  'app-sdk': 'Android',
  'react-native-android': 'Android React Native',
  'flutter-android': 'Android Flutter',
  reactsdk: 'Android React',
  'sdk-transparent': 'Transparent',
  'capacitor-android': 'Android Capacitor',
  iossdk: 'IOS',
  'custom-mob-sdk': 'Mobile',
  'cordova-android': 'Android Cordova',
  'react-native-ios-sdk': 'IOS React Native',
  'sdk-js': 'JS',
  'flutter-ios-sdk': 'IOS Flutter',
  'nextgenapi-js': 'JS Nextgen',
  'nextgenapi-android': 'Android Nextgen',
  'nextgenapi-ios': 'IOS Nextgen',
  'flutter-sdk': 'Flutter',
  'capacitor-ios-sdk': 'IOS Capacitor',
  'xamarin-ios-sdk': 'IOS Xamarin',
  'cordova-ios-sdk': 'IOS Cordova',
  'xamarin-android': 'Android Xamarin',
  'xamarin-forms': 'Form Xamarin',
  'cordova-sdk': 'Cordova',
};

export const API_ITEMS = {
  api: 'API',
  'seamless-pro': 'Seamless',
  nextgenapi: 'API Nextgen',
};

export const ORDER_TYPE_ITEMS = {
  PRODUCT: 'Product Link',
  POS: 'POS',
  PG: 'Payment Gateway',
  CFID: 'Payme Link',
  SBC: 'Subscription',
  API: 'Payment Gateway API',
};

export const CHECKOUT_ITEMS = {
  'checkout-form': 'Checkout Form',
  shopify: 'Shopify',
  opencart: 'Opencart',
  woocommerce: 'Woocommerce',
  cscart: 'Cscart',
  whmcs: 'Whmcs',
  magento: 'Magneto',
};

export const ORDER_SOURCE_ITEMS = {
  SDK: {
    key: 'orderSource',
    displayText: 'SDK',
    type: CHECKBOX,
    placeholder: 'Search SDK',
    items: SDK_ITEMS,
  },
  API: {
    key: 'orderSource',
    displayText: 'API',
    type: CHECKBOX,
    placeholder: 'Search API',
    items: API_ITEMS,
  },
  CHECKOUT: {
    key: 'orderSource',
    displayText: 'Checkout',
    type: CHECKBOX,
    placeholder: 'Search Checkout',
    items: CHECKOUT_ITEMS,
  },
  softpos: 'softPOS',
};

export const REFUNDS_STATUS_ITEMS = {
  // INITIATED: 'Initiated',
  REFUNDED: 'Refunded',
  PENDING: 'Pending',
  ONHOLD: 'Onhold',
  CANCELLED: 'Cancelled',
  PENDING_APPROVAL: 'Pending Approval',
  REJECTED: 'Rejected',
  // FAILED: 'Failed',
};

export const SETTLEMENTS_TYPE_ITEMS = {
  NORMAL_SETTLEMENT: 'Standard',
  INSTANT_SETTLEMENT: 'Instant',
};

export const DEBITED_FROM_TYPE_ITEMS = {
  MERCHANT: 'Merchant',
  VENDOR: 'Vendor',
};

export const BATCH_REFUNDS_STATUS_ITEMS = {
  PROCESSED: 'Processed',
};

export const AUTO_REFUNDS_STATUS_ITEMS = {
  S: 'Refunded',
  C: 'Failed',
  F: 'In Progress',
};

export const AUTO_REFUNDS_PAYMENT_MODE_ITEMS = {
  CREDIT_CARD: 'Credit Card',
  DEBIT_CARD: 'Debit Card',
  UPI: 'UPI',
  Wallet: 'Wallet',
  NET_BANKING: 'Net Banking',
};

export const AUTO_REFUNDS_TYPE_ITEMS = {
  DIRECT_UPI: 'Direct UPI',
  CF_TRANSACTION: 'CF Transaction',
  DISPUTE: 'Dispute',
};

export const PAYMENT_LINK_ALL_STATUS_ITEMS = {
  CREATED: 'Active',
  PAID: 'Paid',
  PARTIALLY_PAID: 'Partially Paid',
  EXPIRED: 'Expired',
  CANCELLED: 'Cancelled',
};

export const PAYMENT_FORM_ALL_STATUS_ITEMS = {
  CREATED: 'Active',
  EXPIRED: 'Expired',
  CANCELLED: 'Cancelled',
};

export const CUSTOMERS_ACTIVE_SPEND_TAG_ITEMS = {
  'HIGH SPENDER': 'High Spender',
};

export const CUSTOMERS_ACTIVE_PREFERRED_MODE = [
  {
    key: 'upi',
    value: 'upi',
    text: 'UPI',
  },
  {
    key: 'card',
    value: 'card',
    text: 'Card',
  },
  {
    key: 'wallet',
    value: 'wallet',
    text: 'Wallet',
  },
  {
    key: 'netbanking',
    value: 'netbanking',
    text: 'Net Banking',
  },
  {
    key: 'bankTransfer',
    value: 'bankTransfer',
    text: 'Bank Transfer',
  },
  {
    key: 'paylater',
    value: 'paylater',
    text: 'Pay Later',
  },
  {
    key: 'cardlessEmi',
    value: 'cardlessEmi',
    text: 'Cardless EMI',
  },
  {
    key: 'ccEmi',
    value: 'ccEmi',
    text: 'CC EMI',
  },
  {
    key: 'dcEmi',
    value: 'dcEmi',
    text: 'DC EMI',
  },
];

export const PAYMENT_LINK_ALL_STATUS_ITEMS_V1 = [
  {
    key: 'PAID',
    value: 'PAID',
    text: 'Paid',
  },
  {
    key: 'AWAITING',
    value: 'ACTIVE',
    text: 'Awaiting',
  },
  {
    key: 'EXPIRED',
    value: 'EXPIRED',
    text: 'Expired',
  },
  {
    key: 'PENDING',
    value: 'PENDING',
    text: 'Pending',
  },
  {
    key: 'PROCESSED',
    value: 'PROCESSED',
    text: 'Processed',
  },
];
export const PAYMENT_LINK_ORDERS_STATUS_ITEMS = {
  SUCCESS: 'Success',
  PENDING: 'Pending',
  FAILED: 'Failed',
  USER_DROPPED: 'User Dropped',
  INCOMPLETE: 'Incomplete',
};

export const VENDOR_STATUS_ITEMS = [
  {
    key: 'ACTIVE',
    value: 'ACTIVE',
    text: 'Active',
  },
  {
    key: 'BLOCKED',
    value: 'BLOCKED',
    text: 'Blocked',
  },
  {
    key: 'DELETED',
    value: 'DELETED',
    text: 'Deleted',
  },
  {
    key: 'IN_BENE_CREATION',
    value: 'IN_BENE_CREATION',
    text: 'In Bene Creation',
  },
  {
    key: 'BENE_CREATION_FAILED',
    value: 'BENE_CREATION_FAILED',
    text: 'Bene Creation Failed',
  },
  {
    key: 'ACTION_REQUIRED',
    value: 'ACTION_REQUIRED',
    text: 'Action Required',
  },
  {
    key: 'IN_KYC_REVIEW',
    value: 'IN_KYC_REVIEW',
    text: 'In KYC Review',
  },
  {
    key: 'IN_BANK_VALIDATION',
    value: 'IN_BANK_VALIDATION',
    text: 'In Bank Validation',
  },
  {
    key: 'BANK_VALIDATION_FAILED',
    value: 'BANK_VALIDATION_FAILED',
    text: 'Bank Validation Failed',
  },
  {
    key: 'ON_HOLD',
    value: 'ON_HOLD',
    text: 'On Hold',
  },
  {
    key: 'DEACTIVATED',
    value: 'DEACTIVATED',
    text: 'Deactivated',
  },
];

export const VENDOR_STATUS_ITEMS_MAP = VENDOR_STATUS_ITEMS.reduce((acc, { key, text }) => {
  acc[key] = text;
  return acc;
}, {});

export const VENDOR_STATUS_ITEMS_NEW_FLOW = [
  {
    key: 'ACTIVE',
    value: 'ACTIVE',
    text: 'Active',
  },
  {
    key: 'BLOCKED',
    value: 'BLOCKED',
    text: 'Blocked',
  },
  {
    key: 'DELETED',
    value: 'DELETED',
    text: 'Deleted',
  },
  {
    key: 'IN_BENE_CREATION',
    value: 'IN_BENE_CREATION',
    text: 'In Bene Creation',
  },
  {
    key: 'BENE_CREATION_FAILED',
    value: 'BENE_CREATION_FAILED',
    text: 'Bene Creation Failed',
  },
  {
    key: 'ACTION_REQUIRED',
    value: 'ACTION_REQUIRED',
    text: 'Action Required',
  },
  {
    key: 'IN_KYC_REVIEW',
    value: 'IN_KYC_REVIEW',
    text: 'In KYC Review',
  },
  {
    key: 'IN_BANK_VALIDATION',
    value: 'IN_BANK_VALIDATION',
    text: 'In Bank Validation',
  },
  {
    key: 'BANK_VALIDATION_FAILED',
    value: 'BANK_VALIDATION_FAILED',
    text: 'Bank Validation Failed',
  },
  {
    key: 'ON_HOLD',
    value: 'ON_HOLD',
    text: 'On Hold',
  },
  {
    key: 'DEACTIVATED',
    value: 'DEACTIVATED',
    text: 'Deactivated',
  },
];

export const OFFERS_STATUS_ITEMS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  EXPIRED: 'Expired',
};

export const OFFERS_CATEGORY_ITEMS = {
  CASHBACK: 'Cashback',
  DISCOUNT: 'Discount',
  NO_COST_EMI: 'No Cost EMI',
  GIFT: 'Gift',
};

export const OFFERS_TYPE_ITEMS = {
  FLAT: 'Flat',
  PERCENTAGE: 'Percentage',
};

export const PAYMENT_MODES_ITEMS = {
  DEBIT_CARD: 'Debit Card',
  CREDIT_CARD: 'Credit Card',
  UPI: 'UPI',
  WALLET: 'Wallet',
  NET_BANKING: 'Net Banking',
  PAY_LATER: 'Pay Later',
  EMI: 'EMI',
};
export const OFFERS_PAYMENT_MODES = {
  CARD: 'Card',
  UPI: 'UPI',
  WALLET: 'Wallet',
  NET_BANKING: 'Net Banking',
  PAY_LATER: 'Pay Later',
  EMI: 'EMI',
  ALL: 'All',
};
export const OFFERS_PLATFORM_ITEMS = {
  CASHFREE: 'Cashfree',
  SHOPIFY: 'Shopify',
};
// const RATE_LIMIT_REQUEST_COUNT = {
//   ZERO_REQUEST_COUNT: 'No Requests',
//   NON_ZERO_REQUEST_COUNT: 'New Requests',
// };
const MERCHANT_RL_UPDATE_REQUESTS = {
  NO_PENDING_RATE_LIMIT_REQUEST: 'No Pending Request',
  PENDING_RATE_LIMIT_REQUEST: 'With Pending Requests',
};
const RATE_LIMIT_VIOLATION_COUNT = {
  ZERO_VIOLATION_COUNT: 'No Violations',
  NON_ZERO_VIOLATION_COUNT: 'With Violations',
};

const API_ALERT_RULES_STATUS = {
  ENABLED: 'On',
  DISABLED: 'Off',
};

export const PG_API_ERROR_4XX = 'PG_API_ERROR_4XX';
export const PG_API_ERROR_5XX = 'PG_API_ERROR_5XX';
export const PG_API_RATE_LIMIT = 'PG_API_RATE_LIMIT';
export const SUBS_API_RATE_LIMIT = 'SUBS_API_RATE_LIMIT';
export const PG_API_LATENCY_1S = 'PG_API_LATENCY_1S';

export const API_ALERT_RULE_TYPE = {
  [PG_API_ERROR_4XX]: '4XX Alert',
  [PG_API_ERROR_5XX]: '5XX Alert',
  [PG_API_RATE_LIMIT]: 'Rate Limit Warning',
  [SUBS_API_RATE_LIMIT]: 'Subscription Rate Limit Warning',
  // [PG_API_LATENCY_1S]: 'Latency Alert',
};

export const TRANSACTION_ITEMS = {
  REFUND: 'Refund',
  DISPUTE: 'Dispute',
  CHARGEBACK: 'Charge Back',
};

export const PAYMENT_LINK_BATCH_STATUS_ITEMS = {
  PROCESSED: 'Processed',
};

export const PAYMENT_LINK_BATCH_STATUS_ITEMS_NEW = {
  PROCESSED: 'Processed',
  PROCESSING: 'Processing',
  FAILED: 'Failed',
};

export const SEARCH = 'search';

export const DROPDOWN = 'dropdown';

export const TEXT = 'text';

export const PAYMENT_METHODS_FILTERS = {
  displayText: 'Payment Methods',
  type: CHECKBOX,
  items: PAYMENT_METHODS_ITEMS,
};

export const EASY_SPLIT_PAYMENTS_METHODS_FILTERS = {
  displayText: 'Payment Methods',
  type: DROPDOWN,
  items: EASY_SPLIT_PAYMENTS_METHODS_ITEMS,
};

export const CAPTURE_STATUS_FILTERS = {
  displayText: 'Capture Status',
  type: CHECKBOX,
  items: CAPTURE_STATUS_ITEMS,
};

export const ORDER_AMOUNT_FILTER = {
  displayText: 'Net Settled Amount',
  type: DROPDOWN,
  items: ORDER_AMOUNT_FILTER_OPTIONS,
};
export const SETTLEMENT_RECON_SETTLED_AMOUNT_FILTER = {
  displayText: 'Net Settled Amount',
  type: DROPDOWN,
  items: SETTLEMENT_RECON_SETTLED_AMOUNT_FILTER_OPTIONS,
};

export const TOTAL_TRANSACTIONS_FILTER = {
  displayText: 'Total Transactions',
  type: DROPDOWN,
  items: TRANSACTIONS_SPENDS_FILTER_OPTIONS,
};

export const TOTAL_SPENDS_FILTER = {
  displayText: 'Total Spends',
  type: DROPDOWN,
  items: TRANSACTIONS_SPENDS_FILTER_OPTIONS,
};

export const SETTLEMENT_AMOUNT_FILTER = {
  displayText: 'Settlement Amount',
  type: DROPDOWN,
  items: ORDER_AMOUNT_FILTER_OPTIONS,
};

export const PRODUCT_LINKS_STATUS_ITEMS = [
  {
    key: 'ACTIVE',
    value: '1',
    text: 'Active',
  },
  {
    key: 'DEACTIVATED',
    value: '0',
    text: 'Deactivated',
  },
];

export const FLOW_WISE_RECON_REPORT = 'flow_wise_recon_report';

export const REPORT_FILTER_ITEMS = [
  {
    key: 'TRANSACTIONS',
    text: 'Transactions',
    value: 'tx_report',
  },
  {
    key: 'SETTLEMENTS',
    text: 'Settlements',
    value: 'pg_settlement_summary_report',
  },
  {
    key: 'FLOWWISE_RECON',
    text: 'flowWise Recon',
    value: FLOW_WISE_RECON_REPORT,
  },
  {
    key: 'SETTLEMENT_RECON',
    text: 'Settlement Recon',
    value: 'pg_settlement_recon_report_v2',
  },
  {
    key: 'LEDGER',
    text: 'Ledger',
    value: 'pg_ledger_summary_report',
  },
  {
    key: 'PAYTM',
    text: 'Paytm',
    value: 'pg_paytm_summary_report',
  },
  {
    key: 'REFUNDS',
    text: 'Refunds',
    value: 'pg_refund_report',
  },
  {
    key: 'PRODUCT_LINK_ORDERS',
    text: 'Product Link Orders',
    value: 'pg_product_txn_report',
  },
  {
    key: 'PAYMENT_FORM',
    text: 'Payment Form',
    value: 'pg_payment_form_report',
  },
  {
    key: 'OFFERS',
    text: 'Offers',
    value: 'redemption_order',
  },
  { key: 'RETARGET_ORDER', text: 'Abandoned Orders', value: 'retarget_order' },
  {
    key: RISK_TRANSACTIONS,
    text: 'Risk Transactions',
    value: 'risk_transaction',
  },
];

export const VENDOR_REPORT_FILTER_ITEMS = [
  {
    key: 'VENDOR_SPLIT_SETTLEMENTS',
    text: 'Vendor Split Settlements',
    value: 'split_report',
  },
  {
    key: 'VENDOR_SETTLEMENT_RECON',
    text: 'Vendor Settlement Recon',
    value: 'split_txn',
  },
  {
    key: 'VENDOR_RECON',
    text: 'Vendor Recon',
    value: 'vendor_recon_report',
  },
  {
    key: 'VENDOR_ORDER_RECON',
    text: 'Vendor Order Recon',
    value: 'vendor_order_recon',
  },
];

export const SUB_REPORT_FILTER_ITEMS = [
  {
    key: 'SUBSCRIPTIONS',
    text: 'Subscriptions',
    value: 'subscription',
  },
  {
    key: 'SUBSCRIPTION_PAYMENT_REPORT',
    text: 'Subscription Payment Reports',
    value: 'subscription_payments_datalake',
  },
];

export const REPORT_DOWNLOAD_FORMAT_OPTIONS = [
  {
    key: 'csv',
    text: 'CSV',
    value: 'CSV',
  },
  {
    key: 'xlsx',
    text: 'XLSX',
    value: 'XLSX',
  },
  {
    key: 'txt',
    text: 'TXT',
    value: 'TXT',
  },
];

export const TXT_DELIMITER_OPTIONS = [
  {
    key: 'tab',
    text: 'Tab (\\t)',
    value: '\t',
  },
  {
    key: 'pipe',
    text: 'Pipe (|)',
    value: '|',
  },
  {
    key: 'comma',
    text: 'Comma (,)',
    value: ',',
  },
  {
    key: 'semicolon',
    text: 'Semicolon (;)',
    value: ';',
  },
];

export const ON_DEMAND_SETTLEMENTS_STATUS_ITEMS = {
  IN_PROGRESS: 'In Progress',
  SUCCESS: 'Success',
  FAILED: 'Failed',
  REJECTED: 'Rejected',
};

export const QR_CODE_STATUS_ITEMS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  DOCS_AWAITED: 'Doc Awaited',
  UNDER_REVIEW: 'Under Review',
  REJECTED: 'Rejected',
  BLOCKED: 'Blocked',
  PROVISIONALLY_ACTIVE: 'Provisionally Active',
};
export const LOGS_STATUS_ITEMS = {
  SUCCESS: 'Success',
  FAILED: 'Failed',
};
export const LOGS_RESEND_STATUS_ITEMS = {
  ORIGINAL: 'Original',
  RESEND: 'Resend',
};

export const COLLECTION_POINT_TYPE_ITEMS = {
  AGENT: 'Agent',
  STOREFRONT: 'Storefront',
};

export const COLLECTION_POINT_MANAGEMENT = 'Collection Point Management';

export const ALL_COLLECTION_POINTS = 'All Collection Points';

export const BATCH_AGENTS = 'Batch Agents';

export const WEBHOOK_TYPE_FILTER_ITEMS = [
  {
    key: 'PAYMENT_SUCCESS_WEBHOOK',
    value: 'PAYMENT_SUCCESS_WEBHOOK',
    text: 'Payment Success Webhook',
  },
  {
    key: 'PAYMENT_FAILED_WEBHOOK',
    value: 'PAYMENT_FAILED_WEBHOOK',
    text: 'Payment Failed Webhook',
  },
  {
    key: 'PAYMENT_USER_DROPPED_WEBHOOK',
    value: 'PAYMENT_USER_DROPPED_WEBHOOK',
    text: 'Payment User dropped Webhook',
  },
  {
    key: 'PAYMENT_CHARGES_WEBHOOK',
    value: 'PAYMENT_CHARGES_WEBHOOK',
    text: 'Payment Charges Webhook',
  },
  {
    key: 'REFUND_STATUS_WEBHOOK',
    value: 'REFUND_STATUS_WEBHOOK',
    text: 'Refund Status Webhook',
  },
  {
    key: 'HEALTH_ALERT',
    value: 'HEALTH_ALERT',
    text: 'Health Alert Webhook',
  },
  {
    key: 'SETTLEMENT_INITIATED',
    value: 'SETTLEMENT_INITIATED',
    text: 'Settlement Initiated Webhook',
  },
  {
    key: 'SETTLEMENT_SUCCESS',
    value: 'SETTLEMENT_SUCCESS',
    text: 'Settlement Success Webhook',
  },
  {
    key: 'SETTLEMENT_FAILED',
    value: 'SETTLEMENT_FAILED',
    text: 'Settlement Failed Webhook',
  },
  {
    key: 'SETTLEMENT_REVERSED',
    value: 'SETTLEMENT_REVERSED',
    text: 'Settlement Reversed Webhook',
  },
  {
    key: 'INSTRUMENT_ACTIVE_WEBHOOK',
    value: 'INSTRUMENT_ACTIVE_WEBHOOK',
    text: 'Instrument Active Webhook',
  },
];

export const EPOS_BATCH_STATUS_ITEMS = {
  COMPLETE: 'Complete',
  PROCESSING: 'Processing',
  FAILED: 'Failed',
};

export const ADJUSTMENT_TYPE_FILTERS = [
  {
    key: 'C',
    value: 'C',
    text: 'Credit',
  },
  {
    key: 'D',
    value: 'D',
    text: 'Debit',
  },
];

export const EASY_SPLIT_REFUNDS_STATUS_ITEMS = [
  {
    key: 'S',
    value: 'S',
    text: 'Refunded',
  },
  {
    key: 'H',
    value: 'H',
    text: 'On Hold',
  },
  {
    key: 'C',
    value: 'C',
    text: 'Cancelled',
  },
];

export const PG_INCIDENTS_STATUS = [
  {
    key: 'ACTIVE',
    value: 'ACTIVE',
    text: 'Active',
  },
  {
    key: 'UPCOMING',
    value: 'UPCOMING',
    text: 'Upcoming',
  },
  {
    key: 'RESOLVED',
    value: 'RESOLVED',
    text: 'Resolved',
  },
];

export const PG_INCIDENTS_SEVERITY = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

export const UPFRONT_TDR_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const PG_INCIDENTS_TYPE = {
  SCHEDULED: 'Scheduled',
  UNSCHEDULED: 'Unscheduled',
};

export const PG_INCIDENTS_PAYMENT_MODE = {
  CREDIT_CARD: 'Credit Card',
  DEBIT_CARD: 'Debit Card',
  ALL_CARDS: 'All Cards',
  UPI: 'UPI',
  NET_BANKING: 'Net Banking',
  WALLET: 'Wallet',
};

export const ORDERS_DESCRIPTION = 'ORDERS_DESCRIPTION';

export const PAYMENTS = 'Payments';

export const REFUNDS = 'Refunds';

export const INITIATED_REFUNDS = 'Initiated Refunds';

export const BATCH_REFUNDS = 'Batch Refunds';

export const AUTO_REFUNDS = 'Auto Refunds';

export const DISPUTES = 'Disputes';

export const SUSPICIOUS = 'Suspicious';

export const BATCH_CAPTURE = 'Batch Capture';

export const STANDARD = 'Standard';

export const INSTANT = 'Instant';

export const ON_DEMAND = 'On-Demand';

export const SETTLE_NOW = 'SETTLE_NOW';

export const SETTLE_NOW_SUCCESS = 'SETTLE_NOW_SUCCESS';

export const SETTLE_NOW_ERROR = 'SETTLE_NOW_ERROR';

export const VENDOR = 'Vendor';

export const SCHEDULED = 'Scheduled';

export const ALL = 'All';

export const ALL_PAYMENTS = 'All Payments';

export const FLAGGED = 'Flagged';

export const BATCH = 'Batch';

export const ORDERS = 'Orders';

export const INTELLI_FORMS = 'Intelli Forms';

export const CUSTOMER_ACTIVE = 'Active';

export const CUSTOMER_UNFULFILLED = 'Unfulfilled';

export const AGENT_MANAGEMENT = 'Agent Management';

export const AGENT_MANAGEMENT_ALL = `${AGENT_MANAGEMENT} ${ALL}`;

export const AGENT_MANAGEMENT_BATCH = `${AGENT_MANAGEMENT} ${BATCH}`;

export const COLLECTION_POINT_MANAGEMENT_ALL_COLLECTION_POINTS = `${COLLECTION_POINT_MANAGEMENT} ${ALL_COLLECTION_POINTS}`;

export const GATEWAYS = 'Gateways';

export const GATEWAYS_CONFIGURATION = 'Configure';

export const UPFRONT_TDR = 'Upfront TDR';

export const PAYMENT_METHODS = 'Payment Methods';

export const ALL_SUBSCRIPTIONS = 'All Subscriptions';

export const BULK_CREATE_SUBSCRIPTIONS = 'Bulk Create Subscriptions';

export const BULK_PAYMENTS = 'Bulk Payments';

export const PLANS = 'plans';

export const IMPORT_MANDATES = 'Import Mandates';

export const TEST_WEBHOOK = 'Test Webhook';

export const TRANSACTIONS = 'TRANSACTIONS';

export const PAYMENT_LINKS = 'PAYMENT_LINKS';

export const SOFTPOS = 'SOFTPOS';

export const SETTINGS = 'SETTINGS';

export const SUMMARY = 'SUMMARY';

export const ROUTER_ANALYTICS = 'ROUTER_ANALYTICS';

export const PAYMENT_FORMS = 'PAYMENT_FORMS';

export const PAYMENT_BUTTONS = 'PAYMENT_BUTTONS';

export const CUSTOMERS = 'CUSTOMERS';

export const PAYMENT_LINKS_V1 = 'PAYMENT_LINKS_V1';

export const EASY_SPLIT = 'EASY_SPLIT';

export const SETTLEMENTS = 'SETTLEMENTS';

export const PAYMENT_VERIFICATION = 'PAYMENT_VERIFICATION';

export const DEVELOPERS = 'DEVELOPERS';

export const PRODUCT_LINKS = 'PRODUCT_LINKS';

export const PRODUCT_DESCRIPTION = 'PRODUCT_DESCRIPTION';

export const REPORTS = 'REPORTS';

export const ROUTER = 'ROUTER';

export const GATEWAY_PLUS = 'GATEWAY_PLUS';

export const CHECKOUT_ONE = 'CHECKOUT_ONE';

export const EMBEDDABLE_COMPONENTS = 'EMBEDDABLE_COMPONENTS';

export const EPOS = 'ePOS';

export const DEFAULT = 'DEFAULT';

export const SETTLEMENT_BANK_DETAILS = 'Settlement Bank Details';

export const EMAIL_NOTIFICATIONS = 'Email Notifications';

export const NOTIFICATIONS = 'Notifications';

export const API_KEYS = 'api-keys';

export const WHITELISTING = 'whitelisting';

export const INTEGRATION_USAGE = 'integration-usage';

export const WEBHOOKS = 'webhooks';

export const API_METRICS = 'api-metrics';

export const API_LOGS = 'api-logs';

export const API_ALERTS = 'api-alerts';

export const CHECKOUT_ANALYTICS = 'checkout-analytics';

export const RATE_LIMITS = 'rate-limits';

export const MERCHANT_NOTIFICATIONS = 'Merchant Notifications';

export const CUSTOMER_NOTIFICATIONS = 'Customer Notifications';

export const COMMUNICATION_PREFERENCES = 'Communication Preferences';
export const SUCCESS_RATE_ALERTS = 'Success Rate Alerts';

export const CONFIGURATION = 'Configuration';

export const LOGS = 'Logs';

export const ALERTS = 'Alerts';

export const ANALYTICS = 'Analytics';

export const SR_DASHBOARD = 'SR_DASHBOARD';
export const PLAYGROUND = 'PLAYGROUND';

export const SERVICE_ALERTS = 'Service Alerts';
export const APPS = 'APPS';

export const DOWNLOAD_REPORT = 'Download';

export const SCHEDULE_REPORT = 'Schedule';

export const SPLIT_SCHEME = 'split-scheme';

export const VENDORS = 'Vendors';

export const ADJUSTMENTS = 'Adjustments';

export const EASY_SPLIT_PAYMENTS = 'Easy-Split Payments';

export const EASY_SPLIT_REFUNDS = 'Easy-Split Refunds';

export const EASY_SPLIT_ADJUSTMENTS = 'Easy-Split Adjustments';

export const STATUS_PAGE = 'STATUS_PAGE';

export const INCIDENTS = 'incidents';

export const SPLIT_SCHEME_CONFIGURATION = 'Split Scheme Configuration';

export const SHELL_V2 = 'Shell V2';

export const SETTLEMENT_ROUTER_RECON = 'settlement-recon';

export const SETTLEMENT_ROUTER_SALE = 'settlement-recon-sale';
export const SETTLEMENT_ROUTER_ADJUSTMENTS = 'settlement-recon-adjustments';

export const SETTLEMENT_ROUTER_ANAMOLY = 'settlement-recon-anamoly';
export const SETTLEMENT_ROUTER_ANAMOLY_SALE = 'settlement-recon-anamoly-sale';
export const SETTLEMENT_ROUTER_ANAMOLY_ADJUSTMENTS =
  'settlement-recon-anamoly-adjustments';

export const VBA_ACCOUNTS = 'VBA_ACCOUNTS';
export const NOTIFICATION_GROUPS = 'NOTIFICATION_GROUPS';

export const COD = 'COD';

export const PG_SETTINGS_OPTIONS = [
  {
    name: BRANDING,
    url: 'branding',
    key: 'BRANDING',
    isActive: true,
    header: BRANDING,
    subheaders: [],
    displayText: BRANDING,
  },
  {
    name: PAYMENT_METHODS,
    url: 'payment-methods',
    key: 'PAYMENT_METHODS',
    isActive: true,
    header: PAYMENT_METHODS,
    subheaders: [],
    displayText: PAYMENT_METHODS,
  },
  {
    name: SETTLEMENT_BANK_DETAILS,
    url: 'bank-accounts',
    key: 'SETTLEMENT_BANK_DETAILS',
    isActive: true,
    header: SETTLEMENT_BANK_DETAILS,
    subheaders: [],
    displayText: SETTLEMENT_BANK_DETAILS,
  },
  {
    name: NOTIFICATIONS,
    url: 'notifications',
    key: 'NOTIFICATIONS',
    isActive: true,
    header: NOTIFICATIONS,
    subheaders: [],
    displayText: NOTIFICATIONS,
  },
  {
    name: 'Preferences',
    url: 'preferences',
    key: 'PREFERENCES',
    isActive: true,
    header: 'Preferences',
    subheaders: [],
    displayText: 'Preferences',
  },
  {
    name: '',
    url: 'wallets',
    key: 'WALLETS',
    isActive: true,
    header: '',
    subheaders: [],
    displayText: '',
    showDocLink: true,
  },
  {
    name: '',
    url: 'wallet-details',
    key: 'WALLET-DETAILS',
    isActive: true,
    header: '',
    subheaders: [],
    displayText: '',
  },
  {
    name: 'Billing Configuration',
    url: 'billing-configuration',
    key: 'BILLING_CONFIG',
    isActive: true,
    header: 'Billing Configuration',
    subheaders: [],
    displayText: 'Billing Configuration',
  },
  {
    name: 'Feature Configuration',
    url: 'feature-configuration',
    key: 'FEATURE_CONFIG',
    isActive: true,
    header: 'Feature Configuration',
    subheaders: [],
    displayText: 'Feature Configuration',
  },
  {
    name: 'Split Scheme Configuration',
    url: 'split-scheme-configuration',
    key: 'SPLIT_SCHEME_CONFIG',
    isActive: true,
    header: 'Split Scheme Configuration',
    subheaders: [],
    displayText: 'Split Scheme Configuration',
  },
  {
    name: 'Upfront TDR Details',
    url: 'upfront-tdr/detalis',
    key: 'UPFRONT_TDR_DETAILS',
    isActive: true,
    header: 'Upfront TDR',
    subheaders: [],
    displayText: 'Upfront TDR',
  },
  {
    name: 'Transaction Time',
    url: 'transaction-time',
    key: 'TRANSACTION_TIME',
    isActive: true,
    header: 'Transaction Time',
    subheaders: [],
    displayText: 'Transaction Time',
  },
  // {
  //   name: 'Upfront TDR',
  //   url: 'upfront-tdr',
  //   key: 'UPFRONT_TDR',
  //   isActive: true,
  //   header: 'Upfront TDR',
  //   subheaders: [],
  //   displayText: 'Upfront TDR',
  // },
];

export const SOFTPOS_SEARCH_ITEMS = [
  {
    key: 'agentName',
    text: 'Agent Name',
    value: 'agentName',
    placeholder: "Enter Agent's Name",
    inputPattern: '^[a-zA-Z0-9\\-_.\\$&\\/ ]+$',
    error:
      'Only alphabets, numbers, and special characters (space, -, _, ., $, &, /) are allowed.',
  },
];

export const PAYMENT_METHOD_STATUS_ITEMS = {
  ALL: 'All',
  ACTIVATED: 'Enabled',
  // REJECTED: 'Rejected', this will be added once we start supporting this status
  IN_REVIEW: 'Pending',
  AVAILABLE: 'Available',
  DISABLED: 'Disabled',
};

export const DISPUTES_TYPE_ITEMS = {
  DISPUTE: 'Dispute',
  RETRIEVAL: 'Retrieval',
  CHARGEBACK: 'Chargeback',
  PRE_ARBITRATION: 'Pre Arbitration',
  ARBITRATION: 'Arbitration',
};

export const DISPUTES_RESULT_ITEMS = {
  MERCHANT_WON: 'Won',
  MERCHANT_LOST: 'Lost',
  MERCHANT_ACCEPTED: 'Accepted',
};

export const DISPUTES_RESPOND_BY_ITEMS = {
  TODAY: 'Today',
  TOMORROW: 'Tomorrow',
  NEXT_SEVEN_DAYS: 'Next 7 days',
  NEXT_THIRTY_DAYS: 'Next 30 days',
  OVERDUE: 'Overdue',
  DUE_IMMEDIATE_WEEKEND: 'Due Immediate Weekend',
};

export const DISPUTES_RESOLVED_ON_ITEMS = {
  LAST_SEVEN_DAYS: 'Last 7 days',
  LAST_FIFTEEN_DAYS: 'Last 15 days',
  LAST_ONE_MONTH: 'Last 1 month',
  LAST_SIX_MONTHS: 'Last 6 months',
};

export const DISPUTE_AMOUNT_FILTER = {
  displayText: 'Dispute Amount',
  type: DROPDOWN,
  items: ORDER_AMOUNT_FILTER_OPTIONS,
};

export const ACTION_REQUIRED = 'Action Required';

export const UNDER_REVIEW = 'Under Review';

export const VERIFIED = 'Verified';

export const EXPIRED = 'Expired';

export const ALL_DISPUTES = 'All Disputes';

export const BUSINESS_TRENDS = 'BUSINESS_TRENDS';

export const PAYMENT_FAILURE = 'PAYMENT_FAILURE';

export const SHIPPING_DELIVERY = 'SHIPPING_DELIVERY';

export const SCHEDULE_REPORTS_STATUS_ITEMS = {
  active: 'Actively Sending',
  pause: 'Paused',
};

export const SCHEDULE_REPORTS_TYPE_ITEMS = {
  transaction: 'Transactions',
  'comprehensive-refunds': 'Comprehensive Refunds',
  settlement_recon_v2: 'Settlement Recon',
  refund: 'Refunds',
  ledger: 'Ledger',
  paymentForm: 'Payment Form',
  product: 'Product Link Orders',
  softpos: 'Softpos',
  dispute_order: 'Disputes',
  offline_settlement_recon: 'Offline Settlement Recon',
  risk_transaction: 'Risk Transactions',
  vendorSettlement: 'Vendor Split Settlements',
  vendorRecon: 'Vendor Recon',
  vendorOrderRecon: 'Vendor Order Recon',
};

export const SCHEDULE_REPORTS_SCHEDULE_ITEMS = {
  DAILY: 'Daily',
  WEEKLY: 'Weekly',
  MONTHLY: 'Monthly',
};

export const SCHEDULE_REPORTS_DELIVERY_ITEMS = {
  EMAIL: 'Email',
  SFTP: 'SFTP',
};
const SHIPPING_FILTER_ITEMS = {
  hideSearchItems: true,
  FILTER_ITEMS: {
    status: {
      displayText: 'Status',
      type: CHECKBOX,
      items: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
      },
    },
    paymentMode: {
      displayText: 'Payment Mode',
      type: CHECKBOX,
      items: {
        COD: 'Cash On Delivery',
        PREPAID: 'Prepaid',
        PARTIAL_COD: 'Partial Payment',
      },
    },
  },
};
export const FILTERS_BY_NAVIGATION = {
  [ROUTER_ANALYTICS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        // pg: {
        //   displayText: 'Payment Gateway',
        //   type: CHECKBOX,
        //   items: PAYMENT_GATEWAY_ITEMS,
        //   hasSubItems: false,
        // },
        // paymentMode: {
        //   ...PAYMENT_METHODS_FILTERS,
        //   remark: 'Tip: For best analysis, choose a single Payment Method.',
        // },
      },
    },
  },
  ROUTER_ANALYTICS_V2: {
    BUSINESS_TRENDS: {
      FILTER_ITEMS: {
        paymentMode: {
          displayText: 'Payment Method',
          type: CHECKBOX,
          items: PAYMENT_MODE_FILTERS,
        },
      },
    },
    PAYMENT_FAILURE: {
      FILTER_ITEMS: {
        errorSources: {
          displayText: 'Failure Source',
          type: CHECKBOX,
          items: FAILURE_SOURCE_FILTERS,
        },
        paymentModes: {
          displayText: 'Payment Method',
          type: CHECKBOX,
          items: PAYMENT_MODE_FILTERS,
        },
      },
    },
  },
  [PAYMENTS]: {
    [ALL]: {
      FILTER_ITEMS: {
        txStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: PAYMENT_STATUS_ITEMS,
        },
        isCaptured: CAPTURE_STATUS_FILTERS,
        paymentMode: PAYMENT_METHODS_FILTERS,
        orderAmount: ORDER_AMOUNT_FILTER,
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Ex: Order ID 1, Order ID 2',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'transactionId',
          text: 'Transaction ID',
          value: 'transactionId',
          placeholder: 'Ex: Transaction ID 1, Transaction ID 2',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'customerReferenceId',
          text: 'Customer Ref ID',
          value: 'customerReferenceId',
          placeholder: 'Enter Customer Ref ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'phoneNumber',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
        {
          key: 'email',
          text: 'Email ID',
          value: 'customerEmail',
          placeholder: 'Enter Email ID',
        },
        {
          key: 'rrn',
          text: 'Bank Reference No',
          value: 'rrn',
          placeholder: 'Enter Bank Reference No',
        },
      ],
    },
    [BATCH_CAPTURE]: {
      SEARCH_ITEMS: [
        {
          key: 'batchFileId',
          text: 'Batch ID',
          value: 'fileId',
          placeholder: 'Enter Batch ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'fileName',
          text: 'File Name',
          value: 'merchantFileName',
          placeholder: 'Enter File Name',
        },
      ],
    },
  },
  [ORDERS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        orderStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: ORDER_STATUS_ITEMS,
        },
        orderType: {
          displayText: 'Order Type',
          type: CHECKBOX,
          items: ORDER_TYPE_ITEMS,
        },
        // orderSource: {
        //   displayText: 'Integration Type',
        //   type: CHECKBOX,
        //   items: ORDER_SOURCE_ITEMS,
        // },
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Ex: Order ID 1, Order ID 2',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'cforderId',
          text: 'CF Order ID',
          value: 'cforderId',
          placeholder: 'Ex: CF Order ID 1, CF Order ID 2',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'customerName',
          text: 'Customer Name',
          value: 'customerName',
          placeholder: 'Enter Customer Name',
          inputPattern: '^[a-zA-Z ]+$',
          error: 'Only alphabets and space are allowed.',
        },
        {
          key: 'phoneNumber',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
        {
          key: 'email',
          text: 'Email ID',
          value: 'customerEmail',
          placeholder: 'Enter Email ID',
        },
      ],
    },
  },
  [DISPUTES]: {
    [ACTION_REQUIRED]: {
      FILTER_ITEMS: {
        type: {
          displayText: 'Type',
          type: CHECKBOX,
          items: DISPUTES_TYPE_ITEMS,
        },
        respondBy: {
          displayText: 'Respond by',
          type: CHECKBOX,
          items: DISPUTES_RESPOND_BY_ITEMS,
        },
        orderAmount: DISPUTE_AMOUNT_FILTER,
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter Order ID',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'transactionId',
          text: 'Transaction ID',
          value: 'txnId',
          placeholder: 'Enter Transaction ID',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'disputeCaseId',
          text: 'Dispute ID',
          value: 'caseId',
          placeholder: 'Enter Dispute ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
      ],
    },
    [UNDER_REVIEW]: {
      FILTER_ITEMS: {
        type: {
          displayText: 'Type',
          type: CHECKBOX,
          items: DISPUTES_TYPE_ITEMS,
        },
        respondBy: {
          displayText: 'Respond by',
          type: CHECKBOX,
          items: DISPUTES_RESPOND_BY_ITEMS,
        },
        orderAmount: DISPUTE_AMOUNT_FILTER,
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter Order ID',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'transactionId',
          text: 'Transaction ID',
          value: 'txnId',
          placeholder: 'Enter Transaction ID',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'disputeCaseId',
          text: 'Dispute ID',
          value: 'caseId',
          placeholder: 'Enter Dispute ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
      ],
    },
    Closed: {
      FILTER_ITEMS: {
        type: {
          displayText: 'Type',
          type: CHECKBOX,
          items: DISPUTES_TYPE_ITEMS,
        },
        resolvedOn: {
          displayText: 'Resolved On',
          type: CHECKBOX,
          items: DISPUTES_RESOLVED_ON_ITEMS,
        },
        status: {
          displayText: 'Result',
          type: CHECKBOX,
          items: DISPUTES_RESULT_ITEMS,
        },
        orderAmount: DISPUTE_AMOUNT_FILTER,
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter Order ID',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'transactionId',
          text: 'Transaction ID',
          value: 'txnId',
          placeholder: 'Enter Transaction ID',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'disputeCaseId',
          text: 'Dispute ID',
          value: 'caseId',
          placeholder: 'Enter Dispute ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
      ],
    },
    [ALL_DISPUTES]: {
      FILTER_ITEMS: {
        type: {
          displayText: 'Type',
          type: CHECKBOX,
          items: DISPUTES_TYPE_ITEMS,
        },
        respondBy: {
          displayText: 'Respond by',
          type: CHECKBOX,
          items: DISPUTES_RESPOND_BY_ITEMS,
        },
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: DISPUTES_STATUS_ITEMS,
        },
        orderAmount: DISPUTE_AMOUNT_FILTER,
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter Order ID',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'transactionId',
          text: 'Transaction ID',
          value: 'txnId',
          placeholder: 'Enter Transaction ID',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'disputeCaseId',
          text: 'Dispute ID',
          value: 'caseId',
          placeholder: 'Enter Dispute ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
      ],
    },
  },
  [SUSPICIOUS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Case Status',
          type: CHECKBOX,
          items: SUSPICIOUS_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Ex: Order ID 1, Order ID 2',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'transactionId',
          text: 'Transaction ID',
          value: 'transactionId',
          placeholder: 'Ex: Transaction ID 1, Transaction ID 2',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'phoneNumber',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
        {
          key: 'riskCaseId',
          text: 'Case ID',
          value: 'caseId',
          placeholder: 'Enter Case ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
        {
          key: 'email',
          text: 'Email ID',
          value: 'customerEmail',
          placeholder: 'Enter Email ID',
        },
      ],
    },
  },
  [REFUNDS]: {
    [INITIATED_REFUNDS]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: REFUNDS_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Ex: Order ID 1, Order ID 2',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'transactionId',
          text: 'Transaction ID',
          value: 'txId',
          placeholder: 'Ex: Transaction ID 1, Transaction ID 2',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'phoneNumber',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
        {
          key: 'refundId',
          text: 'Refund ID',
          value: 'refundId',
          placeholder: 'Enter Refund ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'cfRefundId',
          text: 'CF Refund ID',
          value: 'cfRefundId',
          placeholder: 'Enter CF Refund ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed',
        },
        {
          key: 'refundArn',
          text: 'Refund ARN',
          value: 'arn',
          placeholder: 'Enter Refund ARN',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'email',
          text: 'Email ID',
          value: 'customerEmail',
          placeholder: 'Enter Email ID',
        },
      ],
    },
    [BATCH_REFUNDS]: {
      FILTER_ITEMS: {
        fileStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: BATCH_REFUNDS_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'batchFileId',
          text: 'Batch ID',
          value: 'fileId',
          placeholder: 'Enter Batch ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'fileName',
          text: 'File Name',
          value: 'merchantFileName',
          placeholder: 'Enter File Name',
        },
      ],
    },
    [AUTO_REFUNDS]: {
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter CF Order ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'transactionId',
          text: 'Transaction ID',
          value: 'transactionId',
          placeholder: 'Ex: Transaction ID 1, Transaction ID 2',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'reversalId',
          text: 'Refund ID',
          value: 'reversalId',
          placeholder: 'Enter Refund ID',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'txRef',
          text: 'Transaction UTR',
          value: 'txRef',
          placeholder: 'Ex: Transaction UTR 1, Transaction UTR 2',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'customerPhone',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
        {
          key: 'customerEmail',
          text: 'Email ID',
          value: 'customerEmail',
          placeholder: 'Enter Email ID',
        },
      ],
      FILTER_ITEMS: {
        reversalStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: AUTO_REFUNDS_STATUS_ITEMS,
        },
        paymentMode: {
          displayText: 'Payment Mode',
          type: CHECKBOX,
          items: AUTO_REFUNDS_PAYMENT_MODE_ITEMS,
        },
        reversalType: {
          displayText: 'Type',
          type: CHECKBOX,
          items: AUTO_REFUNDS_TYPE_ITEMS,
        },
      },
    },
  },
  [PAYMENT_LINKS]: {
    [ALL]: {
      FILTER_ITEMS: {
        orderStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: PAYMENT_LINK_ALL_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'customerPhone',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
        {
          key: 'customerEmail',
          text: 'Email ID',
          value: 'customerEmail',
          placeholder: 'Enter Email ID',
        },
        {
          key: 'referenceId',
          text: 'Link ID',
          value: 'referenceId',
          placeholder: 'Enter Link ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'id',
          text: 'CF Link ID',
          value: 'id',
          placeholder: 'Enter CF Link ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed',
        },
        {
          key: 'batchId',
          text: 'Batch ID',
          value: 'batchId',
          placeholder: 'Enter Batch ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
    [ORDERS]: {
      FILTER_ITEMS: {
        orderStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: PAYMENT_LINK_ORDERS_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'customerPhone',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
        {
          key: 'customerEmail',
          text: 'Email ID',
          value: 'customerEmail',
          placeholder: 'Enter Email ID',
        },
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter Order ID',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'paymentRequestId',
          text: 'CF Link ID',
          value: 'paymentRequestId',
          placeholder: 'Enter CF Link ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed',
        },
        {
          key: 'paymentRequestReferenceId',
          text: 'Link ID',
          value: 'paymentRequestReferenceId',
          placeholder: 'Enter Link ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
    [BATCH]: {
      FILTER_ITEMS: {
        fileStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: PAYMENT_LINK_BATCH_STATUS_ITEMS_NEW,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'batchId',
          text: 'Batch Id',
          value: 'batchId',
          placeholder: 'Enter Batch Id',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
  [SETTLEMENTS]: {
    [STANDARD]: {
      FILTER_ITEMS: {
        settlementStatus: {
          displayText: 'Status',
          type: DROPDOWN,
          items: SETTLEMENTS_STATUS_ITEMS,
        },
        settlementType: {
          displayText: 'Type',
          type: CHECKBOX,
          items: SETTLEMENTS_TYPE_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'utrNo',
          text: 'UTR No.',
          value: 'utr',
          placeholder: 'Enter UTR No.',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
    [INSTANT]: {
      FILTER_ITEMS: {
        settlementStatus: {
          displayText: 'Status',
          type: DROPDOWN,
          items: INSTANT_SETTLEMENTS_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'settlementId',
          text: 'Settlement ID',
          value: 'instantEntryId',
          placeholder: 'Enter Settlement ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
      ],
    },
    [ON_DEMAND]: {
      FILTER_ITEMS: {
        settlementStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: ON_DEMAND_SETTLEMENTS_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'settlementId',
          text: 'Settlement ID',
          value: 'settlementId',
          placeholder: 'Enter Settlement ID',
          inputPattern: '^[0-9]+$',
          error: 'Please enter a valid settlement id',
        },
        {
          key: 'utr',
          text: 'UTR No.',
          value: 'utr',
          placeholder: 'Enter UTR No.',
        },
      ],
    },
    [VENDOR]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: DROPDOWN,
          items: SETTLEMENTS_VENDOR_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'merchantVendorId',
          text: 'Vendor ID',
          value: 'merchantVendorId',
          placeholder: 'Enter Vendor ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'payoutId',
          text: 'Settlement ID',
          value: 'payoutId',
          placeholder: 'Enter Settlement ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
        {
          key: 'utr',
          text: 'UTR No.',
          value: 'utr',
          placeholder: 'Enter UTR No.',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
  'Scheduled-Reports-v2': {
    'Scheduled-Reports-v2': {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: SCHEDULE_REPORTS_STATUS_ITEMS,
        },
        reportType: {
          displayText: 'Report Type',
          type: CHECKBOX,
          items: SCHEDULE_REPORTS_TYPE_ITEMS,
        },
        frequency: {
          displayText: 'Report Schedule',
          type: CHECKBOX,
          items: SCHEDULE_REPORTS_SCHEDULE_ITEMS,
        },
        outputType: {
          displayText: 'Delivery Channel',
          type: CHECKBOX,
          items: SCHEDULE_REPORTS_DELIVERY_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'fileName',
          text: 'Report Name',
          value: 'fileName',
          placeholder: 'Enter Report Name',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
  [PRODUCT_LINKS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        isActive: {
          displayText: 'Status',
          type: DROPDOWN,
          items: PRODUCT_LINKS_STATUS_ITEMS,
        },
      },
    },
  },
  [REPORTS]: {
    [DOWNLOAD_REPORT]: {
      FILTER_ITEMS: {
        type: {
          displayText: 'Type',
          type: DROPDOWN,
          items: REPORT_FILTER_ITEMS,
        },
      },
    },
    VENDOR_REPORTS: {
      FILTER_ITEMS: {
        type: {
          displayText: 'Type',
          type: DROPDOWN,
          items: [...REPORT_FILTER_ITEMS, ...VENDOR_REPORT_FILTER_ITEMS],
        },
      },
    },
    SUB_REPORTS: {
      FILTER_ITEMS: {
        type: {
          displayText: 'Type',
          type: DROPDOWN,
          items: [...SUB_REPORT_FILTER_ITEMS],
        },
      },
    },
  },
  [OFFERS]: {
    [ALL]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: OFFERS_STATUS_ITEMS,
        },
        type: {
          displayText: 'Offer Type',
          type: CHECKBOX,
          items: OFFERS_CATEGORY_ITEMS,
        },
        paymentMethod: {
          displayText: 'Payment Modes',
          type: CHECKBOX,
          items: OFFERS_PAYMENT_MODES,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'offerCode',
          text: 'Offer Code',
          value: 'code',
          placeholder: 'Enter Offer Code',
        },
        {
          key: 'offerId',
          text: 'Offer ID',
          value: 'offerId',
          placeholder: 'Enter Offer ID',
        },
      ],
    },
    [RECOVERY_CAMPAIGN]: {},
  },
  [OFFERSV2]: {
    [ALL]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: OFFERS_STATUS_ITEMS,
        },
        type: {
          displayText: 'Offer Type',
          type: CHECKBOX,
          items: OFFERS_CATEGORY_ITEMS,
        },
        paymentMethod: {
          displayText: 'Payment Modes',
          type: CHECKBOX,
          items: OFFERS_PAYMENT_MODES,
        },
        platform: {
          displayText: 'Platform',
          type: CHECKBOX,
          items: OFFERS_PLATFORM_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'offerCode',
          text: 'Offer Code',
          value: 'code',
          placeholder: 'Enter Offer Code',
        },
        {
          key: 'offerId',
          text: 'Offer ID',
          value: 'offerId',
          placeholder: 'Enter Offer ID',
        },
      ],
    },
    [RECOVERY_CAMPAIGN]: {},
  },
  [EASY_SPLIT]: {
    [ALL]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: VENDOR_STATUS_ITEMS_MAP,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'merchantVendorId',
          text: 'Vendor ID',
          value: 'merchantVendorId',
          placeholder: 'Enter Vendor ID',
        },
      ],
    },
    [BATCH]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: PAYMENT_LINK_BATCH_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'fileName',
          text: 'File Name',
          value: 'merchantFileName',
          placeholder: 'Enter File Name',
        },
        {
          key: 'batchFileId',
          text: 'Batch File Id',
          value: 'fileId',
          placeholder: 'Enter Batch File Id',
        },
      ],
    },
    EASY_SPLIT_ALL: {
      OLD_FLOW: {
        FILTER_ITEMS: {
          status: {
            displayText: 'Status',
            type: DROPDOWN,
            items: VENDOR_STATUS_ITEMS,
          },
        },
        SEARCH_ITEMS: [
          {
            key: 'merchantVendorId',
            text: 'Vendor ID',
            value: 'merchantVendorId',
            placeholder: 'Enter Vendor ID',
            inputPattern: '^[a-zA-Z0-9_]+$',
            error: 'Only alphanumeric and underscore are allowed.',
          },
        ],
      },
      NEW_FLOW: {
        FILTER_ITEMS: {
          status: {
            displayText: 'Status',
            type: DROPDOWN,
            items: VENDOR_STATUS_ITEMS_NEW_FLOW,
          },
        },
        SEARCH_ITEMS: [
          {
            key: 'merchantVendorId',
            text: 'Vendor ID',
            value: 'merchantVendorId',
            placeholder: 'Enter Vendor ID',
            inputPattern: '^[a-zA-Z0-9_]+$',
            error: 'Only alphanumeric and underscore are allowed.',
          },
        ],
      },
    },
  },
  [EASY_SPLIT_PAYMENTS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        paymentMode: EASY_SPLIT_PAYMENTS_METHODS_FILTERS,
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Ex: Order ID 1, Order ID 2',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'cfOrderId',
          text: 'CF Order ID',
          value: 'cfOrderId',
          placeholder: 'Ex: CF Order ID 1, CF Order ID 2',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'transactionId',
          text: 'Transaction ID',
          value: 'cfTxnId',
          placeholder: 'Ex: Transaction ID 1, Transaction ID 2',
          inputPattern: '^[0-9,]+$',
          error: 'Only numbers and comma are allowed.',
        },
        {
          key: 'customerName',
          text: 'Customer Name',
          value: 'customerName',
          placeholder: 'Enter Customer Name',
          inputPattern: '^[a-zA-Z ]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'customerPhone',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
      ],
    },
  },
  [EASY_SPLIT_REFUNDS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        refundStatus: {
          displayText: 'Status',
          type: DROPDOWN,
          items: EASY_SPLIT_REFUNDS_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Ex: Order ID 1, Order ID 2',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'customerPhone',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
        {
          key: 'refundId',
          text: 'Refund ID',
          value: 'refundId',
          placeholder: 'Ex: Refund ID 1, Refund ID 2',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        // {
        //   key: 'arn',
        //   text: 'Refund ARN',
        //   value: 'arn',
        //   placeholder: 'Ex: Refund ARN 1, Refund ARN 2',
        //   inputPattern: '^[\\|\\w\\d ,.-]+$',
        //   error:
        //     'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        // },
        {
          key: 'eventId',
          text: 'CF Refund ID',
          value: 'eventId',
          placeholder: 'Ex: CF Refund ID 1, CF Refund ID 2',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        // {
        //   key: 'customerEmail',
        //   text: 'Email ID',
        //   value: 'customerEmail',
        //   placeholder: 'Enter Email ID',
        // },
      ],
    },
  },
  'Easy-Split Settlements': {
    Scheduled: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: DROPDOWN,
          items: SETTLEMENTS_VENDOR_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'merchantVendorId',
          text: 'Vendor ID',
          value: 'merchantVendorId',
          placeholder: 'Enter Vendor ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'payoutId',
          text: 'Settlement ID',
          value: 'payoutId',
          placeholder: 'Enter Settlement ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
        {
          key: 'utr',
          text: 'UTR No.',
          value: 'utr',
          placeholder: 'Enter UTR No.',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
    'On-Demand': {
      FILTER_ITEMS: {
        debitedFrom: {
          displayText: 'Debited from',
          type: CHECKBOX,
          items: DEBITED_FROM_TYPE_ITEMS,
        },
        orderAmount: SETTLEMENT_AMOUNT_FILTER,
      },
      SEARCH_ITEMS: [
        {
          key: 'merchantVendorId',
          text: 'Vendor ID',
          value: 'merchantVendorId',
          placeholder: 'Enter Vendor ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'payoutId',
          text: 'Settlement ID',
          value: 'payoutId',
          placeholder: 'Enter Settlement ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
        {
          key: 'utr',
          text: 'UTR No.',
          value: 'utr',
          placeholder: 'Enter UTR No.',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
  [EASY_SPLIT_ADJUSTMENTS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        adjustmentType: {
          displayText: 'Adjustment Type',
          type: DROPDOWN,
          items: ADJUSTMENT_TYPE_FILTERS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'eventId',
          text: 'Adjustment ID',
          value: 'eventId',
          placeholder: 'Enter Adjustment ID',
          inputPattern: '^[a-zA-Z0-9_]+$',
          error: 'Only alphanumeric and underscore are allowed.',
        },
      ],
    },
  },
  [PAYMENT_LINKS_V1]: {
    [ALL]: {
      FILTER_ITEMS: {
        orderStatus: {
          displayText: 'Status',
          type: DROPDOWN,
          items: PAYMENT_LINK_ALL_STATUS_ITEMS_V1,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter Order ID',
        },
        {
          key: 'customerPhone',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
        },
        {
          key: 'customerEmail',
          text: 'Email ID',
          value: 'customerEmail',
          placeholder: 'Enter Email ID',
        },
      ],
    },
    [BATCH]: {
      FILTER_ITEMS: {
        fileStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: PAYMENT_LINK_BATCH_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'fileName',
          text: 'File Name',
          value: 'merchantFileName',
          placeholder: 'Enter File Name',
        },
        {
          key: 'batchFileId',
          text: 'Batch File Id',
          value: 'fileId',
          placeholder: 'Enter Batch File Id',
        },
      ],
    },
  },
  [PRODUCT_DESCRIPTION]: {
    DESCRIPTION: {},
  },
  [PAYMENT_FORMS]: {
    [ALL]: {
      FILTER_ITEMS: {
        orderStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: PAYMENT_FORM_ALL_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'referenceId',
          text: 'Form ID',
          value: 'referenceId',
          placeholder: 'Enter Form ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'id',
          text: 'CF Form ID',
          value: 'id',
          placeholder: 'Enter CF Form ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed',
        },
        {
          key: 'form_url',
          text: 'Form URL',
          value: 'form_url',
          placeholder: 'Enter Form URL',
          inputPattern: '^[a-zA-Z0-9:/_.-]+$',
          error:
            'Only alphanumeric and special characters (colon, slash, underscore, dot, hyphen) are allowed.',
        },
      ],
    },
    [ORDERS]: {
      FILTER_ITEMS: {
        orderStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: PAYMENT_LINK_ORDERS_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'customerPhone',
          text: 'Phone Number',
          value: 'customerPhone',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
        {
          key: 'customerEmail',
          text: 'Email ID',
          value: 'customerEmail',
          placeholder: 'Enter Email ID',
        },
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter Order ID',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
        {
          key: 'paymentRequestId',
          text: 'CF Form ID',
          value: 'paymentRequestId',
          placeholder: 'Enter CF Form ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed',
        },
        {
          key: 'paymentRequestReferenceId',
          text: 'Form ID',
          value: 'paymentRequestReferenceId',
          placeholder: 'Enter Form ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
  [LOGS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: LOGS_STATUS_ITEMS,
        },
        webhookType: {
          displayText: 'Webhook Type',
          type: DROPDOWN,
          items: WEBHOOK_TYPE_FILTER_ITEMS,
        },
        resendStatus: {
          displayText: 'Resend Status',
          type: CHECKBOX,
          items: LOGS_RESEND_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'entityId',
          text: 'Entity ID',
          value: 'entityId',
          placeholder: 'Enter transaction id/entity id',
        },
      ],
    },
  },
  [ANALYTICS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        webhookType: {
          displayText: 'Webhook Type',
          type: DROPDOWN,
          items: WEBHOOK_TYPE_FILTER_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'endpointUrl',
          text: 'Url',
          value: 'endpointUrl',
          placeholder: 'Enter Url',
        },
      ],
    },
  },
  [QR_CODE]: {
    [DEFAULT]: {
      // FILTER_ITEMS: {
      //   statuses: {
      //     displayText: 'Status',
      //     type: CHECKBOX,
      //     items: QR_CODE_STATUS_ITEMS,
      //   },
      // },
      SEARCH_ITEMS: [
        {
          key: 'name',
          text: 'QR Code Name',
          value: 'name',
          placeholder: 'Enter QR Code Name',
          // Validations and error message
          inputPattern: '^[a-zA-Z0-9]+$',
          error: 'Only alphanumeric characters are allowed.',
        },
        // {
        //   key: 'merchantVPA',
        //   text: 'VPA',
        //   value: 'merchantVPA',
        //   placeholder: 'Enter VPA',
        //   // Validations and error message
        //   inputPattern: '^[a-zA-Z0-9@_.]+$',
        //   error:
        //     'Only alphanumeric and special characters (@, underscore, dot) are allowed.',
        // },
      ],
    },
  },
  PAYMENT_METHODS: {
    [DEFAULT]: {
      hideSearchDropdown: true,
      SEARCH_ITEMS: [
        {
          key: 'paymentMethodName',
          text: '',
          value: 'paymentMethodName',
          placeholder: 'Enter payment method name',
          // Validations and error message
          inputPattern: '^[a-zA-Z ]+$',
          error: 'Only alphabets and space are allowed.',
        },
      ],
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: PAYMENT_METHOD_STATUS_ITEMS,
        },
      },
    },
  },
  [COLLECTION_POINT_MANAGEMENT]: {
    [ALL_COLLECTION_POINTS]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: QR_CODE_STATUS_ITEMS,
        },
        terminalType: {
          displayText: 'Collection Point Type',
          type: CHECKBOX,
          items: COLLECTION_POINT_TYPE_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'agentName',
          text: 'Collection Point Name',
          value: 'agentName',
          placeholder: 'Enter Name',
          inputPattern: '^[a-zA-Z0-9\\-_.\\$&\\/ ]+$',
          error:
            'Only alphabets, numbers, and special characters (space, -, _, ., $, &, /) are allowed.',
        },
        {
          key: 'agentMobileNo',
          text: 'Phone Number',
          value: 'agentMobileNo',
          placeholder: 'Enter Phone Number',
          inputPattern: '^[0-9 +-]+$',
          maxLength: 14,
          error:
            'Only numbers and special characters (space, plus, hyphen) are allowed.',
        },
      ],
    },
    [BATCH_AGENTS]: {
      FILTER_ITEMS: {
        fileStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: EPOS_BATCH_STATUS_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'fileId',
          text: 'File ID',
          value: 'fileId',
          placeholder: 'Enter File ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed.',
        },
      ],
    },
  },
  [INCIDENTS]: {
    [DEFAULT]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: DROPDOWN,
          items: PG_INCIDENTS_STATUS,
        },
        incidentImpact: {
          displayText: 'Severity',
          type: CHECKBOX,
          items: PG_INCIDENTS_SEVERITY,
        },
        incidentType: {
          displayText: 'Incident Type',
          type: CHECKBOX,
          items: PG_INCIDENTS_TYPE,
        },
        incidentPaymentMode: {
          displayText: 'Payment Mode',
          type: CHECKBOX,
          items: PG_INCIDENTS_PAYMENT_MODE,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'incidentId',
          text: 'Incident ID',
          value: 'incidentId',
          placeholder: 'Enter Incident ID',
          inputPattern: '^[\\|\\w\\d ,.-]+$',
          error:
            'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
        },
      ],
    },
  },
  [CUSTOMERS]: {
    [CUSTOMER_ACTIVE]: {
      FILTER_ITEMS: {
        spendTag: {
          displayText: 'Spend Tag',
          type: CHECKBOX,
          items: CUSTOMERS_ACTIVE_SPEND_TAG_ITEMS,
        },
        preferredMode: {
          displayText: 'Preferred Mode',
          type: DROPDOWN,
          items: CUSTOMERS_ACTIVE_PREFERRED_MODE,
        },
        totalTransactions: TOTAL_TRANSACTIONS_FILTER,
        totalSpends: TOTAL_SPENDS_FILTER,
      },
      SEARCH_ITEMS: [
        {
          key: 'phone',
          text: 'Phone No.',
          value: 'phone',
          placeholder: 'Enter Phone No.',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed',
        },
        {
          key: 'email',
          text: 'Email ID',
          value: 'email',
          placeholder: 'Enter Email ID',
        },
      ],
    },
    [CUSTOMER_UNFULFILLED]: {
      FILTER_ITEMS: {
        totalTransactions: TOTAL_TRANSACTIONS_FILTER,
        totalSpends: TOTAL_SPENDS_FILTER,
      },
      SEARCH_ITEMS: [
        {
          key: 'phone',
          text: 'Phone No.',
          value: 'phone',
          placeholder: 'Enter Phone No.',
          inputPattern: '^[0-9]+$',
          error: 'Only numbers are allowed',
        },
        {
          key: 'email',
          text: 'Email ID',
          value: 'email',
          placeholder: 'Enter Email ID',
        },
      ],
    },
  },
  [API_LOGS]: {
    [API_LOGS]: {
      SEARCH_ITEMS: [
        {
          key: 'x_request_id',
          text: 'X Request ID',
          value: 'x_request_id',
          placeholder: 'Enter X Request ID',
        },
        {
          key: 'order_id',
          text: 'Order ID',
          value: 'order_id',
          placeholder: 'Enter Order ID',
        },
      ],
    },
  },
  [API_ALERTS]: {
    [API_ALERTS]: {
      hideSearchItems: true,
      FILTER_ITEMS: {
        filter: {
          displayText: 'API',
          type: DROPDOWN,
          items: PATH_DROPDOWN_OPTIONS,
        },
        alertRuleStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: API_ALERT_RULES_STATUS,
        },
        ruleTypes: {
          displayText: 'Rule Type',
          type: CHECKBOX,
          items: API_ALERT_RULE_TYPE,
        },
      },
    },
  },
  Wallets: {
    refund: {
      FILTER_ITEMS: {
        saleType: {
          displayText: 'Event Type',
          type: CHECKBOX,
          items: EVENT_TYPE_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'eventId',
          text: 'Event ID',
          value: 'eventId',
          placeholder: 'Enter Event ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'utr',
          text: 'UTR',
          value: 'utr',
          placeholder: 'Enter UTR',
          inputPattern: '^[a-zA-Z0-9]+$',
          error: 'Only alphanumeric characters are allowed.',
        },
      ],
    },
    fee: {
      FILTER_ITEMS: {
        saleType: {
          displayText: 'Event Type',
          type: CHECKBOX,
          items: FEE_WALLET_EVENT_TYPE_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'eventId',
          text: 'Event ID',
          value: 'eventId',
          placeholder: 'Enter Event ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'utr',
          text: 'UTR',
          value: 'utr',
          placeholder: 'Enter UTR',
          inputPattern: '^[a-zA-Z0-9]+$',
          error: 'Only alphanumeric characters are allowed.',
        },
      ],
    },
  },
  ROUTER: {
    UPFRONT_TDR: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: UPFRONT_TDR_STATUS,
        },
      },
      SEARCH_ITEMS: [],
    },
    [GATEWAYS]: {
      FILTER_ITEMS: {
        env: {
          displayText: 'Environment',
          type: CHECKBOX,
          items: { PROD: 'Prod', TEST: 'Test' },
        },
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: { ACTIVE: 'Active', INACTIVE: 'Inactive' },
        },
      },
      hideSearchItems: true,
    },
    [GATEWAYS_CONFIGURATION]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: RULE_STATUS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'name',
          text: 'Configuration Name',
          value: 'name',
          placeholder: 'Enter Configuration Name',
        },
      ],
    },
    [SETTLEMENT_ROUTER_RECON]: {
      FILTER_ITEMS: {},
      SEARCH_ITEMS: [
        {
          key: 'utr',
          text: 'UTR',
          value: 'utr',
          placeholder: 'Enter Utl.',
        },
        {
          key: 'settlementId',
          text: 'Settlement Id',
          value: 'settlementId',
          placeholder: 'Enter Settlement ID',
        },
      ],
    },
    [SETTLEMENT_ROUTER_SALE]: {
      FILTER_ITEMS: {
        paymentMode: {
          displayText: 'Payment Modes',
          type: CHECKBOX,
          items: PAYMENT_MODES_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter Order ID',
        },
        {
          key: 'gatewayTxnId',
          text: 'PG Transaction ID',
          value: 'gatewayTxnId',
          placeholder: 'Enter PG Transaction ID',
        },
      ],
    },
    [SETTLEMENT_ROUTER_ADJUSTMENTS]: {
      FILTER_ITEMS: {
        txnType: {
          displayText: 'Event',
          type: CHECKBOX,
          items: TRANSACTION_ITEMS,
        },
        paymentMode: {
          displayText: 'Payment Modes',
          type: CHECKBOX,
          items: PAYMENT_MODES_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'orderId',
          text: 'Order ID',
          value: 'orderId',
          placeholder: 'Enter Order ID',
        },
        {
          key: 'gatewayTxnId',
          text: 'PG Transaction ID',
          value: 'gatewayTxnId',
          placeholder: 'Enter PG Transaction ID',
        },
        {
          key: 'gatewayTxnId',
          text: 'PG Adjustment ID',
          value: 'gatewayTxnId',
          placeholder: 'Enter PG Adjustment ID',
        },
      ],
    },
    [SETTLEMENT_ROUTER_ANAMOLY_SALE]: {
      FILTER_ITEMS: {
        paymentMode: {
          displayText: 'Payment Modes',
          type: CHECKBOX,
          items: PAYMENT_MODES_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'gatewayTxnId',
          text: 'PG Transaction ID',
          value: 'gatewayTxnId',
          placeholder: 'Enter PG Transaction ID',
        },
        {
          key: 'gatewayTxnId',
          text: 'PG Adjustment ID',
          value: 'gatewayTxnId',
          placeholder: 'Enter PG Adjustment ID',
        },
      ],
    },
    [SETTLEMENT_ROUTER_ANAMOLY_ADJUSTMENTS]: {
      FILTER_ITEMS: {
        txnType: {
          displayText: 'Event',
          type: CHECKBOX,
          items: TRANSACTION_ITEMS,
        },
        paymentMode: {
          displayText: 'Payment Modes',
          type: CHECKBOX,
          items: PAYMENT_MODES_ITEMS,
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'gatewayTxnId',
          text: 'PG Transaction ID',
          value: 'gatewayTxnId',
          placeholder: 'Enter PG Transaction ID',
        },
        {
          key: 'gatewayTxnId',
          text: 'PG Adjustment ID',
          value: 'gatewayTxnId',
          placeholder: 'Enter PG Adjustment ID',
        },
      ],
    },
  },
  [RATE_LIMITS]: {
    [RATE_LIMITS]: {
      hideSearchItems: true,
      FILTER_ITEMS: {
        api: {
          displayText: 'API',
          type: DROPDOWN,
          items: PATH_DROPDOWN_OPTIONS,
        },
        merchantRateLimitRequest: {
          displayText: 'Limit Update Requests',
          type: CHECKBOX,
          items: MERCHANT_RL_UPDATE_REQUESTS,
        },
        violationCount: {
          displayText: 'Violation Count',
          type: CHECKBOX,
          items: RATE_LIMIT_VIOLATION_COUNT,
        },
      },
    },
  },
  [VBA_CONFIGURATION]: {
    [VBA_ACCOUNTS]: {
      SEARCH_ITEMS: [
        { key: 'vAccountId', text: 'Virtual A/c ID', value: 'vAccountId' },
        { key: 'name', text: 'A/c Holder’s Name', value: 'name' },
        { key: 'phone', text: 'Phone Number', value: 'phone' },
      ],
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: {
            ACTIVE: 'Active',
            INACTIVE: 'Inactive',
          },
        },
      },
    },
    [NOTIFICATION_GROUPS]: {},
  },
  [PAYMENT_VERIFICATION]: {
    [ACTION_REQUIRED]: {
      FILTER_ITEMS: {},
      SEARCH_ITEMS: [],
    },
    [UNDER_REVIEW]: {
      FILTER_ITEMS: {},
      SEARCH_ITEMS: [],
    },
    [VERIFIED]: {
      FILTER_ITEMS: {},
      SEARCH_ITEMS: [],
    },
    [EXPIRED]: {
      FILTER_ITEMS: {},
      SEARCH_ITEMS: [],
    },
    [ALL]: {
      FILTER_ITEMS: {},
      SEARCH_ITEMS: [],
    },
  },
  [SHIPPING_DELIVERY]: {
    'Standard Shipping': SHIPPING_FILTER_ITEMS,
    'Express Shipping': SHIPPING_FILTER_ITEMS,
    'Add Rule': {
      SEARCH_ITEMS: [
        {
          key: 'pincodes',
          text: 'Pincode',
          value: 'pincodes',
          placeholder: 'Enter pincode',
        },
      ],
    },
  },
  [OCC_ANALYTICS]: {
    [OFFERS_ANALYTICS]: {
      FILTER_ITEMS: {
        offerType: {
          displayText: 'Offer Category',
          type: CHECKBOX,
          items: OFFERS_CATEGORY_ITEMS,
        },
        offerValueType: {
          displayText: 'Offer Type',
          type: CHECKBOX,
          items: OFFERS_TYPE_ITEMS,
        },
      },
    },
  },
  [PLANS]: {
    [ALL]: {
      FILTER_ITEMS: {
        planType: {
          displayText: 'Plan Type',
          type: CHECKBOX,
          items: {
            PERIODIC: 'Periodic',
            ON_DEMAND: 'On Demand',
          },
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'planId',
          text: 'Plan ID',
          value: 'planId',
          placeholder: 'Enter Plan ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
  [BATCH]: {
    BATCH_SUBSCRIPTIONS: {
      FILTER_ITEMS: {
        fileStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: {
            INITIALIZED: 'Initialized',
            FAILED: 'Failed',
            REJECTED: 'Rejected',
            ACTION_REQUIRED: 'Action Required',
            CANCELLED: 'Cancelled',
            PENDING: 'Pending',
            COMPLETED: 'Completed',
          },
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'fileId',
          text: 'File ID',
          value: 'fileId',
          placeholder: 'Enter File ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
    BATCH_AMOUNT: {
      FILTER_ITEMS: {
        fileStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: {
            INITIALIZED: 'Initialized',
            FAILED: 'Failed',
            REJECTED: 'Rejected',
            ACTION_REQUIRED: 'Action Required',
            CANCELLED: 'Cancelled',
            PENDING: 'Pending',
            COMPLETED: 'Completed',
          },
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'fileId',
          text: 'File ID',
          value: 'fileId',
          placeholder: 'Enter File ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
    IMPORT_MANDATES: {
      FILTER_ITEMS: {
        fileStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: {
            INITIALIZED: 'Initialized',
            FAILED: 'Failed',
            REJECTED: 'Rejected',
            ACTION_REQUIRED: 'Action Required',
            CANCELLED: 'Cancelled',
            PENDING: 'Pending',
            COMPLETED: 'Completed',
          },
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'fileId',
          text: 'File ID',
          value: 'fileId',
          placeholder: 'Enter File ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
    BATCH_PNACH: {
      FILTER_ITEMS: {
        fileStatus: {
          displayText: 'Status',
          type: CHECKBOX,
          items: {
            INITIALIZED: 'Initialized',
            FAILED: 'Failed',
            REJECTED: 'Rejected',
            ACTION_REQUIRED: 'Action Required',
            CANCELLED: 'Cancelled',
            PENDING: 'Pending',
            COMPLETED: 'Completed',
          },
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'fileId',
          text: 'File ID',
          value: 'fileId',
          placeholder: 'Enter File ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
  [SUBSCRIPTIONS]: {
    [ALL]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: {
            ACTIVE: 'Active',
            FAILED: 'Failed',
            COMPLETED: 'Completed',
            INITIALIZED: 'Initialized',
            CANCELLED: 'Cancelled',
            CUSTOMER_CANCELLED: 'Customer Cancelled',
            ON_HOLD: 'On Hold',
            LINK_EXPIRED: 'Link Expired',
            CUSTOMER_PAUSED: 'Customer Paused',
            PAUSED: 'Paused',
            BANK_APPROVAL_PENDING: 'Bank Approval Pending',
          },
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'subscriptionId',
          text: 'Subscription ID',
          value: 'subscriptionId',
          placeholder: 'Enter Subscription ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
  [SUBSCRIPTIONS_DETAILS]: {
    [ALL]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: {
            INITIALIZED: 'Initialized',
            PENDING: 'Pending',
            SUCCESS: 'Success',
            FAILED: 'Failed',
            CANCELLED: 'Cancelled',
            INCOMPLETE: 'Incomplete',
          },
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'subscriptionId',
          text: 'Subscription ID',
          value: 'subscriptionId',
          placeholder: 'Enter Subscription ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
  [SUBSCRIPTION_PAYMENTS]: {
    [ALL]: {
      FILTER_ITEMS: {
        status: {
          displayText: 'Status',
          type: CHECKBOX,
          items: {
            INITIALIZED: 'Initialized',
            PENDING: 'Pending',
            SUCCESS: 'Success',
            FAILED: 'Failed',
            CANCELLED: 'Cancelled',
            INCOMPLETE: 'Incomplete',
          },
        },
      },
      SEARCH_ITEMS: [
        {
          key: 'paymentId',
          text: 'Payment ID',
          value: 'paymentId',
          placeholder: 'Enter Payment ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
        {
          key: 'cfTxnId',
          text: 'CF Txn ID',
          value: 'cfTxnId',
          placeholder: 'Enter CF Txn ID',
          inputPattern: '^[0-9]+$',
          error: 'Only numeric characters are allowed.',
        },
        {
          key: 'subReferenceId',
          text: 'Sub. Ref. ID',
          value: 'subReferenceId',
          placeholder: 'Enter Sub. Ref. ID',
          inputPattern: '^[a-zA-Z0-9_-]+$',
          error:
            'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
        },
      ],
    },
  },
};

export const DEFAULT_DATE_OPTIONS = [
  {
    displayText: 'Today',
    range: [
      moment()
        .startOf('day')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Last 7 days',
    range: [
      moment()
        .subtract(6, 'days')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'This Month',
    range: [
      moment()
        .startOf('month')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Last Month',
    range: [
      moment()
        .subtract(1, 'month')
        .startOf('month')
        .toDate(),
      moment()
        .subtract(1, 'month')
        .endOf('month')
        .toDate(),
    ],
  },
];

export const DEFAULT_V2_DATE_PRESET_LABEL = 'Last 15 days';

export const DEFAULT_DATE_OPTIONS_V2 = [
  {
    displayText: 'Today',
    range: [
      moment()
        .startOf('day')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Last 7 days',
    range: [
      moment()
        .subtract(6, 'days')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Last 15 days',
    range: [
      moment()
        .subtract(14, 'days')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'This Month',
    range: [
      moment()
        .startOf('month')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Last Month',
    range: [
      moment()
        .subtract(1, 'month')
        .startOf('month')
        .toDate(),
      moment()
        .subtract(1, 'month')
        .endOf('month')
        .toDate(),
    ],
  },
];

export const DATE_OPTIONS_CUSTOMERS = [
  {
    displayText: 'Last 7 days',
    range: [
      moment()
        .subtract(7, 'days')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Last 30 days',
    range: [
      moment()
        .subtract(30, 'days')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
];

export const DATE_OPTIONS_SUBS = [
  {
    displayText: 'Last 7 days',
    range: [
      moment()
        .subtract(7, 'days')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Last 15 days',
    range: [
      moment()
        .subtract(15, 'days')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Last 30 days',
    range: [
      moment()
        .subtract(30, 'days')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Last 1 year',
    range: [
      moment()
        .subtract(366, 'days')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
];

export const DATE_FILTER_RANGE_SIZE_SUBS = 366;

export const DEFAULT_DATE_TIME_PAYLOAD_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const CURRENCY_OPTIONS = [
  { key: 'INR', text: 'INR', value: 'INR', symbol: '₹' },
  { key: 'USD', text: 'USD', value: 'USD', symbol: '$' },
  { key: 'BDT', text: 'BDT', value: 'BDT' },
  { key: 'GBP', text: 'GBP', value: 'GBP' },
  { key: 'AED', text: 'AED', value: 'AED' },
  { key: 'AUD', text: 'AUD', value: 'AUD' },
  { key: 'BHD', text: 'BHD', value: 'BHD' },
  { key: 'CAD', text: 'CAD', value: 'CAD' },
  { key: 'CHF', text: 'CHF', value: 'CHF' },
  { key: 'DKK', text: 'DKK', value: 'DKK' },
  { key: 'EUR', text: 'EUR', value: 'EUR' },
  { key: 'HKD', text: 'HKD', value: 'HKD' },
  { key: 'JPY', text: 'JPY', value: 'JPY' },
  { key: 'KES', text: 'KES', value: 'KES' },
  { key: 'KWD', text: 'KWD', value: 'KWD' },
  { key: 'LKR', text: 'LKR', value: 'LKR' },
  { key: 'MUR', text: 'MUR', value: 'MUR' },
  { key: 'MYR', text: 'MYR', value: 'MYR' },
  { key: 'NOK', text: 'NOK', value: 'NOK' },
  { key: 'NPR', text: 'NPR', value: 'NPR' },
  { key: 'NZD', text: 'NZD', value: 'NZD' },
  { key: 'OMR', text: 'OMR', value: 'OMR' },
  { key: 'QAR', text: 'QAR', value: 'QAR' },
  { key: 'SAR', text: 'SAR', value: 'SAR' },
  { key: 'SEK', text: 'SEK', value: 'SEK' },
  { key: 'SGD', text: 'SGD', value: 'SGD' },
  { key: 'THB', text: 'THB', value: 'THB' },
  { key: 'ZAR', text: 'ZAR', value: 'ZAR' },
  { key: 'N/A', text: 'INR', value: 'INR', symbol: '₹' },
];

export const CURRENCY_SYMBOL = {
  INR: '₹',
  USD: '$',
  BDT: '৳',
  GBP: '£',
  AED: 'د.إ',
  AUD: '$',
  BHD: 'BD',
  CAD: '$',
  CHF: 'CHf',
  DKK: 'Kr.',
  EUR: '€',
  HKD: '$',
  JPY: '¥',
  KES: 'K',
  KWD: 'KD',
  LKR: 'Rs',
  MUR: 'Rs',
  MYR: 'RM',
  NOK: 'kr',
  NPR: 'Rs',
  NZD: '$',
  OMR: 'ر.ع.',
  QAR: 'QR',
  SAR: 'SR',
  SEK: 'kr',
  SGD: '$',
  THB: '฿',
  ZAR: 'R',
};

export const PERCENTAGE_SYMBOL = '%';

export const INDIAN_CURRENCY = [{ key: 'INR', text: 'INR (₹)', value: 'INR' }];

export const HOUR_FACTOR = 4;

export const AUTHENTICATION_MODALS = [
  'VERIFY_PASSWORD',
  'VERIFY_OTP',
  'VERIFY_G2FA',
  'SAR_PENDING',
];

export const ICICIMERCHANT = 'ICICIMERCHANT';

export const AXISEASYPAYPLUS = 'AXISEASYPAYPLUS';

export const YESMERCHANT = 'YESMERCHANT';

export const LENDINGKARTMERCHANT = 'LENDINGKART';

export const IDFCMERCHANT = 'IDFC';

export const WHITELABELEDMERCHANT = 'WHITELABELEDMERCHANT';

export const MERCHANT_TEST = 'MERCHANT-TEST';

export const CSBMERCHANT = 'CSBMERCHANT';

export const IDBIMERCHANT = 'IDBIMERCHANT';

export const IMPORTS_TEST_MERCHANT = 'IMPORTS_TEST_MERCHANT';

export const IMPORTS_PROD_MERCHANT = 'IMPORTS_PROD_MERCHANT';

export const FRESHSALES_LEAD_SOURCE_ID = {
  PARTNER: 9000254840,
  ICICI: 9000322726,
  YESBANK: 9000322762,
  YESMERCHANT: 9000322762,
  DEFAULT: 9000274724,
  ICICIMERCHANT: 9000322726,
  PROD: 9000322726,
  [MERCHANT_TEST]: 9000322726,
  // This is default value for leadSourceId used in backend.
  AXISEASYPAYPLUS: 9000254828,
};

export const GLOBAL_SIDEBAR_MAPPING = {
  payout: {
    title: 'Payouts',
    key: 'CSP',
    url: '/payout?iframe=1#summary',
  },
  settlements: {
    title: 'Marketplace Settlements',
    key: 'CES',
    url: '/ces?iframe=1#summary',
  },
};

// Can be removed once all are true
export const USE_SUBSCRIPTIONS_NEW_PAGES = {
  [PLANS]: true,
  [ALL_SUBSCRIPTIONS]: true,
  [PAYMENTS]: true,
  [BULK_CREATE_SUBSCRIPTIONS]: false,
  [BULK_PAYMENTS]: false,
  [IMPORT_MANDATES]: false,
  [TEST_WEBHOOK]: false,
};

export const SUBSCRIPTIONS_IFRAME_CONFIG = {
  [ALL_SUBSCRIPTIONS]: {
    title: 'All Subscriptions',
    key: 'SBC.View',
    url: 'subscriptions/all-subscriptions',
  },
  [BULK_CREATE_SUBSCRIPTIONS]: {
    title: 'Bulk Create Subscriptions',
    key: 'SBC.BulkCreate',
    url: 'subscriptions/bulk-create-subscriptions',
  },
  [PAYMENTS]: {
    title: 'Payments',
    key: 'SBC.Payments',
    url: 'subscriptions/payments',
  },
  [BULK_PAYMENTS]: {
    title: 'Bulk Payments',
    key: 'SBC.Bulk',
    url: 'subscriptions/bulk-payments',
  },
  [PLANS]: {
    title: 'Plans',
    key: 'SBC.Plans',
    url: 'subscriptions/plans',
  },
  [IMPORT_MANDATES]: {
    title: 'Import Mandates',
    key: 'SBC.Mandates',
    url: 'subscriptions/import-mandates',
  },
  [TEST_WEBHOOK]: {
    title: 'Test Webhook',
    key: 'SBC.Webhook',
    url: 'subscriptions/test-webhook',
  },
};

export const GLOBAL_SIDEBAR_PRODUCT_ITEM_CONFIGURATION = [
  {
    key: 'subscriptions',
    visible: true,
  },
];

export const GLOBAL_SIDEBAR_CONTROL_ITEM_CONFIGURATION = () => [
  {
    key: 'subscriptions',
    visible: true,
  },
  {
    key: 'notification',
    visible: true,
    label: 'Try',
  },
  {
    key: 'developers',
    visible: true,
    label: 'Try',
  },
  {
    key: 'Workflows',
    visible: true,
    label: 'New',
  },
];

export const PUBLIC_URLS = [
  '/common/signup/password',
  '/common/signup/google',
  '/common/signin/password',
  '/common/alias/signin/password',
  '/common/signin/google',
  '/common/forgot-password/send',
  '/common/forgot-password/validate',
  '/common/forgot-password/reset',
  '/common/pincode',
];

export const FETCH_GAMMA_TOKEN_URL = {
  method: 'GET',
  url: '/common/gamma/token',
};

export const STATUS_PAGE_URL = 'https://status.cashfree.com/';

export const USER_GUIDE_URL = 'https://www.cashfree.com/docs/';

export const LOGO_URL =
  'https://cashfreelogo.cashfree.com/cashfreepayments/logopng4x';

export const OLD_LOGO_URL =
  'https://cashfreelogo.cashfree.com/merchant/referrer';

export const LOGO_MAPPING = {
  ICICI: `${OLD_LOGO_URL}/icici.png`,
  YESBANK: `${OLD_LOGO_URL}/yesbank.png`,
  YESMERCHANT: `${OLD_LOGO_URL}/yesbank.png`,
  LENDINGKARTMERCHANT: `${OLD_LOGO_URL}/lendingkart.png`,
  ICICIMERCHANT: `${OLD_LOGO_URL}/Cashfree_EasypayPro+_Logo.png`,
  IDFCMERCHANT: `${OLD_LOGO_URL}/Cashfree_Idfc_Logo.png`,
  // TODO: Update CSB and IDBI logos - currently using ICICI and IDFC as placeholder
  CSBMERCHANT: `${OLD_LOGO_URL}/CF_CSB_LOGO.png`, // TODO: Replace with CSB bank logo
  IDBIMERCHANT: `${OLD_LOGO_URL}/cf_idbi_merchant_logo.png`,
  [MERCHANT_TEST]: `${OLD_LOGO_URL}/Cashfree_EasypayPro+_Logo.png`,
  MERCHANT: `${LOGO_URL}/Cashfree_Payments_Logo.png`,
  PROD: `${OLD_LOGO_URL}/icici.png`,
  XS: xsLogoSmall,
  ICICIMERCHANT_XS: `${OLD_LOGO_URL}/Eazypay_icon.png`,
  LENDINGKARTMERCHANT_XS: `${OLD_LOGO_URL}/lendingkart_icon.png`,
  [AXISEASYPAYPLUS]: `${OLD_LOGO_URL}/axis_easypayplus_logo.svg`,
  [`${AXISEASYPAYPLUS}_WHITE`]: `${OLD_LOGO_URL}/axis_easypayplus_white_logo.svg`,
};

export const PAYPAL_SIGNIN_URL = 'https://www.paypal.com/in/signin';

export const PAYTM_SIGNIN_URL = 'https://dashboard.paytm.com/login/';

export const REFUND_TYPE_MAPPER = {
  PARTIAL_REFUND: {
    label: 'P',
    text: {
      SUCCESS: 'Partially Refunded',
      PENDING: 'Partial Refund Pending',
    },
  },
  COMPLETE_REFUND: {
    label: 'R',
    text: {
      SUCCESS: 'Refunded',
      PENDING: 'Refund Pending',
    },
  },
};

export const PAYMENT_METHODS_MAXIMUM_LIMIT = {
  AMT_CASH: '10000',
  AMT_LINK: '1000000',
  AMT_QR: '100000',
  AMT_TAP: '5000',
  AMT_CARDLESS_EMI: '500000',
};

export const HOLIDAYS_DATA_2025 = [
  {
    date: '19 February',
    title: 'Chhatrapati Shivaji Maharaj Jayanti',
  },
  {
    date: '26 February',
    title: 'Mahashivratri',
  },
  {
    date: '14 March',
    title: 'Holi (Second Day)',
  },
  {
    date: '31 March',
    title: 'Ramzan-Id (Id-Ul-Fitr) (Shawal-1)',
  },
  {
    date: '1 April',
    title: 'Closure of bank books for the financial year',
  },
  {
    date: '10 April',
    title: 'Mahavir Janmakalyanak',
  },
  {
    date: '14 April',
    title: 'Dr. B. R. Ambedkar Jayanti',
  },
  {
    date: '18 April',
    title: 'Good Friday',
  },
  {
    date: '1 May',
    title: 'Maharashtra Din',
  },
  {
    date: '12 May',
    title: 'Buddha Purnima',
  },
  {
    date: '7 June',
    title: "Id-Ul-Ad'ha (Bakrid)",
  },
  {
    date: '15 August',
    title: 'Independence Day/ Parsi New Year (Shahenshahi)',
  },
  {
    date: '27 August',
    title: 'Ganesh Chaturthi',
  },
  {
    date: '5 September',
    title: 'Id-E-Milad',
  },
  {
    date: '2 October',
    title: 'Mahatma Gandhi Jayanti/ Dasara',
  },
  {
    date: '21 October',
    title: 'Diwali Amavasya (Laxmi Pujan)',
  },
  {
    date: '22 October',
    title: 'Diwali (Bali Pratipada)',
  },
  {
    date: '5 November',
    title: 'Guru Nanak Jayanti',
  },
  {
    date: '25 December',
    title: 'Christmas',
  },
];

export const SETTLEMENT_SUMMARY_URL =
  'https://www.cashfree.com/instant-settlements?utm_source=in-app&utm_medium=internal-referral&utm_campaign=instantsettlements&utm_content=summary-holiday';

export const SETTLEMENT_NORMAL_DAY_URL =
  'https://www.cashfree.com/instant-settlements?utm_source=in-app&utm_medium=internal-referral&utm_campaign=instantsettlements&utm_content=settlements-normalday';

export const SETTLEMENT_HOLIDAY_URL =
  'https://www.cashfree.com/instant-settlements?utm_source=in-app&utm_medium=internal-referral&utm_campaign=instantsettlements&utm_content=settlements-holiday';

export const NAVIGATION_BAR_OPTIONS = {
  [PAYMENTS]: [
    {
      key: 'all',
      text: ALL,
    },
    {
      key: 'batch-capture',
      text: BATCH_CAPTURE,
    },
  ],
  Analytics: [
    {
      key: 'business-trends',
      text: 'Business Trends',
    },
    {
      key: 'conversion-rate',
      text: 'Conversion Rate',
    },
  ],
  [REFUNDS]: [
    {
      key: 'initiated-refunds',
      text: INITIATED_REFUNDS,
    },
    {
      key: 'batch-refunds',
      text: BATCH_REFUNDS,
    },
    {
      key: 'auto-refunds',
      text: AUTO_REFUNDS,
    },
  ],
  'Easy-Split Settlements': [
    {
      key: 'scheduled',
      text: 'Scheduled',
    },
    {
      key: 'on-demand',
      text: 'On-Demand',
    },
  ],
  [TRANSACTIONS]: [
    {
      key: 'payments',
      text: PAYMENTS,
    },
    {
      key: 'orders',
      text: ORDERS,
    },
    {
      key: 'refunds',
      text: REFUNDS,
    },
    {
      key: 'disputes',
      text: DISPUTES,
    },
    {
      key: 'suspicious',
      text: SUSPICIOUS,
    },
    {
      key: 'batch-refunds',
      text: 'Batch Refunds',
    },
    {
      key: 'initiated-refunds',
      text: 'Initiated Refunds',
    },
    {
      key: 'auto-refunds',
      text: 'Auto Refunds',
    },
    {
      key: 'actionRequired',
      text: 'Action Required',
    },
    {
      key: 'underReview',
      text: 'Under Review',
    },
    {
      key: 'closed',
      text: 'Closed',
    },
    {
      key: 'allDisputes',
      text: 'All Disputes',
    },
    {
      key: 'all',
      text: ALL,
    },
    {
      key: 'batch-capture',
      text: 'Batch Capture',
    },
  ],
  [PAYMENT_LINKS]: [
    {
      key: 'all',
      text: ALL,
    },
    {
      key: 'batch',
      text: BATCH,
    },
    {
      key: 'orders',
      text: ORDERS,
    },
  ],
  [CUSTOMERS]: [
    {
      key: 'active',
      text: CUSTOMER_ACTIVE,
    },
    {
      key: 'unfulfilled',
      text: CUSTOMER_UNFULFILLED,
    },
  ],
  [PAYMENT_FORMS]: [
    {
      key: 'all',
      text: ALL,
    },
    {
      key: 'orders',
      text: ORDERS,
    },
  ],
  [PAYMENT_LINKS_V1]: [
    {
      key: 'all',
      text: ALL,
    },
    {
      key: 'batch',
      text: BATCH,
    },
  ],
  [EASY_SPLIT]: [
    {
      key: 'vendors',
      text: VENDORS,
    },
    {
      key: 'transactions',
      text: 'Transactions',
    },
    {
      key: 'refunds',
      text: REFUNDS,
    },
    {
      key: 'settlements',
      text: 'Settlements',
    },
    {
      key: 'adjustments',
      text: ADJUSTMENTS,
    },
    {
      key: 'scheduled',
      text: 'Scheduled',
    },
    {
      key: 'on-demand',
      text: 'On-Demand',
    },
  ],
  [SETTLEMENTS]: [
    {
      key: 'standard',
      text: STANDARD,
    },
    {
      key: 'on-demand',
      text: ON_DEMAND,
    },
    {
      key: 'vendor',
      text: VENDOR,
    },
    // {
    //   key: 'instant',
    //   text: INSTANT,
    // },
  ],
  [PRODUCT_LINKS]: [],
  [PRODUCT_DESCRIPTION]: [],
  [REPORTS]: [
    {
      key: 'download',
      text: DOWNLOAD_REPORT,
    },
    {
      key: 'schedule',
      text: SCHEDULE_REPORT,
    },
  ],
  [ROUTER]: [
    {
      key: 'gateways',
      text: GATEWAYS,
    },
    {
      key: 'configure',
      text: GATEWAYS_CONFIGURATION,
    },
    {
      key: 'upfront-tdr',
      text: UPFRONT_TDR,
    },
  ],
  [SOFTPOS]: [
    {
      key: 'collection-point-management',
      text: COLLECTION_POINT_MANAGEMENT,
    },
    {
      key: 'payment-methods',
      text: PAYMENT_METHODS,
    },
    {
      key: 'all-collection-points',
      text: ALL_COLLECTION_POINTS,
    },
    {
      key: 'batch',
      text: BATCH_AGENTS,
    },
  ],
  [COLLECTION_POINT_MANAGEMENT]: [
    {
      key: 'all-collection-points',
      text: ALL_COLLECTION_POINTS,
    },
    {
      key: 'batch',
      text: BATCH_AGENTS,
    },
  ],
  [SUBSCRIPTIONS]: [
    {
      key: 'all-subscriptions',
      text: ALL_SUBSCRIPTIONS,
    },
    {
      key: 'bulk-create-subscriptions',
      text: BULK_CREATE_SUBSCRIPTIONS,
    },
    {
      key: 'transactions',
      text: PAYMENTS,
    },
    {
      key: 'bulk-payments',
      text: BULK_PAYMENTS,
    },
    {
      key: 'plans',
      text: PLANS,
    },
    {
      key: 'import-mandates',
      text: IMPORT_MANDATES,
    },
    {
      key: 'test-webhook',
      text: TEST_WEBHOOK,
    },
  ],
  [VBA_CONFIGURATION]: [
    { key: 'accounts', text: 'Accounts Created' },
    { key: 'notification-groups', text: 'Notification Groups' },
  ],
  // [DEVELOPERS]: [
  //   {
  //     key: 'api-keys',
  //     text: API_KEYS,
  //   },
  //   {
  //     key: 'service-alerts',
  //     text: SERVICE_ALERTS,
  //   },
  //   {
  //     key: 'webhooks',
  //     text: WEBHOOKS,
  //   },
  //   {
  //     key: 'api-logs',
  //     text: API_LOGS,
  //   },
  // ],
  [NOTIFICATIONS]: [
    {
      key: 'merchant-notifications',
      text: MERCHANT_NOTIFICATIONS,
    },
    {
      key: 'customer-notifications',
      text: CUSTOMER_NOTIFICATIONS,
    },
    {
      key: 'communication-preferences',
      text: COMMUNICATION_PREFERENCES,
    },
    {
      key: 'success-rate-alerts',
      text: SUCCESS_RATE_ALERTS,
    },
  ],
  [DISPUTES]: [
    {
      key: 'actionRequired',
      text: 'Action Required',
    },
    {
      key: 'underReview',
      text: 'Under Review',
    },
    {
      key: 'closed',
      text: 'Closed',
    },
    {
      key: 'allDisputes',
      text: 'All Disputes',
    },
  ],
  [PAYMENT_VERIFICATION]: [
    {
      key: 'actionRequired',
      text: 'Action Required',
    },
    {
      key: 'underReview',
      text: 'Under Review',
    },
    {
      key: 'verified',
      text: 'Verified',
    },
    {
      key: 'expired',
      text: 'Expired',
    },
    {
      key: 'all',
      text: 'All',
    },
  ],
  [SHIPPING_DELIVERY]: [
    {
      key: 'cashfree-standard-shipping',
      text: 'Standard Shipping',
    },
    {
      key: 'cashfree-express-shipping',
      text: 'Express Shipping',
    },
  ],
  [BBPS_COU]: [
    { key: 'transactions', text: 'Transactions' },
    { key: 'wallet', text: 'Wallet & Funds' },
  ],
};

export const NAVIGATION_BAR_OPTIONS_V2 = {
  [PAYMENTS]: [
    {
      key: 'all',
      text: ALL_PAYMENTS,
    },
    {
      key: 'refunds',
      text: REFUNDS,
    },
    {
      key: 'disputes',
      text: DISPUTES,
    },
    {
      key: 'flagged',
      text: FLAGGED,
    },
  ],
  Analytics: [
    {
      key: 'business-trends',
      text: 'Business Trends',
    },
    {
      key: 'conversion-rate',
      text: 'Conversion Rate',
    },
  ],
  [REFUNDS]: [
    {
      key: 'initiated-refunds',
      text: INITIATED_REFUNDS,
    },
    {
      key: 'auto-refunds',
      text: AUTO_REFUNDS,
    },
  ],
  'Easy-Split Settlements': [
    {
      key: 'scheduled',
      text: 'Scheduled',
    },
    {
      key: 'on-demand',
      text: 'On-Demand',
    },
  ],
  [TRANSACTIONS]: [
    {
      key: 'payments',
      text: PAYMENTS,
    },
    {
      key: 'orders',
      text: ORDERS,
    },
    {
      key: 'refunds',
      text: REFUNDS,
    },
    {
      key: 'disputes',
      text: DISPUTES,
    },
    {
      key: 'suspicious',
      text: SUSPICIOUS,
    },
    {
      key: 'batch-refunds',
      text: 'Batch Refunds',
    },
    {
      key: 'initiated-refunds',
      text: 'Initiated Refunds',
    },
    {
      key: 'auto-refunds',
      text: 'Auto Refunds',
    },
    {
      key: 'actionRequired',
      text: 'Action Required',
    },
    {
      key: 'underReview',
      text: 'Under Review',
    },
    {
      key: 'closed',
      text: 'Closed',
    },
    {
      key: 'allDisputes',
      text: 'All Disputes',
    },
    {
      key: 'all',
      text: ALL,
    },
    {
      key: 'batch-capture',
      text: 'Batch Capture',
    },
  ],
  [PAYMENT_LINKS]: [
    {
      key: 'all',
      text: ALL,
    },
    {
      key: 'batch',
      text: BATCH,
    },
    {
      key: 'orders',
      text: ORDERS,
    },
  ],
  [CUSTOMERS]: [
    {
      key: 'active',
      text: CUSTOMER_ACTIVE,
    },
    {
      key: 'unfulfilled',
      text: CUSTOMER_UNFULFILLED,
    },
  ],
  [PAYMENT_FORMS]: [
    {
      key: 'all',
      text: ALL,
    },
    {
      key: 'orders',
      text: ORDERS,
    },
  ],
  [PAYMENT_LINKS_V1]: [
    {
      key: 'all',
      text: ALL,
    },
    {
      key: 'batch',
      text: BATCH,
    },
  ],
  [EASY_SPLIT]: [
    {
      key: 'vendors',
      text: VENDORS,
    },
    {
      key: 'transactions',
      text: 'Transactions',
    },
    {
      key: 'refunds',
      text: REFUNDS,
    },
    {
      key: 'settlements',
      text: 'Settlements',
    },
    {
      key: 'adjustments',
      text: ADJUSTMENTS,
    },
    {
      key: 'scheduled',
      text: 'Scheduled',
    },
    {
      key: 'on-demand',
      text: 'On-Demand',
    },
  ],
  [SETTLEMENTS]: [
    {
      key: 'standard',
      text: STANDARD,
    },
    {
      key: 'on-demand',
      text: ON_DEMAND,
    },
    {
      key: 'vendor',
      text: VENDOR,
    },
    // {
    //   key: 'instant',
    //   text: INSTANT,
    // },
  ],
  [PRODUCT_LINKS]: [],
  [PRODUCT_DESCRIPTION]: [],
  [REPORTS]: [
    {
      key: 'download',
      text: DOWNLOAD_REPORT,
    },
    {
      key: 'schedule',
      text: SCHEDULE_REPORT,
    },
  ],
  [ROUTER]: [
    {
      key: 'gateways',
      text: GATEWAYS,
    },
    {
      key: 'configure',
      text: GATEWAYS_CONFIGURATION,
    },
    {
      key: 'upfront-tdr',
      text: UPFRONT_TDR,
    },
  ],
  [SOFTPOS]: [
    {
      key: 'collection-point-management',
      text: COLLECTION_POINT_MANAGEMENT,
    },
    {
      key: 'payment-methods',
      text: PAYMENT_METHODS,
    },
    {
      key: 'all-collection-points',
      text: ALL_COLLECTION_POINTS,
    },
    {
      key: 'batch',
      text: BATCH_AGENTS,
    },
  ],
  [COLLECTION_POINT_MANAGEMENT]: [
    {
      key: 'all-collection-points',
      text: ALL_COLLECTION_POINTS,
    },
    {
      key: 'batch',
      text: BATCH_AGENTS,
    },
  ],
  [SUBSCRIPTIONS]: [
    {
      key: 'all-subscriptions',
      text: ALL_SUBSCRIPTIONS,
    },
    {
      key: 'bulk-create-subscriptions',
      text: BULK_CREATE_SUBSCRIPTIONS,
    },
    {
      key: 'transactions',
      text: PAYMENTS,
    },
    {
      key: 'bulk-payments',
      text: BULK_PAYMENTS,
    },
    {
      key: 'plans',
      text: PLANS,
    },
    {
      key: 'import-mandates',
      text: IMPORT_MANDATES,
    },
    {
      key: 'test-webhook',
      text: TEST_WEBHOOK,
    },
  ],
  [VBA_CONFIGURATION]: [
    { key: 'accounts', text: 'Accounts Created' },
    { key: 'notification-groups', text: 'Notification Groups' },
  ],
  // [DEVELOPERS]: [
  //   {
  //     key: 'api-keys',
  //     text: API_KEYS,
  //   },
  //   {
  //     key: 'service-alerts',
  //     text: SERVICE_ALERTS,
  //   },
  //   {
  //     key: 'webhooks',
  //     text: WEBHOOKS,
  //   },
  //   {
  //     key: 'api-logs',
  //     text: API_LOGS,
  //   },
  // ],
  [NOTIFICATIONS]: [
    {
      key: 'merchant-notifications',
      text: MERCHANT_NOTIFICATIONS,
    },
    {
      key: 'customer-notifications',
      text: CUSTOMER_NOTIFICATIONS,
    },
    {
      key: 'communication-preferences',
      text: COMMUNICATION_PREFERENCES,
    },
    {
      key: 'success-rate-alerts',
      text: SUCCESS_RATE_ALERTS,
    },
  ],
  [DISPUTES]: [
    {
      key: 'actionRequired',
      text: 'Action Required',
    },
    {
      key: 'underReview',
      text: 'Under Review',
    },
    {
      key: 'closed',
      text: 'Closed',
    },
    {
      key: 'allDisputes',
      text: 'All Disputes',
    },
  ],
  [PAYMENT_VERIFICATION]: [
    {
      key: 'actionRequired',
      text: 'Action Required',
    },
    {
      key: 'underReview',
      text: 'Under Review',
    },
    {
      key: 'verified',
      text: 'Verified',
    },
    {
      key: 'expired',
      text: 'Expired',
    },
    {
      key: 'all',
      text: 'All',
    },
  ],
  [SHIPPING_DELIVERY]: [
    {
      key: 'cashfree-standard-shipping',
      text: 'Standard Shipping',
    },
    {
      key: 'cashfree-express-shipping',
      text: 'Express Shipping',
    },
  ],
};

export const ONE_MB_VALUE = 1048576;

export const DEFAULT_LIMIT_OPTIONS = [
  { key: '0', value: '10', text: '10' },
  { key: '1', value: '25', text: '25' },
  { key: '2', value: '50', text: '50' },
];
export const DATE_FILTER_RANGE_SIZE = 31;
export const DATE_FILTER_YEARLY_RANGE_SIZE = 366;

export const TRANSACTION_STATUS_CHECKBOX_OPTIONS = {
  Success: 'SUCCESS',
  Failed: 'FAILED',
  Dropped: 'USER_DROPPED',
  Incomplete: 'INCOMPLETE',
  Flagged: 'FLAGGED',
  Cancelled: 'CANCELLED',
  Void: 'VOID',
  Pending: 'PENDING',
};

export const SBC_PAYMENTS_STATUS_CHECKBOX_OPTIONS = {
  Success: 'SUCCESS',
  SBCPaymentsInitialized: 'SBC_PAYMENT_INITIALIZED',
  SBCPaymentsCancelled: 'SBC_PAYMENT_CANCELLED',
  Failed: 'FAILED',
  Pending: 'PENDING',
};
export const SBC_STATUS_CHECKBOX_OPTIONS = {
  Initialized: 'INITIALIZED',
  'Bank Approval Pending': 'BANK_APPROVAL_PENDING',
  Active: 'ACTIVE',
  Cancelled: 'CANCELLED',
  'On Hold': 'ON_HOLD',
};

export const HOLD = 'HOLD';

export const DEFAULT_SECURITY_HEADERS = {
  'X-XSS-Protection': '1; mode=block',
  'X-Frame-Options': 'DENY',
  'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
};

export const PLACEHOLDER_TEXT = '--';

export const FRESHSALES_TRACKING_METRICS_PARAMS = {
  referrer: '',
  refCode: '',
  action: '',
  'button-id': '',
  'source-action': '',
};

export const REFUND_DISABLED_PAYMENT_METHODS = ['PAYPAL', 'PAYTM'];

// add the video embeds as per the activeNavigation / Menu selected
export const VIDEO_EMBEDS = {
  [PAYMENT_METHODS]: [
    {
      title: 'Learn how the Settings help',
      url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=729&end=751',
    },
  ],
  [MERCHANT_NOTIFICATIONS]: [
    {
      title: 'Learn how the Settings help',
      url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=751&end=768',
    },
  ],
  [CUSTOMER_NOTIFICATIONS]: [
    {
      title: 'Learn how the Settings help',
      url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=751&end=768',
    },
  ],
  [SETTLEMENT_BANK_DETAILS]: [
    {
      title: 'Learn how the Settings help',
      url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=768&end=776',
    },
  ],
  [SOFTPOS]: [
    {
      title: 'How to use softPOS',
      url: 'https://www.youtube.com/embed/yjkmXD4rAEo',
    },
    {
      title: 'How to use Agent App',
      url: 'https://www.youtube.com/embed/UJmbC2z1VR0',
    },
  ],
  [DEVELOPERS]: [
    {
      title: 'How does the Developers tab work?',
      url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=706&end=728',
    },
  ],
  [SERVICE_ALERTS]: [
    {
      title: 'How does the Developers tab work?',
      url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=706&end=728',
    },
  ],
  [SUMMARY]: [
    {
      title: 'Learn how the Summary helps',
      url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=0&end=810',
    },
  ],
  [TRANSACTIONS]: {
    [ALL]: [
      {
        title: 'How to check Transaction Details?',
        url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=172&end=230',
      },
    ],
    [INITIATED_REFUNDS]: [
      {
        title: 'How to check the Refund status?',
        url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=231&end=260',
      },
    ],
    [BATCH_REFUNDS]: [
      {
        title: 'How to initiate Batch Refunds?',
        url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=261&end=304',
      },
    ],
    [DISPUTES]: [
      {
        title: 'Learn more about Disputes here',
        url: 'https://www.cashfree.com/docs/payments/manage/disputes/overview',
      },
    ],
    [SUSPICIOUS]: [
      {
        title: 'What is a Suspicious transaction?',
        url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=377&end=401',
      },
    ],
    [BATCH_CAPTURE]: [
      {
        title: 'Learn how the Batch Capture works',
        url: 'https://www.youtube.com/embed/7AXaPiK8BZc?start=668&end=689',
      },
    ],
  },
  [PAYMENT_LINKS]: {
    [ALL]: [
      {
        title: 'Learn to create Payment Links',
        url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=560&end=618',
      },
    ],
  },
  [EASY_SPLIT]: [
    {
      title: 'Simple Easy Split Integration',
      url: 'https://www.youtube.com/embed/_Vde5QDJwg8',
    },
  ],
  [SETTLEMENTS]: {
    [STANDARD]: [
      {
        title: 'Learn to check the Settlements status',
        url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=402&end=458',
      },
    ],
    [INSTANT]: [
      {
        title: 'What is Instant Settlements?',
        url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=459&end=488',
      },
    ],
    [VENDOR]: [
      {
        title: 'How do Vendor Settlements help?',
        url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=489&end=513',
      },
    ],
  },
  [PRODUCT_LINKS]: [
    {
      title: 'How to create Product Links?',
      url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=619&end=662',
    },
  ],
  [SUBSCRIPTIONS]: [
    {
      title: 'Learn how the Subscriptions works',
      url: 'https://www.youtube.com/embed/63-lKFYiJmY?start=10',
    },
  ],
  // commenting for now - will make this live when we have updated knowledge video
  // [REPORTS]: [
  //   {
  //     title: 'How to download a Report?',
  //     url: 'https://www.youtube.com/embed/ECwGBJmEy5E?start=663&end=705',
  //   },
  // ],
};

export const DATE_AND_TIME_FORMAT = 'DD MMM YYYY, hh:mm A';

export const SUCCESS = 'SUCCESS';

export const PENDING = 'PENDING';

export const CANCELLED = 'CANCELLED';

export const NOT_REFUNDED = 'NOT_REFUNDED';

export const PARTIAL_REFUND = 'PARTIAL_REFUND';

export const PROCESSED = 'PROCESSED';

export const REFUNDED = 'REFUNDED';

export const CLOSED = 'CLOSED';

export const VOID = 'VOID';

export const MANUAL_REVIEW = 'MANUAL_REVIEW';

const RECHARGE_ALERT = {
  key: 'rechargeAlert',
  localStorageKey: 'hideRechargeAlertBar',
  buttonText: 'View Bank Details',
  clss: 'align-center',
};

const HOLIDAYS_ALERT = {
  key: 'holidaysAlert',
  localStorageKey: 'hideHolidaysAlertBar',
  clss: 'align-center',
};

export const ANNOUNCEMENT_STRIP_DATA = {
  [SUMMARY]: {
    RECHARGE_ALERT,
    HOLIDAYS_ALERT,
    // GST_SURVEY_ALERT: {
    //   key: 'gstSurveyAlert',
    //   localStorageKey: 'hideGSTFormSurveyAlertBar',
    //   markup:
    //     'Are you looking for a GST-compliant invoicing solution? Take this survey to help us understand your needs.',
    //   buttonText: 'Take Survey',
    // },
    HOLI_OFFER_ALERT: {
      key: 'holiOfferAlert',
      localStorageKey: 'hideHoliOfferAlert',
      markup:
        'Exclusive Holi Offer: Give up to ₹150 cashback to your customers with MobiKwik Wallet.',
      buttonText: 'Know More',
      expiry: moment('2022-03-31')
        .endOf('day')
        .format('X'),
    },
    // ON_DEMAND_SETTLEMENTS_ALERT: {
    //   key: 'onDemandSettlementsAlert',
    //   localStorageKey: 'hideOnDemandSettlementsAlert',
    //   markup:
    //     '[Introducing] On-Demand Settlements - Want to receive your funds 24*7, including holidays? Explore our on-demand settlement solution.',
    //   buttonText: 'Activate Now',
    //   // to be added later when the markup and buttonText will be updated
    //   // expiry: moment('2022-02-09')
    //   //   .endOf('day')
    //   //   .format('X'),
    // },
    SOFT_POS_ALERT: {
      key: 'softPOSAlert',
      localStorageKey: 'hideSoftPOSAlertBar',
      markup:
        '[Introducing] soft POS App - Now turn your android phone into an ePOS machine',
      buttonText: 'Activate Now',
      expiry: moment('2022-02-09')
        .endOf('day')
        .format('X'),
    },
    // ADVANCES_ALERT: {
    //   key: 'advancesAlert',
    //   localStorageKey: 'hideAdvancesAlertBar',
    //   markup:
    //     'Grow your business with Advances - Affordable Collateral-free Loans by Cashfree Payments!',
    //   buttonText: 'Avail Now',
    // },
    // TOKEN_VAULT_ALERT: {
    //   key: 'tokenVaultAlert',
    //   clss: 'tokenVaultAlert',
    //   localStorageKey: 'hideTokenVaultAlertBar',
    //   markup:
    //     '{Stay RBI compliant} Process card payments securely by integrating with our card tokenisation solution before September 30, 2022.',
    //   buttonText: 'Start now',
    //   expiry: moment('2022-09-30')
    //     .endOf('day')
    //     .format('X'),
    // },
  },
  [REFUNDS]: {
    [INITIATED_REFUNDS]: {
      RECHARGE_ALERT,
    },
  },
  [SETTLEMENTS]: {
    HOLIDAYS_ALERT,
  },
};

export const PG_TRANSACTIONS_PATH = 'transactions';

export const PG_WEBHOOKS_PATH = 'developers/webhooks';

export const PG_DEVELOPERS_API_METRICS_PATH = 'developers/api-metrics';

export const PG_SETTINGS_NOTIFICATIONS = 'pg/settings/notifications';

export const TRACK_EVENT = 'TRACK_EVENT';

export const CF_API_VERSION = '2021-09-21';

export const MERCHANT_DASHBOARD_GPLAY_URL =
  'https://play.google.com/store/apps/details?id=com.cashfree.merchant';

export const MERCHANT_DASHBOARD_APPLE_APP_URL =
  'https://apps.apple.com/in/app/cashfree-payments-business-app/id1658841415';

export const MERCHANT_DASHBOARD_MOBILE_APP_URL =
  'https://cashfree.app.link/app';

export const HELP_CENTER_URL =
  'https://cashfreepayments.freshworks.com/login/auth/1682654995546?client_id=451979510707337272&redirect_uri=https://cashfreepayments.freshdesk.com/freshid/customer_authorize_callback?hd=cashfreepayments.freshdesk.com';

export const ANDROID = 'Android';

export const IOS = 'iOS';

export const SIGNUP_SOURCE = 'signup';

export const UTM_PARAMS = {
  utm_source: 'UTM_Source__c',
  utm_medium: 'UTM_Medium__c',
  utm_campaign: 'UTM_Campaign__c',
  utm_term: 'UTM_Term__c',
  utm_content: 'UTM_Content__c',
  gclid: 'cf_gclid',
  fbclid: 'cf_fbclid',
};

export const UTM_CAMPAIGN_URL = '__gtm_campaign_url';

export const SEARCH_EASY_SPLIT_VENDOR_ALL_URL = {
  url: '/pg/settlements/split/vendors/search',
  method: 'GET',
};

export const CF_TNC_URL = 'https://www.cashfree.com/tnc';
export const CF_HELP_URL = 'https://www.cashfree.com/docs/help/overview';
export const CF_FAQ_URL =
  'https://www.cashfree.com/help/questions/getting-started/account-activation';
export const CF_SUPPORT_URL = 'https://www.cashfree.com/en/report-issue/';

export const DEFAULT_CHARACTERS_CLASS = {
  character: 'text-dark',
  alphabet: 'text-dark',
  number: 'text-dark',
  symbol: 'text-dark',
};

export const ONBOARDING_ROUTES = [
  'signup',
  'forgot-password',
  'reset-password',
];

export const EMAIL_LOGIN = 'Email ID';
export const ALIAS_LOGIN = 'Account Alias';

export const PGDB_SHOW_PRODUCT_LINKS = 'pgdb_show_product_links';

export const PGDB_LOCK_SETTLEMENT_ACCOUNT = 'LOCK_SETTLEMENT_ACCOUNT';

export const PGDB_HIDE_REFUNDS_TAB = 'pgdb_hide_refunds_tab';
export const PGDB_SHOW_WORKFLOWS = 'PGDB_SHOW_WORKFLOWS';

export const PGDB_HIDE_RISKSHIELD_MODAL_ON_DISPUTES =
  'pgdb_hide_riskshield_modal_on_disputes';

export const PGDB_SHOW_SLACK = 'pgdb_slack';

export const LINKS_BATCH_UPLOAD = 'pgdb_show_payment_links_batch_upload';
export const LINK_BATCH_UPLOAD_WHATSAPP_NOTIFY =
  'pgdb_show_payment_links_batch_upload_whatsapp_notify';

export const PGDB_SHOW_SCHEDULE_REPORT = 'pgdb_show_schedule_report';

export const PGDB_NEED_PCI = 'pgdb_need_pci';
export const NEW_ONBOARDING_FLOW = 'ob_new_flow_minmax';

export const VENDOR_DASHBOARD_TOGGLE = 'vendorDashboardToggle';

export const PGDB_SHOW_OFFERS = 'pgdb_show_offers';

export const PGDB_SHOW_QUICK_CREATE = 'pgdb_show_quick_create';

export const DASHBOARD_NOTIFICATION = 'dashboard_notification';

export const PGDB_SHOW_SR_CHART = 'pgdb_show_sr_chart';
export const ENABLE_HELP_CENTRE = 'enable_help_centre';

export const ENABLE_SHELL_V2 = 'enable_shell_v2';

export const ENABLE_QUICK_LINKS = 'pgdb_show_quick_links';

export const ENABLE_SCHEDULED_REPORTS_V2 = 'pdgb_scheduled_reports_v2';

export const VENDOR_ONBOARDING_V2_BLACKLIST = 'VENDOR_ONBOARDING_V2_BLACKLIST';

export const PG_RISK_SHIELD = 'PG_RISK_SHIELD';

export const PGDB_SHOW_UPFRONT_TDR = 'pgdb_show_upfront_tdr';

export const PGDB_SHOW_ANALYTICS_V2 = 'pgdb_show_analytics_v2';

export const ROUTER_TTL_AUTOREFUND = 'router_ttl_autorefund';

export const PGDB_SHOW_INSTANT_REFUNDS = 'pgdb_show_instant_refunds';

export const PGDB_SHOW_FLOWWISE_SETTLEMENT_RECON = 'flowwise_settlement_recon';

export const PGDB_SHOW_FLOWWISE_CONFIGURATIONS_V2 =
  'pgdb_show_flowwise_configuration_v2';

export const SELF_SERVE_SR_ALERTS = 'SELF_SERVE_SR_ALERTS';

export const PGDB_SHOW_REFUNDS_V2 = 'pgdb_show_refunds_v2';

// Shared with blue-green deployment
export const BLUE_GREEN_TEST_MERCHANT = 'BLUE_GREEN_TEST_MERCHANT';

export const SHOW_APPLE_PAY_PAYMENT_METHOD = 'SHOW_APPLE_PAY_PAYMENT_METHOD';

export const PGDB_SHOW_SAVE_FILTERS = 'pgdb_show_save_filters';

export const PGDB_SHOW_UPFRONT_TDR_SLABS = 'pgdb_show_upfront_tdr_slabs';

export const PGDB_ENABLE_UPFRONT_TDR_SLABS_FOR_ALL =
  'pgdb_enable_upfront_tdr_slabs_for_all';

export const PGDB_SHOW_PAYPAL_FOREX_MARKUP = 'pgdb_show_paypal_forex_markup';

export const PGDB_SHOW_DISPUTES_WALLET = 'pgdb_show_disputes_wallet';

export const PGDB_SHOW_PAYMENT_FAILURE = 'pgdb_show_payment_failure';

export const PGDB_SHOW_SUBS = 'pgdb_show_subs';

export const PGDB_SHOW_INSIGHTS_AI = 'pgdb_show_insights_ai';

export const PGDB_SHOW_ROUTER_GATEWAYS_V2 = 'pgdb_show_router_gateways_v2';

export const PGDB_SHOW_INTERCOM_CHATBOT = 'pgdb_show_intercom_chatbot';

export const PGDB_SHOW_INSIGHTS_AI_POPUP = 'pgdb_show_insights_ai_popup';

export const PGDB_SHOW_GMV_BASED_CONFIG = 'pgdb_show_gmv_based_config';

export const PF_INTELLI_FORM_ANALYTICS = 'update_subscriber_status';

export const PRODUCT_FRUIT_INTEGRATION = 'PRODUCT_FRUIT_INTEGRATION';

export const DAY_ZERO_SHOPIFY_MODAL = 'DAY_ZERO_SHOPIFY_MODAL';
export const DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION =
  'DAY_ZERO_SHOPIFY_PROFILE_ACTIVATION';

export const DAY_ZERO_CHECKOUT_JOURNEY = 'DAY_ZERO_CHECKOUT_JOURNEY';

export const NEW_COMMS_PREFERENCE = 'COMMS_PREFERENCE';
export const CARE_TICKET_DASHBOARD = 'CARE_TICKET_DASHBOARD';

export const DASHBOARD_EMBEDDABLE_COMPONENTS =
  'dashboard_embeddable_components';

export const VBA_V2_ACTIVATED = 'VBA_V2_ACTIVATED';

export const SHOW_SR_DASHBOARD = 'show_sr_dashboard';
export const SEND_BIRD_BOT = 'SEND_BIRD_BOT';
export const NPS_SURVEY = 'NPS_SURVEY';
export const ONBOARDING_SURVEY = 'ONBOARDING_SURVEY';
export const SURVEY_COHORT_IDS = 'SURVEY_COHORT_IDS';
export const IS_OB_NPS_SURVEY_ENABLED = 'IS_OB_NPS_SURVEY_ENABLED';
export const FEATURE_REQUESTS_AND_ROADMAP = 'FEATURE_REQUESTS_AND_ROADMAP';
export const SUBS_POPUP_DISMISSED_KEY = 'subs_new_home_popup_dismissed';

export const SHOW_TEST_AI_CHAT = 'SHOW_TEST_AI_CHAT';
export const OCC_SHIPPING_AND_DELIVERY = 'OCC_SHIPPING_AND_DELIVERY';

export const YELLOW_CHAT_BOT = 'YELLOW_CHAT_BOT';
export const ONE_OF_A_KIND_CAMPAIGN = 'oneofakind';
export const DB_CUSTOM_CAMPAIGN = 'DB_CUSTOM_CAMPAIGN';
export const SENTRY_MUTED_API_ENDPOINTS = 'SENTRY_MUTED_API_ENDPOINTS';
export const SHOW_PREV_FINANCIAL_YEAR = 'show_prev_financial_year';
export const OFFER_LISTING_V2 = 'OFFER_LISTING_V2';
export const GET_VALID_OFFERS_V2 = 'GET_VALID_OFFERS_V2';
export const OFFERS_REVAMP = 'OFFERS_REVAMP';
export const OFFERS_V2_FOR_PG = 'OFFERS_V2_FOR_PG';
export const MERCHANTDB_CASHFIRE = 'MERCHANTDB_AI_CAIA';
export const BOTPRESS_TEST_COMPONENTS = 'Botpress_test_components';
export const SHOW_CUSTOM_BOTPRESS_CHATBOT = 'SHOW_CUSTOM_BOTPRESS_CHATBOT';

export const IS_TRANSACTION_CURRENCY_ENABLED = 'isTransactionCurrencyEnabled';

export const SHOW_WORKFLOW_BUILDER = 'SHOW_WORKFLOW_BUILDER';

export const SHOW_ENABLE_STANDARD_CLIENT_EVENTS =
  'pgdb_show_enable_standard_client_events';

export const FEATURE_TOGGLE_CONFIG = [
  SHOW_PREV_FINANCIAL_YEAR,
  PGDB_SHOW_PRODUCT_LINKS,
  PGDB_HIDE_REFUNDS_TAB,
  PGDB_SHOW_SLACK,
  LINKS_BATCH_UPLOAD,
  LINK_BATCH_UPLOAD_WHATSAPP_NOTIFY,
  NEW_ONBOARDING_FLOW,
  PGDB_SHOW_SCHEDULE_REPORT,
  PGDB_NEED_PCI,
  VENDOR_DASHBOARD_TOGGLE,
  DASHBOARD_NOTIFICATION,
  PGDB_SHOW_SR_CHART,
  ENABLE_HELP_CENTRE,
  ENABLE_SHELL_V2,
  PG_RISK_SHIELD,
  VENDOR_ONBOARDING_V2_BLACKLIST,
  PGDB_SHOW_UPFRONT_TDR,
  PGDB_SHOW_ANALYTICS_V2,
  PGDB_SHOW_INSTANT_REFUNDS,
  PGDB_SHOW_FLOWWISE_SETTLEMENT_RECON,
  PGDB_SHOW_FLOWWISE_CONFIGURATIONS_V2,
  SELF_SERVE_SR_ALERTS,
  PG_RISK_SHIELD,
  PGDB_SHOW_REFUNDS_V2,
  BLUE_GREEN_TEST_MERCHANT,
  SHOW_APPLE_PAY_PAYMENT_METHOD,
  PGDB_SHOW_QUICK_CREATE,
  ROUTER_TTL_AUTOREFUND,
  PGDB_SHOW_SAVE_FILTERS,
  PGDB_SHOW_UPFRONT_TDR_SLABS,
  NEW_COMMS_PREFERENCE,
  PGDB_SHOW_PAYPAL_FOREX_MARKUP,
  ENABLE_QUICK_LINKS,
  ENABLE_SCHEDULED_REPORTS_V2,
  PGDB_SHOW_DISPUTES_WALLET,
  PGDB_SHOW_PAYMENT_FAILURE,
  PGDB_SHOW_INSIGHTS_AI,
  DASHBOARD_EMBEDDABLE_COMPONENTS,
  CARE_TICKET_DASHBOARD,
  PGDB_LOCK_SETTLEMENT_ACCOUNT,
  PGDB_SHOW_ROUTER_GATEWAYS_V2,
  PGDB_SHOW_INTERCOM_CHATBOT,
  PGDB_SHOW_INSIGHTS_AI_POPUP,
  PRODUCT_FRUIT_INTEGRATION,
  PGDB_ENABLE_UPFRONT_TDR_SLABS_FOR_ALL,
  PGDB_SHOW_GMV_BASED_CONFIG,
  DAY_ZERO_SHOPIFY_MODAL,
  SHOW_SR_DASHBOARD,
  SEND_BIRD_BOT,
  NPS_SURVEY,
  ONBOARDING_SURVEY,
  SURVEY_COHORT_IDS,
  IS_OB_NPS_SURVEY_ENABLED,
  FEATURE_REQUESTS_AND_ROADMAP,
  SHOW_TEST_AI_CHAT,
  PGDB_HIDE_RISKSHIELD_MODAL_ON_DISPUTES,
  OCC_SHIPPING_AND_DELIVERY,
  YELLOW_CHAT_BOT,
  ONE_OF_A_KIND_CAMPAIGN,
  DB_CUSTOM_CAMPAIGN,
  SENTRY_MUTED_API_ENDPOINTS,
  PGDB_SHOW_WORKFLOWS,
  OFFER_LISTING_V2,
  GET_VALID_OFFERS_V2,
  OFFERS_REVAMP,
  OFFERS_V2_FOR_PG,
  MERCHANTDB_CASHFIRE,
  BOTPRESS_TEST_COMPONENTS,
  SHOW_CUSTOM_BOTPRESS_CHATBOT,
  PF_INTELLI_FORM_ANALYTICS,
  IS_TRANSACTION_CURRENCY_ENABLED,
  VBA_V2_ACTIVATED,
  PGDB_SHOW_SUBS,
  SHOW_WORKFLOW_BUILDER,
  SHOW_ENABLE_STANDARD_CLIENT_EVENTS,
  ENABLE_AOV_MX,
];

export const LINE_GRAPH_COLORS = [
  '#265AE0',
  '#FF0000',
  '#00FF00',
  '#FFC0CB',
  '#FF8A33',
  '#E633FF',
  '#979191',
  '#444444',
  '#2371EA',
  '#9F23EA',
];

export const DISCOUNT = 'DISCOUNT';
export const CASHBACK = 'CASHBACK';
export const DISCOUNT_AND_CASHBACK = 'DISCOUNT_AND_CASHBACK';
export const NO_COST_EMI = 'NO_COST_EMI';

export const WALLET = 'WALLET';
export const CARD = 'CARD';
export const NET_BANKING = 'NET_BANKING';
export const PAY_LATER = 'PAY_LATER';
export const EMI = 'EMI';
export const CASH = 'CASH';

export const FLAT = 'FLAT';
export const PERCENTAGE = 'PERCENTAGE';
export const REMINDER_MESSAGE = 'REMINDER_MESSAGE';

export const NUDGE_BUTTON_ID = {
  START_FREE_TRIAL: 'START_FREE_TRIAL',
  REQUEST_ACTIVATION: 'REQUEST_ACTIVATION',
  EXTEND_NOW: 'EXTEND_NOW', // only on OD Screen
  WITHDRAW_FOR_FREE: 'WITHDRAW_FOR_FREE',
  WITHDRAW_NOW: 'WITHDRAW_NOW',
};

export const ON_DEMAND_FREE_TRIAL_ELIGIBLE = 'ELIGIBLE';

export const ON_DEMAND_FREE_TRIAL_ACTIVE_STATUS = 'ACTIVE';

export const OFFERS_REDEMPTION_OPTIONS = {
  Success: 'SUCCESS',
  Failed: 'FAILED',
};

export const ON_DEMAND_SETTLEMENT_STATUS_MAPPER = {
  ACTIVE: 'ACTIVE',
  IN_REVIEW: 'IN_REVIEW',
  REJECTED: 'REJECTED',
  DISABLED: 'DISABLED',
  RISK_APPROVED: 'IN_REVIEW',
  FINANCE_APPROVED: 'IN_REVIEW',
};

export const PRODUCT_MAPPING = {
  PG: 'Payment Gateway',
  PO: 'Payouts',
};

export const REDEEM_VOUCHER_MODAL = 'REDEEM_VOUCHER_MODAL';
export const VOUCHER_SUCCESS = 'VOUCHER_SUCCESS';

export const MAX_FILE_SIZE_ALLOWED = 20;

export const PREFERENCES_URL = 'pg/settings/preferences';
export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';
export const UNFULFILLED = 'UNFULFILLED';

export const INSTANT_REFUNDS_URL =
  'https://www.cashfree.com/docs/payments/manage/refunds/instant-refunds';

export const TIME_FORMATS = {
  FULL_DATE_WITH_TIME_TO_SECONDS: 'YYYY-DD-MM HH:MM:SS',
  FULL_DATE_WITH_TIME_TO_SECONDS_YYYY_MM_DD: 'YYYY-MM-DD HH:mm:ss',
  DATE_MONTH_WITH_TIME: 'Do MMM, hh:mm A',
  DATE_MONTH_YEAR_WITH_TIME: 'DD MMM YYYY, hh:mm A',
  DATE_MONTH_YEAR: 'DD/MMM/YYYY',
  FULL_TIME: 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)',
  Do_MMM_YYYY_HH_mm: 'Do MMM YYYY HH:mm',
  DD_MMM_YYYY: 'DD MMM YYYY',
  hh_mm_A: 'hh:mm A',
  Do_MMMM_YYYY: 'Do MMMM YYYY',
};

export const FAQ_CAMPAIGNS_CHECKLIST_NAME_MAPPING = {
  'checklist3-instance1': 'checklist1-instance2', // web checklist
  'checklist2-instance1': 'checklist1-instance3', // android checklist
  'checklist4-instance1': 'checklist1-instance4', // ios checklist
};

export const USER_PERSONA = 'user_persona';

export const MERCHANT_TRANSACTION_DONE = 'merchant_transaction_done';

export const CUSTOM_MESSAGE = 'Custom Message';

export const INSIGHTS_AI_BANNER = 'insightsAIBanner';

export const INSIGHTS_AI_ALERT = 'insightsAIAlert';

export const INSIGHTS_AI_MODAL = 'insightsAIModal';

export const PAYOUT_PROTECT_MODAL_SHOWN = 'payoutProtectModalShown';

export const INSIGHTS_AI_COACHMARK_CLOSE_COUNT =
  'insights_ai_coachmark_close_count';

export const MAX_PRODUCT_ID_LIMIT = 255;

export const CUSTOM_THANKS_MESSAGE_OPTIONS = [
  {
    value: 'No Message',
    text: 'No Message',
    key: 'No Message',
  },
  {
    value: 'Thank You for your Order!',
    text: 'Thank You for your Order!',
    key: 'Thank You for your Order!',
  },
  {
    value: 'Thank You for your Order! Please check E-Mail for further details!',
    text: 'Thank You for your Order! Please check E-Mail for further details!',
    key: 'Thank You for your Order! Please check E-Mail for further details!',
  },
  {
    value: 'Custom Message',
    text: 'Custom Message',
    key: CUSTOM_MESSAGE,
  },
];

export const NO_MESSAGE = 'No Message';

export const CREATED_ON_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss';

export const DISPUTES_INFO_DOC_LINK =
  'https://www.cashfree.com/docs/payments/manage/disputes/dashboard-actions';
export const PAYMENT_MODES_AMT = [
  'AMT_CASH',
  'AMT_LINK',
  'AMT_TAP',
  'AMT_QR',
  'AMT_CARDLESS_EMI',
];

export const SAMPLE_INVOICE_LINK =
  'https://cashfreelogo.cashfree.com/ass/sample-payment-receipt.pdf';

export const DATE_REGEX_PATTERN = '\\d{4}-\\d{2}-\\d{2}$';

export const DATE_FORMAT = 'YYYY/MM/DD';
export const DATE_MONTH_FORMAT = 'DD MMM YYYY, hh:mm A';

export const TNC = {
  SIGNUP: 'SIGNUP-v1.0.0',
  PRODUCT: 'PRODUCT-v1.0.0',
  SAR: 'SAR-v1.0.0',
  PEP: 'PEP-v1.0.0',
  REKYC: 'Rekyc_policy_agreement-v1.0.0',
  SAQA: 'SAQA-v1.0.0',
};

export const DECLARATION_FILE = 'declarationFile';

export const MAX_CHAR_80G = 200;

export const MAX_PHONE_NUMBER_LENGTH = 10;

export const PRODUCTION = 'production';

export const PRODUCTION_FORM_URL = 'https://payments.cashfree.com/forms/';

export const GAMMA_FORM_URL = 'https://gamma.cashfree.com/forms/';

export const CASHFREE_LOGO =
  'https://cashfreelogo.cashfree.com/assets_images/cfbrand/cf_logo.svg';

export const KNOW_PAYMENT_FORM_CODE_URL =
  'https://www.cashfree.com/docs/payments/no-code/payment-button';

export const PG_SOFTPOS_PATH = 'pg/softpos';

export const PG_SETTLEMENTS_PATH = 'pg/settlements';

export const PG_PAYMENT_LINKS_PATH = 'pg/payment-links';

export const PG_CUSTOMERS_PATH = 'pg/customers';

export const PG_PAYMENT_FORMS_PATH = 'pg/payment-forms';

export const PG_CHECKOUT_CUSTOMISATION_PATH = 'pg/customisation';

export const PAYMENT_FORM = 'PAYMENT_FORM';

export const ONDEMAND = 'OnDemand';

export const EASY_SPLIT_SETTLEMENT = 'Easy-Split Settlements';

export const VENDOR_DETAILS = [VENDOR, SCHEDULED, ON_DEMAND];

export const PL_PF_FIELD_REGEX = /^(?!.*<script>)^[ A-Za-z0-9_@.#&+-{}"')(!$%^=~`|<>?*,.;:₹]*$/;

export const DESCRIPTION_FIELD_REGEX = /^[a-zA-Z0-9\s.,\-_:/()&#@!$%~]+$/;

export const NAME_FIELD_REGEX = /^[a-zA-Z0-9\s._-]+$/;

export const PARTNER = 'partner';
export const UNDERSCORE_REQUIRED = ['refundId'];

export const MINIMUM_SETTELEMENT_AMOUNT = 1;

export const AUDIT_HEADER = 'Audit-Type';

export const TIME_TWO_YEARS_BACK = moment()
  .subtract(2, 'years')
  .toDate();

// Previous Financial Year Start Date (April 1st)
export const PREV_FINANCIAL_YEAR_START_DATE = (() => {
  const today = moment();
  let currentFinancialYearStartYear = today.year();
  if (today.month() < 3 || (today.month() === 3 && today.date() < 1)) {
    currentFinancialYearStartYear -= 1;
  }
  const prevFinancialYearStartYear = currentFinancialYearStartYear - 1;
  return moment(`${prevFinancialYearStartYear}-04-01`).toDate();
})();

export const TIME_ONE_YEARS_BACK = moment()
  .subtract(1, 'years')
  .toDate();

export const EXCLUDED_PAGE_LIST_FOR_MOBILE_APP_PROMOTION_PAGE = [
  'validate/:merchantToken',
  'forgot-password',
  'signup',
];

export const LINK_EXPIRY_OPTIONS = [
  {
    value: 'IN_12_HRS',
    text: '12 hours',
    key: 'IN_12_HRS',
  },
  {
    value: 'IN_1_DAY',
    text: '1 Day',
    key: 'IN_1_DAY',
  },
  {
    value: 'IN_2_DAYS',
    text: '2 Days',
    key: 'IN_2_DAYS',
  },
  {
    value: 'IN_7_DAYS',
    text: '7 Days',
    key: 'IN_7_DAYS',
  },
  {
    value: 'IN_14_DAYS',
    text: '14 Days',
    key: 'IN_14_DAYS',
  },
  {
    value: 'IN_30_DAYS',
    text: '30 Days',
    key: 'IN_30_DAYS',
  },
  {
    value: 'CUSTOM_EXPIRY_TIME',
    text: 'Custom Expiry Time',
    key: 'CUSTOM_EXPIRY_TIME',
  },
];

export const CUSTOM_EXPIRY_TIME = 'CUSTOM_EXPIRY_TIME';

export const ORDER_AMOUNT = 'orderAmount';

export const TOTAL_TRANSACTIONS = 'totalTransactions';

export const TOTAL_SPENDS = 'totalSpends';

export const FILTER_MAPPER = {
  [ORDER_AMOUNT]: {
    start: 'startOrderAmount',
    end: 'endOrderAmount',
    text: 'Amount',
    isRupeeField: true,
  },
  [TOTAL_TRANSACTIONS]: {
    start: 'startTotalTransactions',
    end: 'endTotalTransactions',
    text: 'Transaction',
    isRupeeField: false,
  },
  [TOTAL_SPENDS]: {
    start: 'startTotalSpends',
    end: 'endTotalSpends',
    text: 'Spend',
    isRupeeField: true,
  },
};
export const COPY_TO_CLIPBOARD = 'COPY_TO_CLIPBOARD';

export const GREEN_TICK = 'GREEN_TICK';

export const POPULAR_BANKS = [
  'Axis Bank',
  'HDFC Bank',
  'ICICI Bank',
  'Kotak Mahindra Bank',
  'State Bank Of India',
  'Yes Bank Ltd',
  'Bank Of India',
];

export const WALLET_RECHARGE_ACCOUNT_NAME =
  'Cashfree Payments India Private Limited';

export const user = {
  MERCHANT_OWNER: 'MERCHANT_OWNER',
  MERCHANT_ALIAS: 'MERCHANT_ALIAS',
};

export const USER_NAME = 'User Name';

export const PAGE_FILTERS = 'pageFilters';

export const DEVELOPER_TOOLS_CHILDREN = [
  'api-keys',
  'api-logs',
  'webhooks',
  'api-metrics',
  'rate-limits',
  'whitelisting',
  'integration-usage',
  'checkout-analytics',
];

export const SOURCE_TYPE = {
  DASHBOARD: 'MERCHANT_DASHBOARD',
};

export const TWO_FA_TYPE = {
  G2FA: 'G2FA',
  OTP: 'OTP',
};

export const LOCAL_STORAGE_KEY = {
  CF_EMAIL_EMPTY: 'CF_EMAIL_EMPTY',
};

export const CHART_COLOR_CODES = [
  '#6930ca', // purple
  '#5EDA83', // green
  '#2183CE', // blue
  '#FFD141', // yellow
  '#9E33BB', // purple
  '#20B2AA', // teal
  '#FF4500', // orange-red
  '#4682B4', // steel blue
  '#F5D3D3', // pink
  '#6A5ACD', // slate blue
  '#7FFF00', // chartreuse
  '#C71585', // violet-red
  '#00B7B1', // teal
  '#A52A2A', // brown
  '#87CEEB', // sky blue
  '#800000', // maroon
  '#FFD000', // gold
  '#556B2F', // olive green
  '#8A2BE2', // blue-violet
  '#FA8072', // salmon
  '#006400', // dark green
  '#F0E68C', // khaki
  '#00008B', // dark blue
  '#DC143C', // crimson
  '#A9A9A9', // gray
  '#00FF7B', // neon green
  '#8B4513', // saddle brown
  '#00FFD9', // aqua
  '#3B0087', // indigo
  '#FFD600', // bright yellow
  '#5F9EA0', // cadet blue
  '#FF8C00', // dark orange
  '#DA70D6', // orchid
  '#E6E6FA', // lavender
  '#0000FF', // blue
  '#FF00FF', // magenta
  '#00FF00', // lime
  '#FF0000', // red
  '#FFFF00', // yellow
  '#FF7F50', // coral (extra balance)
  '#708090', // slate gray
  '#A43A00', // earthy orange
  '#1267FF', // vivid blue
  '#6EB200', // grassy green
  '#9E00C4', // violet
  '#FFC0CB', // pink
  '#2F4F4F', // dark slate gray
  '#8B008B', // dark magenta
  '#C6E2FF', // light blue
  '#F18600', // deep orange
  '#AFEEEE', // pale turquoise
  '#9B0300', // deep red
  '#FFF300', // bright yellow
  '#F0FFF0', // honeydew
  '#20FF00', // lime variant
  '#CD5C5C', // indian red
  '#3D006A', // purple variant
  '#00FF98', // mint green
  '#8E3500', // rust brown
  '#9400D3', // dark violet
  '#FFDDA0', // pale yellow
  '#6495ED', // cornflower blue
  '#7A9F29', // green-yellow
  '#9E00FF', // violet extreme
  '#FFEBCD', // blanched almond
  '#00CED1', // dark turquoise
  '#DC143C', // crimson
  '#800080', // purple
  '#00BFFF', // deep sky blue
  '#C0C0C0', // silver
  '#5D4F99', // muted indigo
  '#FFB6C1', // light pink
  '#FFD700', // gold
  '#483D8B', // dark slate blue
  '#ADFF2F', // green-yellow
  '#FF6347', // tomato
  '#9ACD32', // yellow-green
  '#B22222', // firebrick
  '#D2691E', // chocolate
  '#E0FFFF', // light cyan
  '#BDB76B', // dark khaki
  '#4682B4', // steel blue
  '#8B0000', // dark red
  '#7E1300', // burnt red
  '#3AFF00', // neon green
  '#DDA0DD', // plum
  '#708090', // slate gray
  '#A13600', // dark orange-brown
  '#EEDD82', // light goldenrod
  '#C71585', // medium violet-red
  '#FFDEAD', // navajo white
  '#F4A460', // sandy brown
  '#ADD8E6', // light blue
  '#FF1493', // deep pink
  '#00FA9A', // medium spring green
];

export const FLOWWISE_CONFIGURATION_V2_START_DATE = '2024-11-12T00:00:00';

export const LAST_1_HOUR = 'Last 1 hour';

export const LAST_3_HOUR = 'Last 3 hours';

export const LAST_6_HOUR = 'Last 6 hours';

export const TODAY = 'Today';

export const YESTERDAY = 'Yesterday';

export const THIS_WEEK = 'This Week';

export const LAST_WEEK = 'Last Week';

export const THIS_MONTH = 'This Month';

export const LAST_MONTH = 'Last Month';

export const LAST_3_DAYS = 'Last 3 Days';

export const CUSTOM_DATE_RANGE = 'Custom Date Range';

export const DATETIME_TO_REQUEST_PAYLOAD_MAPPER = {
  [LAST_1_HOUR]: {
    timeRange: 5,
    duration: 'MINUTES',
  },
  [LAST_3_HOUR]: {
    timeRange: 15,
    duration: 'MINUTES',
  },
  [LAST_6_HOUR]: {
    timeRange: 1,
    duration: 'HOUR',
  },
  [TODAY]: {
    timeRange: 1,
    duration: 'HOUR',
  },
  [YESTERDAY]: {
    timeRange: 1,
    duration: 'HOUR',
  },
  [LAST_3_DAYS]: {
    timeRange: 3,
    duration: 'HOUR',
  },
  [THIS_WEEK]: {
    timeRange: 1,
    duration: 'DAYS',
  },
  [LAST_WEEK]: {
    timeRange: 1,
    duration: 'DAYS',
  },
  [THIS_MONTH]: {
    timeRange: 1,
    duration: 'DAYS',
  },
  [LAST_MONTH]: {
    timeRange: 1,
    duration: 'DAYS',
  },
  // for Custom Range calculate the timeRange and duration based on the number of days
};

export const DATE_FORMAT_FULL = 'Do MMM hh:mm A';

export const DATE_FORMAT_SHORT = 'Do MMM';

export const CREDIT_CARD = 'CREDIT_CARD';

export const DEBIT_CARD = 'DEBIT_CARD';

export const UPI = 'UPI';

export const PAYMENT_METHOD = 'PAYMENT_METHOD';

export const COLUMNS_FOR_SR_DASHBOARD = [
  {
    accessorKey: 'platform',
    header: 'Platform',
  },
  {
    accessorKey: 'userDecline',
    header: 'User Decline',
  },
  {
    accessorKey: 'bankDecline',
    header: 'Bank Decline',
  },
  {
    accessorKey: 'technicalDecline',
    header: 'Technical Decline',
  },
];

export const GET_DATA_FOR_SR = {
  url: '/router/analytics/transaction',
  method: 'POST',
};

export const SR_CONSTANTS = {
  ALL_PLATFORMS: 'All Platforms',
  All_PSPS: 'All PSPs',
  All_BANKS: 'All Banks',
  All_CARDS: 'All Cards',
  All_UPI_OPTIONS: 'All UPI Options',
  CREDIT_CARD: 'CREDIT_CARD',
  CARD: 'CARD',
  CARD_TYPE: 'CARD_TYPE',
  CARD_BANK_NAME: 'CARD_BANK_NAME',
  DEBIT_CARD: 'DEBIT_CARD',
  PLATFORM: 'PLATFORM',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  NET_BANKING: 'NET_BANKING',
  NET_BANKING_BANK_NAME: 'NET_BANKING_BANK_NAME',
  SR_TAB: 'SR_TAB',
  SUMMARY: 'SUMMARY',
  UPI: 'UPI',
  UPI_PSP: 'UPI_PSP',
  UPI_VALUE: 'UPI_VALUE',
  UPI_CUSTOMER_BANK: 'UPI_CUSTOMER_BANK',
  INTEGRATION_TYPE: 'Integration Types',
  BANKS: 'Banks',
  PSP: 'PSPs',
  UPI_TYPE: 'UPI Type',
  UPI_METHOD: 'UPI Methods',
  SELECTED_TAB: 'selectedTab',
  CARD_PROCESSOR: 'Card Processors',
  TOP_ERROR_REASONS: 'Top Error Reasons',
  HOURS: 'hours',
  DAYS: 'DAYS',
  CARD_NETWORK: 'Card Networks',
};

export const SR_TIME_DATE_CONSTANTS = {
  DISPLAY_DATE_FORMAT: 'Do MMM',
  DISPLAY_TIME_FORMAT: 'HH:mm',
  START_OF_DAY_FORMAT: 'YYYY-MM-DD 00:00:00',
  FULL_DATETIME_FORMAT: 'YYYY-MM-DD HH:mm:ss',
};

export const PAYMENT_MODE_FORMATTED_TEXT = {
  'CREDIT CARD': 'Credit Card',
  'DEBIT CARD': 'Debit Card',
  'WESTPAC BANKING CORPORATION': 'Westpac Banking Corporation',
  visa: 'Visa',
  mastercard: 'Mastercard',
  SBIN: 'State Bank of India',
  PAYTM: 'Paytm',
  'GOOGLE PAY': 'Google Pay',
  UPI_PPI: 'UPI PPI',
  UPI_CREDIT_CARD: 'UPI Credit Card',
  UPI_COLLECT: 'UPI Collect',
  UPI_INTENT: 'UPI Intent',
  UPI_CREDIT_LINE: 'UPI Credit Line',
  'Hdfc Bank': 'HDFC Bank',
  'COMMUNITY FEDERAL SAVINGS BANK': 'Community Federal Savings Bank',
  IOS: 'iOS',
  ALL_CARDS: 'All Cards',
  NET_BANKING: 'Net Banking',
  'STATE BANK OF INDIA': 'State Bank of India',
  'ALL BANKS': 'All Banks',
  CREDIT_CARD: 'Credit Card',
  CREDIT_CARD_EMI: 'Credit Card',
  DEBIT_CARD: 'Debit Card',
  DEBIT_CARD_EMI: 'Debit Card',
  PREPAID_CARD: 'Prepaid Card',
  WALLET: 'Wallet',
  qrcode: 'QR Code',
  link: 'Link',
  rupay: 'RuPay',
  mastero: 'Maestro',
  PHONEPE: 'PhonePe',
  'NET BANKING': 'Net Banking',
  'HDFC BANK': 'HDFC Bank',
  'AXIS BANK': 'Axis Bank',
  'ICICI BANK': 'ICICI Bank',
  'IDFC FIRST BANK': 'IDFC First Bank',
  'BANK OF BARODA - RETAIL BANKING': 'Bank Of Baroda - Retail Banking',
  'PUNJAB NATIONAL BANK - RETAIL BANKING':
    'Punjab National Bank - Retail Banking',
  'BANK OF BARODA': 'Bank of Baroda',
  'UNION BANK OF INDIA': 'Union Bank of India',
  'CANARA BANK': 'Canara Bank',
  'IDBI BANK': 'IDBI Bank',
  'CSB BANK': 'CSB Bank',
  'PUNJAB NATIONAL BANK': 'Punjab National Bank',
};

export const HOURS_TO_SUBTRACT = {
  LAST_1_HOUR: 1,
  LAST_3_HOUR: 3,
  LAST_6_HOUR: 6,
};

export const INITIAL_DATE_FOR_CUSTOM_OPTION = new Date(2024, 8, 1);

export const CUSTOM_BASE_PATH_TYPES = {
  RISKSHIELD_BASE_PATH: 'RISKSHIELD_BASE_PATH',
  SUBSCRIPTIONS_DASHBOARD_BASE_PATH: 'SUBSCRIPTIONS_DASHBOARD_BASE_PATH',
  BBPS_COU_BASE_PATH: 'BBPS_COU_BASE_PATH',
};

export const RISK_SHIELD_OVERVIEW_URL = 'pg/risk-shield/overview';

export const RISK_SHIELD_PRICING_URL = 'pg/risk-shield/pricing';

export const REMIND_LATER_FOR_REFLECT_2025 = 'remind_later_reflect_2025';

export const VIEWED_REFLECT_2025 = 'viewed_reflect_2025';

export const REFLECT_2025_TOKEN = 'reflect_2025_token';

export const OFFER_PAYMENT_MODES = ['ALL', 'PREPAID'];

export const IMPORT_TRANSACTIONS = {
  PAYMENTS: 'PAYMENTS',
  ORDERS: 'ORDERS',
  SUSPICIOUS: 'SUSPICIOUS',
  REFUNDS: 'REFUNDS',
  SETTLEMENTS: 'SETTLEMENTS',
  PAYMENT_VERIFICATION: 'PAYMENT_VERIFICATION',
};

export const DEVICE_TYPES = {
  ANDROID_APP: 'ANDROID_APP',
  IOS_APP: 'IOS_APP',
  ANDROID_WEB: 'ANDROID_WEB',
  IOS_WEB: 'IOS_WEB',
  WEB: 'WEB',
};

export const SAGE_TOUR_KEY = 'sage_tour_remaining';

export const KNOW_MORE_URLS = {
  subscriptionsPage_doc:
    'https://www.cashfree.com/docs/payments/subscription/create',
  batchSubscriptionsPage_doc:
    'https://www.cashfree.com/docs/payments/subscription/create',
  batchPnachPage_doc:
    'https://www.cashfree.com/docs/payments/subscription/create',
  batchAmountsPage_doc:
    'https://www.cashfree.com/docs/payments/subscription/faq#can-i-modify-an-existing-subscription',
  importMandatesPage_doc:
    'https://www.cashfree.com/docs/payments/subscription/import',
  batchPaymentsPage_doc:
    'https://www.cashfree.com/docs/payments/subscription/create',
  batchCancelPaymentsPage_doc:
    'https://www.cashfree.com/docs/payments/subscription/create',
  plansPage_doc:
    'https://www.cashfree.com/docs/payments/subscription/introduction#plans',
  transactionsPage_doc:
    'https://www.cashfree.com/docs/payments/manage/transactions#viewing-transaction-details',
};
